{
  "voice": {
    "record": "Dictate — speak and your words are typed",
    "preparing": "Preparing voice input…",
    "stop": "Stop dictating",
    "processing": "Transcribing…",
    "unsupported": "Voice input isn't supported in this browser",
    "denied": "Microphone access is needed for voice input",
    "insecure": "Voice input needs a secure (HTTPS) connection",
    "busy": "Microphone is in use — please try again in a moment",
    "noMic": "No microphone was found",
    "error": "Voice input stopped unexpectedly"
  },
  "phone": {
    "callAria": "Call {{number}}",
    "smsAria": "Text {{number}}",
    "actions": {
      "call": "Call",
      "sms": "SMS",
      "copy": "Copy",
      "copied": "Copied"
    }
  },
  "email": {
    "emailAria": "Email {{address}}",
    "actions": {
      "email": "Email",
      "copy": "Copy",
      "copied": "Copied"
    }
  },
  "smsSegmentCounter": {
    "segmentInfo_one": "{{chars}} · {{count}} SMS segment",
    "segmentInfo_other": "{{chars}} · {{count}} SMS segments"
  },
  "smsSanitize": {
    "notice": "Special characters will be simplified to plain text so this message delivers reliably."
  },
  "smsDeliverability": {
    "severity": {
      "block": "Blocked:",
      "warn": "Warning:",
      "info": "Note:"
    }
  },
  "numberHealth": {
    "badge": {
      "smsBlocked": "SMS blocked — call only",
      "invalid": "Invalid — both channels down"
    },
    "lineType": {
      "mobile": "Mobile",
      "landline": "Landline",
      "voip": "VoIP",
      "unknown": "Unknown",
      "withCarrier": "{{type}} — {{carrier}}"
    },
    "value": {
      "deliverable": "Deliverable",
      "notSupported": "Not supported",
      "undeliverable": "Undeliverable",
      "optedOut": "Opted out",
      "optedOutOn": "Opted out · {{date}}"
    },
    "tooltip": {
      "title": {
        "healthy": "Number verified",
        "landline": "Landline — cannot receive SMS",
        "optedOut": "Opted out of SMS",
        "invalid": "Invalid or disconnected number"
      },
      "lineType": "Line type",
      "voice": "Voice",
      "sms": "SMS",
      "lastVerified": "Last verified",
      "lastChecked": "Last checked",
      "summary": {
        "healthy": "Calls and texts both go through.",
        "landline": "Texts won’t deliver here — reach them by phone.",
        "optedOut": "Opted out of texts. Nothing sends until they reply START.",
        "optedOutOn": "Opted out {{date}}. Nothing sends until they reply START.",
        "invalid": "Number looks disconnected — texts and calls won’t go through."
      },
      "hint": {
        "landline": "Texts won’t be delivered to this number. Calling still works — reach the contact by phone.",
        "invalid": "This number looks invalid or disconnected — texts and calls won’t go through."
      }
    },
    "banner": {
      "landline": {
        "named": "This number is a landline and can’t receive texts. Calling works — reach {{name}} by phone instead.",
        "anon": "This number is a landline and can’t receive texts. Calling works — reach the contact by phone instead."
      },
      "optedOut": {
        "named": "{{name}} opted out of texts on {{date}}. Messages won’t send unless they reply START.",
        "anon": "This contact opted out of texts on {{date}}. Messages won’t send unless they reply START.",
        "namedNoDate": "{{name}} opted out of texts (replied STOP). Messages won’t send unless they reply START.",
        "anonNoDate": "This contact opted out of texts (replied STOP). Messages won’t send unless they reply START."
      },
      "invalid": "This number is invalid or disconnected. Texts and calls won’t go through — update the contact’s phone number."
    }
  },
  "smsCost": {
    "title": "Costing extra segments:",
    "clear": "Clear {{label}}",
    "clearAll": "Clear all",
    "kind": {
      "formatting": "Bold or italic text",
      "bulletList": "Bulleted list",
      "emoji": "Emoji",
      "smartPunctuation": "Curly quotes and dashes",
      "otherUnicode": "Special characters",
      "gsmExtended": "Double-cost characters"
    },
    "hint": {
      "formatting": "Bold and italic are sent as Unicode look-alikes, which cut the segment from 160 to 70 characters. Clearing keeps the words, drops the styling.",
      "bulletList": "The • marker is Unicode and cuts the segment to 70 characters. Clearing switches the list to numbers, which are free.",
      "emoji": "Emoji are Unicode and cut the segment from 160 to 70 characters. Clearing removes them.",
      "smartPunctuation": "Curly quotes, dashes and ellipses are Unicode and cut the segment to 70 characters. Clearing swaps them for plain equivalents.",
      "otherUnicode": "These characters cut the segment from 160 to 70. Clearing replaces accents with plain letters and removes the rest.",
      "gsmExtended": "These characters each count as two. Clearing removes them."
    }
  },
  "massAction": {
    "channel": {
      "sms": "Mass SMS",
      "email": "Mass Email",
      "phone": "Power dialer"
    },
    "status": {
      "onCall": "On call",
      "onHold": "On hold",
      "incoming": "Incoming",
      "connecting": "Connecting...",
      "calling": "Calling...",
      "ended": "Call ended",
      "dialing": "Power Dialing",
      "sending": {
        "sms": "Sending SMS",
        "email": "Sending Email",
        "phone": "Sending"
      },
      "sent": "Sent",
      "paused": "Paused",
      "pausedForCall": "Paused — incoming call"
    },
    "queueStarted": "{{queue}} in queue · started {{minutes}}m ago",
    "completedToast": {
      "sms": "Mass SMS sending is done",
      "email": "Mass Email sending is done",
      "sentFailed": "{{sent}} of {{total}} sent · {{failed}} failed"
    },
    "controls": {
      "stop": "Stop",
      "pause": "Pause",
      "resume": "Resume",
      "endCall": "End",
      "cancel": "Cancel",
      "mute": "Mute",
      "speaker": "Speaker",
      "hold": "Hold",
      "keypad": "Keypad",
      "transfer": "Transfer",
      "silence": "Silence",
      "reply": "Reply",
      "speakerUnavailable": "Speaker output can't be switched on this device"
    },
    "call": {
      "total": "Total:",
      "accept": "Accept call",
      "decline": "Decline call",
      "silence": "Silence ringtone",
      "unsilence": "Unmute ringtone",
      "noRecordsTitle": "Not in your records",
      "noRecordsHint": "Add as a lead, customer, or carrier after the call",
      "mainline": "Mainline",
      "copyNumber": "Click to copy",
      "numberCopied": "Number copied",
      "answerHangsPowerdial": "Answering will hang up your Power Dial call — dialing resumes when this call ends",
      "answerHangsCurrent": "Answering will hang up your current call"
    },
    "demo": {
      "title": "Mass action demo",
      "reset": "Idle",
      "sms": "Sending SMS",
      "email": "Sending Email",
      "dialing": "Dialing",
      "onCall": "On call",
      "calling": "Calling",
      "incoming": "Incoming",
      "incomingNew": "Incoming (new)"
    }
  },
  "callButton": {
    "call": "Call {{number}}"
  },
  "telephony": {
    "title": "Phone",
    "close": "Close",
    "empty": "—",
    "health": {
      "title": "Connection health",
      "openLabel": "Show connection health",
      "stateGood": "Good connection",
      "stateFair": "Weak connection",
      "statePoor": "Poor connection",
      "stateUnknown": "Checking connection…",
      "yourConnection": "Your connection",
      "customerAudio": "Customer audio",
      "mineGood": "Good",
      "mineFair": "Unstable",
      "minePoor": "Poor",
      "theirsGood": "Clear",
      "theirsPoor": "Breaking up",
      "checking": "Checking…",
      "theirsPoorHint": "The problem is likely on the customer's side, not yours.",
      "loss": "Loss {{value}}%",
      "jitter": "Jitter {{value}} ms",
      "ping": "Ping {{value}} ms"
    },
    "providerBadge": {
      "premium": "Premium",
      "standard": "Standard",
      "premiumShort": "P",
      "standardShort": "S"
    },
    "device": {
      "idle": "Not started",
      "connecting": "Connecting…",
      "ready": "Connected",
      "error": "Failed",
      "offline": "Offline",
      "hint": {
        "idle": "Connect to place and receive calls in this tab.",
        "connecting": "Setting up your voice connection…",
        "ready": "Incoming calls ring in this tab.",
        "error": "Calls can't be placed or received right now.",
        "offline": "Your device has no internet connection."
      }
    },
    "fields": {
      "phoneNumber": "Phone number",
      "numbers": "Numbers"
    },
    "notConfigured": {
      "title": "Calling unavailable",
      "hint": "Telephony is not set up for your organization yet."
    },
    "connect": {
      "action": "Connect",
      "connecting": "Connecting…"
    },
    "reconnect": {
      "action": "Reconnect"
    },
    "refresh": "Refresh connection",
    "preflight": {
      "action": "Test my phone",
      "running": "Testing…",
      "pass": "Everything looks good — your phone is ready to call.",
      "fail": "A check failed — share this result with support.",
      "check": {
        "browser": "Browser support",
        "mic": "Microphone",
        "backend": "Phone service",
        "socket": "Live connection",
        "media": "Call audio path",
        "call": "Test call quality"
      }
    },
    "disconnect": {
      "action": "Disconnect"
    },
    "reason": {
      "title": "Phone connection lost",
      "socketClosed": "The voice connection closed unexpectedly.",
      "socketError": "The voice connection hit a network error.",
      "clientError": "The phone service reported an error.",
      "connectFailed": "Could not reach the voice service.",
      "networkOffline": "Your device lost its internet connection.",
      "retriesExhausted": "Automatic reconnect attempts ran out — reconnect manually.",
      "credentialRejected": "The voice service rejected the phone's credentials — reconnecting with new ones."
    },
    "toast": {
      "connectFailed": "Could not connect the phone.",
      "disconnected": "Phone disconnected.",
      "defaultFailed": "Could not set the default number.",
      "wentOffline": "Phone went offline — trying to reconnect…",
      "cantReconnect": "Phone is offline — automatic reconnect failed. Reconnect from the phone panel."
    },
    "report": {
      "action": "Report a problem",
      "noteLabel": "What went wrong? (optional)",
      "notePlaceholder": "e.g. the caller couldn't hear me, the call dropped after a few seconds…",
      "cancel": "Cancel",
      "send": "Send report",
      "sending": "Sending…",
      "sentTitle": "Report sent",
      "sentHint": "Share this reference code with support:",
      "cooldown": "Report sent",
      "callAction": "Report issue",
      "callTitle": "Report a call problem",
      "toastSent": "Your report was sent — support code {{ref}}"
    },
    "reset": {
      "action": "Phone stuck on a call?",
      "confirmHint": "This ends every call this phone is holding, including one that is still connected.",
      "cancel": "Keep the call",
      "confirm": "End and reset",
      "done": "Phone reset."
    },
    "section": {
      "lines": "Call from",
      "audio": "Audio devices",
      "diagnostics": "Troubleshooting"
    },
    "audio": {
      "mic": "Microphone",
      "speaker": "Speaker",
      "systemDefault": "System default",
      "unnamedMic": "Microphone {{index}}",
      "unnamedSpeaker": "Speaker {{index}}",
      "missing": "“{{label}}” is unplugged — using the system default until it's back.",
      "permissionHint": "Device names appear once microphone access is allowed.",
      "micUnplugged": "Your microphone “{{label}}” was disconnected — calls switched to the system default.",
      "speakerUnplugged": "Your speaker “{{label}}” was disconnected — call audio switched to the system default.",
      "micRestored": "Microphone “{{label}}” reconnected — calls are using it again.",
      "speakerRestored": "Speaker “{{label}}” reconnected — call audio is using it again."
    },
    "line": {
      "shared": "Shared"
    }
  },
  "softphone": {
    "callFailed": "Call failed — {{reason}}",
    "badNumber": "This number doesn't exist or can't be reached — double-check it before dialing again.",
    "declinedByCallee": "The person you called declined the call.",
    "callRetrying": "Connection hiccup — reconnecting and retrying your call…",
    "micBlockedTitle": "Microphone is blocked",
    "micBlockedHint": "Allow microphone access in your browser's site settings, then reload the page.",
    "micBlockedAnswer": "Can't answer — microphone access is blocked. Allow it in your browser's site settings.",
    "micUnavailable": "Microphone unavailable — check that it's connected and allowed in your browser.",
    "mediaSetupFailed": "Call audio couldn't be established — your network may be blocking it. Please try again.",
    "answerTimeout": "The call couldn't connect — please try again.",
    "trigger": "Phone",
    "disconnect": "Disconnect",
    "notConnectedHint": "Connect your phone from your profile menu to place calls.",
    "connect": {
      "title": "Connect your phone",
      "hint": "Connect to make and receive calls from here.",
      "action": "Connect"
    },
    "status": {
      "title": "Phone",
      "idle": "Not connected",
      "connecting": "Connecting…",
      "ready": "Ready",
      "error": "Connection error",
      "offline": "Offline"
    },
    "dialer": {
      "from": "From",
      "placeholder": "Enter a number",
      "call": "Call"
    },
    "session": {
      "connecting": "Connecting…",
      "conference": "Conference",
      "empty": "No active calls"
    },
    "state": {
      "init": "Starting",
      "ringing": "Ringing",
      "answered": "On call",
      "disposed": "Ended",
      "failed": "Failed"
    },
    "controls": {
      "answer": "Answer",
      "decline": "Decline",
      "voicemail": "Voicemail",
      "forward": "Forward",
      "hangup": "Hang up",
      "endConference": "End conference",
      "mute": "Mute",
      "unmute": "Unmute",
      "hold": "Hold",
      "unhold": "Resume",
      "record": "Record",
      "stopRecording": "Stop",
      "transfer": "Transfer",
      "dtmf": "Keypad",
      "dtmfPlaceholder": "123#",
      "send": "Send"
    },
    "incoming": {
      "title": "Incoming call",
      "answer": "Answer",
      "decline": "Decline"
    },
    "toast": {
      "missingCredentials": "Telephony is not configured.",
      "connectFailed": "Could not connect the phone."
    },
    "powerDialer": {
      "title": "Power dialer",
      "start": "Start dialing",
      "pause": "Pause",
      "resume": "Resume",
      "stop": "Stop",
      "idle": "No active session",
      "progress": "{{dialed}} of {{total}} dialed",
      "current": "Calling {{name}}",
      "phase": {
        "initializing": "Initializing",
        "dialing": "Dialing",
        "on_call": "On call",
        "paused": "Paused",
        "completed": "Completed",
        "cancelled": "Cancelled"
      }
    },
    "keypadUnreachable": "Keypad tones can't reach this call — the connection dropped mid-call. The audio is fine, but menu keys won't register; redial to use the menu."
  },
  "map": {
    "unavailable": "The map can't be displayed on this device",
    "control": {
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "recenter": "Recenter route",
      "enterFullscreen": "View fullscreen",
      "exitFullscreen": "Exit fullscreen",
      "toggleStyle": "Switch map style"
    },
    "route": {
      "distance": "Distance",
      "duration": "Drive time",
      "miles": "{{value}} mi",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "focus": "Zoom to {{label}}"
    },
    "gesture": {
      "scroll": "Use ctrl + scroll to zoom the map",
      "touch": "Use two fingers to move the map"
    }
  },
  "documentTitle": {
    "dashboard": "Dashboard",
    "inbox": "Inbox",
    "leads": "Leads",
    "lead": "Lead",
    "quotes": "Quotes",
    "quote": "Quote",
    "newQuote": "New Quote",
    "convert": "Convert to Order",
    "orders": "Orders",
    "order": "Order",
    "newOrder": "New Order",
    "editLead": "Edit Lead",
    "editQuote": "Edit Quote",
    "editOrder": "Edit Order",
    "dispatchOrder": "Dispatch Order",
    "tasks": "Tasks",
    "customer": "Customer",
    "carrier": "Carrier",
    "insights": "Insights",
    "admin": "Admin",
    "more": "More",
    "automations": "Automations",
    "preferences": "Preferences",
    "login": "Log in",
    "notFound": "Page not found",
    "forbidden": "Access denied",
    "oauthConsent": "Connect App",
    "campaign": "Campaign"
  },
  "oauthConsent": {
    "title": "Connect {{app}}",
    "organizationLabel": "Organization",
    "permissionsTitle": "This will allow {{app}} to:",
    "scopes": {
      "read": "Read your shipments, customers, carriers and messages",
      "write": "Create and update shipments, customers and carriers, and send messages on your behalf"
    },
    "actsAsYou": "The app acts with your own permissions — it can't do anything you can't already do in the dashboard.",
    "allow": "Allow",
    "deny": "Deny",
    "approveError": "Couldn't complete the connection. Please try again.",
    "empty": {
      "title": "Nothing to authorize",
      "description": "This page completes a connection request started from an external app. Open it from the app you're connecting.",
      "goHome": "Go to dashboard"
    },
    "invalid": {
      "title": "Invalid connection request",
      "description": "This connection request is invalid or has expired. Start over from the app you're connecting."
    },
    "loadError": {
      "title": "Couldn't load the request",
      "description": "Something went wrong while loading the connection request.",
      "retry": "Try again"
    }
  },
  "workspaceTabs": {
    "label": "Workspace tabs",
    "newTab": "New Tab",
    "openNewTab": "Open new tab",
    "closeTab": "Close tab",
    "renameTab": "Rename tab",
    "pinStrip": "Lock tabs at top",
    "unpinStrip": "Unlock tabs",
    "shortcuts": {
      "title": "Shortcuts",
      "links": "Links",
      "tabs": "Tabs",
      "click": "Click",
      "doubleClick": "Double-click",
      "openBackground": "Open link in a background tab",
      "openForeground": "Open link and switch to it",
      "newTab": "New tab",
      "switchTab": "Go to tab 1–8",
      "lastTab": "Go to last tab",
      "previousTab": "Back to previous tab",
      "renameTab": "Rename a tab"
    }
  },
  "hello": "Hello World",
  "loading": "Loading...",
  "connection": {
    "offline": "No internet connection",
    "reconnected": "Back online"
  },
  "clipboard": {
    "linkCopied": "Link copied",
    "copyFailed": "Couldn't copy the link"
  },
  "appUpdate": {
    "title": "New version available",
    "description": "We've shipped an update. Reload when you're ready to get the latest version.",
    "reload": "Reload",
    "sidebarHint": "A new version is available",
    "updateNow": "Update now"
  },
  "unsavedChanges": {
    "title": "Leave without saving?",
    "description": "You have unsaved changes. If you leave now, the data you entered will be lost.",
    "cancel": "Stay on page",
    "confirm": "Leave anyway"
  },
  "card": {
    "title": "shadcn/ui Test",
    "description": "Testing the latest shadcn/ui components",
    "inputPlaceholder": "Enter some text...",
    "button": "Click me!"
  },
  "bulkSend": {
    "badge": {
      "sending": "Sending messages",
      "done": "All messages sent"
    },
    "panel": {
      "sending": "Sending messages",
      "done": "All messages sent",
      "close": "Collapse"
    },
    "channel": {
      "sms": "SMS",
      "email": "Email"
    },
    "progress": "{{current}} / {{total}}",
    "eta": "~{{minutes}} min left",
    "sent": "{{count}} sent",
    "failed": "{{count}} failed",
    "dismiss": "Dismiss"
  },
  "massSms": {
    "title": "Mass SMS",
    "close": "Close",
    "from": "From",
    "fromPlaceholder": "Select number",
    "noNumbers": "No numbers available",
    "template": "Template",
    "insertField": "Insert field",
    "noTemplates": "No templates",
    "noFields": "No fields",
    "messagePlaceholder": "Write your message...",
    "summary": {
      "sending": "Sending to {{willReceive}} of {{total}} selected",
      "single": "This message can't be sent",
      "viewRemoved": "View {{count}} removed"
    },
    "removed": {
      "heading": "{{count}} won't be contacted — here's why:",
      "chip": {
        "duplicate": "{{count}} duplicates merged",
        "unsubscribed": "{{count}} unsubscribed",
        "invalid": "{{count}} invalid number",
        "do_not_text": "{{count}} do-not-text",
        "do_not_call": "{{count}} do-not-call",
        "wrong_number": "{{count}} wrong number",
        "undeliverable": "{{count}} undeliverable",
        "spam_blocked": "{{count}} blocked as spam",
        "route_blocked": "{{count}} route blocked",
        "sender_paused": "{{count}} sender paused",
        "landline_or_voip": "{{count}} landline or VoIP",
        "gate_rejected": "{{count}} rejected",
        "tmobile_daily_cap": "{{count}} T-Mobile daily cap",
        "no_contact": "{{count}} without a phone number"
      },
      "reason": {
        "duplicate": "Duplicate",
        "unsubscribed": "Unsubscribed",
        "invalid": "Invalid number",
        "do_not_text": "Do not text",
        "do_not_call": "Do not call",
        "wrong_number": "Wrong number",
        "undeliverable": "Undeliverable",
        "spam_blocked": "Blocked as spam",
        "route_blocked": "Route blocked",
        "sender_paused": "Sender paused",
        "landline_or_voip": "Landline or VoIP",
        "gate_rejected": "Rejected",
        "tmobile_daily_cap": "T-Mobile daily cap reached",
        "no_contact": "No phone number"
      }
    },
    "counter": {
      "chars": "{{chars}} characters · {{segments}} segments per recipient",
      "math": "{{willReceive}} × {{segments}} = {{totalSms}} SMS"
    },
    "carrierNote": "Requests {{count}} SMS from your carrier. Recipients can reply STOP to opt out at any time.",
    "footer": {
      "summary": "{{willReceive}} will receive · {{totalSms}} SMS"
    },
    "cancel": "Cancel",
    "send": "Send {{count}} SMS",
    "media": {
      "add": "Add media",
      "remove": "Remove attachment",
      "failed": "Failed",
      "tooMany": "You can attach up to {{max}} files",
      "tooLarge": "{{name}} is over 10 MB",
      "uploadError": "Couldn't upload {{name}}"
    },
    "toast": {
      "sent": "Queued {{count}} SMS",
      "error": "Couldn't send the messages"
    }
  },
  "massEmail": {
    "title": "Mass Email",
    "close": "Close",
    "from": "From",
    "fromPlaceholder": "Select address",
    "noEmails": "No addresses available",
    "subjectLabel": "Subject",
    "subjectPlaceholder": "Subject line",
    "messagePlaceholder": "Write your message...",
    "summary": {
      "sending": "Sending to {{willReceive}} of {{total}} selected",
      "single": "This email can't be sent",
      "viewRemoved": "View {{count}} removed"
    },
    "removed": {
      "heading": "{{count}} won't be contacted — here's why:",
      "chip": {
        "duplicate": "{{count}} duplicates merged",
        "unsubscribed": "{{count}} unsubscribed",
        "invalid": "{{count}} invalid address",
        "do_not_text": "{{count}} do-not-text",
        "do_not_call": "{{count}} do-not-call",
        "wrong_number": "{{count}} wrong number",
        "undeliverable": "{{count}} undeliverable",
        "spam_blocked": "{{count}} blocked as spam",
        "route_blocked": "{{count}} route blocked",
        "sender_paused": "{{count}} sender paused",
        "landline_or_voip": "{{count}} landline or VoIP",
        "gate_rejected": "{{count}} rejected",
        "tmobile_daily_cap": "{{count}} T-Mobile daily cap",
        "no_contact": "{{count}} without an email address"
      },
      "reason": {
        "duplicate": "Duplicate",
        "unsubscribed": "Unsubscribed",
        "invalid": "Invalid email",
        "do_not_text": "Do not text",
        "do_not_call": "Do not call",
        "wrong_number": "Wrong number",
        "undeliverable": "Undeliverable",
        "spam_blocked": "Blocked as spam",
        "route_blocked": "Route blocked",
        "sender_paused": "Sender paused",
        "landline_or_voip": "Landline or VoIP",
        "gate_rejected": "Rejected",
        "tmobile_daily_cap": "T-Mobile daily cap reached",
        "no_contact": "No email address"
      }
    },
    "note": "Sends {{count}} emails. Each includes a one-click unsubscribe link, so opt-outs are captured automatically.",
    "footer": {
      "summary": "{{willReceive}} will receive"
    },
    "cancel": "Cancel",
    "send": "Send {{count}} Email",
    "sendEmpty": "Send",
    "toast": {
      "sent": "Queued {{count}} emails",
      "error": "Couldn't send the emails"
    }
  },
  "massCall": {
    "toast": {
      "error": "Couldn't start Power Dial",
      "linesLoading": "Loading your phone lines — try again in a moment",
      "noLine": "No call-capable line available",
      "noRecipients": "Selected records have no phone numbers",
      "onCall": "You're on a call — Power Dial can start once it ends",
      "pausedForIncoming": "Power Dial paused — incoming call",
      "resumedAfterCall": "Power Dial resumed",
      "softphoneConnecting": "Connecting the softphone — try again in a moment"
    },
    "disabled": {
      "starting": "Starting Power Dial…",
      "onCall": "Finish the active call to start Power Dial",
      "connecting": "Softphone is connecting…",
      "noRecipients": "Selected records have no phone numbers",
      "noLine": "No call-capable line is assigned to you"
    }
  },
  "templateToolbar": {
    "template": "Template",
    "insertField": "Insert field",
    "noTemplates": "No templates",
    "noFields": "No fields",
    "loading": "Loading…"
  },
  "manageFields": {
    "title": "You Can Show / Hide Fields",
    "hideAll": "Hide all",
    "showAll": "Show all",
    "sections": {
      "vehicle": "Vehicle",
      "customerDetails": "Customer Details",
      "origin": "Origin",
      "destination": "Destination",
      "shipment": "Shipment",
      "payment": "Payment"
    },
    "options": {
      "vin": "VIN",
      "compactView": "Compact view",
      "company": "Company",
      "billingEmail": "Billing email",
      "companyPhone": "Company phone",
      "altPhone": "Alternative phone",
      "altEmail": "Alternative email",
      "additionalNote": "Additional note",
      "businessName": "Business name",
      "tags": "Tags",
      "customerNote": "Customer note",
      "defaultMethods": "Default methods"
    }
  },
  "forms": {
    "validation": {
      "required": "This field is required",
      "invalidEmail": "Please enter a valid email address",
      "minLength": "Must be at least {{min}} characters long",
      "maxLength": "Must be no more than {{max}} characters long",
      "passwordMinLength": "Password must be at least 8 characters long",
      "passwordStrength": "Password must contain uppercase, lowercase, number and special character",
      "passwordMismatch": "Passwords do not match",
      "invalidUsPhone": "Enter a valid US phone number"
    }
  },
  "errors": {
    "boundary": {
      "updating": {
        "title": "Finishing an update",
        "description": "A new version was just released. This page will reload on its own as soon as it's ready."
      },
      "title": "This page pulled over for a second",
      "description": "It's not something you did — your work is safe. Give it a reload to get moving again.",
      "detailsTitle": "Error details",
      "tryAgain": "Reload the page",
      "goHome": "Back to dashboard",
      "goBack": "Go Back",
      "copyError": "Copy details",
      "copied": "Details copied — send them to our team and we'll take it from here",
      "copyFailed": "Couldn't copy the details",
      "unknownError": "Unknown error occurred"
    },
    "notFound": {
      "title": "Page not found",
      "description": "Sorry, we couldn't find the page you're looking for.",
      "goHome": "Go to dashboard"
    },
    "general": {
      "title": "Something went wrong",
      "description": "An unexpected error occurred"
    },
    "api": {
      "unauthorized": "Authentication required. Please log in.",
      "forbidden": "You don't have permission to access this resource.",
      "notFound": "The requested resource was not found.",
      "serverError": "Internal server error. Please try again later.",
      "serviceUnavailable": "Service temporarily unavailable. Please try again later.",
      "networkError": "Network error. Please check your connection.",
      "generic": "An error occurred while processing your request."
    }
  },
  "login": {
    "title": "Broker OS",
    "features": {
      "trackShipment": "Track shipment status in real time",
      "viewDetails": "View pickup & delivery details",
      "instantPricing": "Get instant pricing for new shipments"
    },
    "email": "Email",
    "emailPlaceholder": "email@company.com",
    "emailHint": "We'll send a one-time code to your email. No password required.",
    "password": "Password",
    "passwordPlaceholder": "Enter password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "forgotPassword": "Forgot your password?",
    "signIn": "Sign In",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "sendCode": "Send Verification Code",
    "agreementPrefix": "By signing in, you agree to TheCarGo's",
    "termsAndConditions": "Terms & Conditions",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "copyright": "© 2025 TheCarGo. All rights reserved.",
    "verification": {
      "checkEmail": "Check your email.",
      "codeSentTo": "We sent a code to your {{email}}.",
      "codePlaceholder": "Enter a code",
      "didntReceive": "Didn't receive the code?",
      "didntReceiveResendIn": "Didn't get it? Resend in {{time}}",
      "resendIn": "You can resend in {{time}}",
      "resendCode": "Resend a code",
      "verifyAndSignIn": "Verify and Sign In",
      "continue": "Continue"
    },
    "errors": {
      "failed": "Sign in failed. Please check your credentials and try again.",
      "rateLimited": "Too many attempts. Please try again in {{seconds}} seconds.",
      "networkCooldown": "Can't reach the server. Please try again in {{seconds}} seconds.",
      "retryIn": "Try again in {{time}}",
      "invalidCode": "Invalid or expired code. Please try again.",
      "deviceLimitReached": "Device limit reached. Sign out on another device first.",
      "deviceLimitReachedCount_one": "Device limit reached ({{count}} device). Sign out on that device first.",
      "deviceLimitReachedCount_other": "Device limit reached ({{count}} devices). Sign out on another device first."
    },
    "success": "Signed in successfully.",
    "rememberMe": "Remember me",
    "sessionRevoked": {
      "passwordChange": "Your password was changed. Please sign in again.",
      "adminReset": "Your password was reset by an administrator. Please sign in again.",
      "emailChange": "Your login email was changed. Please sign in with your new email.",
      "deactivated": "Your account has been deactivated. Contact your administrator.",
      "userDeleted": "Your account is no longer active.",
      "unknown": "Your session has ended. Please sign in again.",
      "sessionTerminated": "This device was signed out from your Devices page.",
      "sessionSuperseded": "Your account signed in again on this device, which closed this session."
    }
  },
  "bottomNav": {
    "dashboard": "Dash",
    "leads": "Lead",
    "quotes": "Quote",
    "orders": "Order",
    "phone": "Phone",
    "more": "More"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "leads": "Leads",
    "quotes": "Quotes",
    "orders": "Orders",
    "task": "Task",
    "customer": "Customer",
    "carrier": "Carrier",
    "insights": "Insights",
    "admin": "Admin",
    "more": "More",
    "preferences": "Preferences",
    "adminItems": {
      "users": "Users",
      "leads": "Leads",
      "company": "Company",
      "companyTemplate": "Template",
      "numbers": "Numbers"
    },
    "moreItems": {
      "automation": "Automation"
    },
    "version": "Version: {{version}}",
    "soon": "Soon",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "openMenu": "Open menu",
    "userMenu": {
      "logout": "Log out",
      "telephonyFailed": "Phone is offline",
      "tour": "Take the tour",
      "mailbox": "Connect mailbox",
      "devices": "Devices"
    },
    "inbox": "Inbox"
  },
  "insights": {
    "title": "Insights",
    "dateRange": "{{current}}",
    "dateRangeCompare": "{{current}} · vs {{previous}}",
    "compareToPrevious": "Compare to previous",
    "export": "Export",
    "exportPreparing": "Preparing…",
    "scope": {
      "allTeam": "All team"
    },
    "overview": {
      "vsPrev": "{{value}} vs prev",
      "openInvoices": "{{count}} open invoices",
      "error": "Couldn't load metrics",
      "empty": "No data for this period",
      "metrics": {
        "totalRevenue": "Total revenue",
        "margin": "Margin",
        "dispatched": "Dispatched",
        "conversionRate": "Conversion rate",
        "avgBrokerFee": "Avg broker fee",
        "receivables": "Receivables"
      }
    },
    "funnel": {
      "title": "Full funnel",
      "subtitle": "lead → delivered",
      "step": "→ {{value}}",
      "error": "Couldn't load funnel data",
      "mode": {
        "volume": "Volume",
        "revenue": "Revenue"
      },
      "stages": {
        "leadsReceived": "Leads received",
        "quoted": "Quoted",
        "active": "Active",
        "orders": "Orders",
        "posted": "Posted",
        "dispatched": "Dispatched",
        "pickedUp": "Picked up",
        "delivered": "Delivered"
      },
      "summary": {
        "leadToOrder": "Lead → Order",
        "orderToDispatch": "Order → Dispatch",
        "dispatchToDelivered": "Dispatch → Delivered",
        "endToEnd": "End-to-end"
      }
    },
    "revenueTrend": {
      "title": "Revenue & margin — daily",
      "error": "Couldn't load revenue data",
      "series": {
        "revenue": "Revenue (tariff)",
        "margin": "Margin (broker fee)"
      }
    },
    "leaders": {
      "seeAll": "See all",
      "orders": "{{count}} orders",
      "ordShort": "{{count}} ord",
      "error": "Couldn't load leaderboards",
      "performers": {
        "title": "Top performers",
        "subtitle": "By margin"
      },
      "sources": {
        "title": "Top sources",
        "subtitle": "By margin"
      }
    },
    "emptyState": {
      "title": "No data for this period",
      "description": "Once there's activity in this range, it will show up here."
    },
    "recommendations": {
      "comingSoon": "Coming soon",
      "error": "Couldn't load recommendations",
      "items": {
        "dialBlocks": {
          "title": "Move dial blocks to 10–12 AM",
          "description": "Pickup rate hits 31% Tue–Thu 10–12 vs a 17% daily average. Schedule power-dialer sessions in that window.",
          "action": "Open Communications →"
        },
        "leadSpend": {
          "title": "Rebalance lead spend",
          "description": "ShipQuotes costs $74 per order vs $41 on AutoLeadPro. Shifting ~30% of spend is worth ≈ 9 extra orders / mo.",
          "action": "Open Sources →"
        },
        "stalledQuotes": {
          "title": "12 stalled quotes ≈ $2,460 margin",
          "description": "Quotes idle 5+ days with no follow-up. Auto-nurture is switched off for 2 agents.",
          "action": "Review quotes →"
        }
      }
    },
    "sales": {
      "metrics": {
        "leads": "Leads",
        "quotes": "Quotes",
        "orders": "Orders",
        "conversionRate": "Conversion rate",
        "margin": "Margin",
        "avgBrokerFee": "Avg broker fee"
      },
      "deltaPts": "{{value}}pts",
      "marginByAgent": {
        "title": "Margin by agent",
        "subtitle": "Broker fee earned · selected period",
        "error": "Couldn't load margin by agent"
      }
    },
    "leaderboard": {
      "title": "Leaderboard",
      "subtitle": "Ranked by margin generated",
      "exportCsv": "Export CSV",
      "error": "Couldn't load leaderboard",
      "qualityNote": "Quality grade = composite of margin %, dispatch rate, and issue rate",
      "columns": {
        "rank": "#",
        "agent": "Agent",
        "margin": "Margin $",
        "marginPct": "Margin %",
        "conv": "Conv. rate",
        "dispatch": "Dispatch rate",
        "avgFee": "Avg fee",
        "issue": "Issue rate",
        "quality": "Quality"
      },
      "roles": {
        "senior": "Senior agent",
        "middle": "Middle agent",
        "junior": "Junior agent",
        "trainee": "Trainee"
      },
      "team": {
        "margin": "Team margin",
        "avgMargin": "Team avg margin %",
        "avgConv": "Team avg conv.",
        "issue": "Team issue rate"
      }
    },
    "salesByAgent": {
      "title": "Sales by agent",
      "subtitle": "All metrics · selected period",
      "exportCsv": "Export CSV",
      "error": "Couldn't load sales by agent",
      "note": "Click an agent to scope all Insights tabs to them.",
      "allAgents": "All {{count}} agents",
      "columns": {
        "agent": "Agent",
        "leads": "Leads",
        "quotes": "Quotes",
        "orders": "Orders",
        "conv": "Conv %",
        "disp": "Disp.",
        "dispPct": "Disp %",
        "revenue": "Revenue",
        "carrierPay": "Carrier pay",
        "margin": "Margin",
        "avgFee": "Avg fee",
        "marginPct": "Margin %"
      }
    },
    "marginBySource": {
      "title": "Margin by source",
      "subtitle": "Broker fee earned · selected period",
      "error": "Couldn't load margin by source",
      "noSpend": "no spend",
      "perOrder": "{{amount}} / order",
      "total": "Total"
    },
    "sourcePerformance": {
      "title": "Source performance",
      "subtitle": "Lead providers, organic and B2B in one view",
      "exportCsv": "Export CSV",
      "error": "Couldn't load source performance",
      "note": "Spend, CPL and ROI apply to paid providers only — B2B and organic rows show — by design.",
      "allSources": "All sources",
      "sortBy": "Sort by {{column}}",
      "types": {
        "b2b": "B2B",
        "organic": "Organic",
        "provider": "Provider"
      },
      "columns": {
        "source": "Source",
        "type": "Type",
        "leads": "Leads",
        "spend": "Spend",
        "cpl": "CPL",
        "quotes": "Quotes",
        "orders": "Orders",
        "conv": "Conv %",
        "dispatch": "Dispatch",
        "dConv": "D conv %",
        "revenue": "Revenue",
        "margin": "Margin",
        "cpo": "CPO",
        "roi": "ROI"
      }
    },
    "sourceMix": {
      "title": "B2B vs Organic vs Provider",
      "subtitle": "Orders · selected period",
      "error": "Couldn't load source mix",
      "b2b": "B2B",
      "organic": "Organic",
      "provider": "Provider",
      "legend": "{{orders}} orders · {{pct}}"
    },
    "sourceInsight": {
      "rebalanceSpend": {
        "title": "Rebalance lead spend",
        "description": "ShipQuotes returns 3.0× at $74 per order. AutoLeadPro returns 5.6× at $41. Shifting ~30% of ShipQuotes budget is worth ≈ 9 extra orders and ≈ $1,850 margin per month.",
        "action": "Open Sales →"
      }
    },
    "financials": {
      "kpi": {
        "collected": "Collected",
        "receivable": "Receivable",
        "carrierPayable": "Carrier payable",
        "refunded": "Refunded",
        "netCashFlow": "Net cash flow"
      },
      "notes": {
        "payments": "{{count}} payments",
        "openInvoices": "{{count}} open invoices",
        "dispatches": "{{count}} dispatches",
        "refunds": "{{count}} refunds",
        "netFlow": "collected − paid out"
      }
    },
    "cashFlow": {
      "title": "Cash in vs out",
      "subtitle": "Daily · May 30 – Jun 12",
      "error": "Couldn't load cash flow",
      "cashIn": "Cash in",
      "cashOut": "Cash out"
    },
    "receivableAging": {
      "title": "Receivable aging",
      "subtitle": "{{amount}} open · {{invoices}} invoices",
      "error": "Couldn't load receivable aging",
      "chaseNote": "Chase 30+ day invoices first — they hold {{amount}}.",
      "buckets": {
        "0_7": "0–7 d",
        "8_14": "8–14 d",
        "15_30": "15–30 d",
        "30_plus": "30+ d"
      }
    },
    "transactions": {
      "title": "Daily transactions",
      "subtitle": "Most recent first",
      "exportCsv": "Export CSV",
      "error": "Couldn't load transactions",
      "columns": {
        "date": "Date",
        "type": "Type",
        "order": "Order",
        "counterparty": "Counterparty",
        "method": "Method",
        "amount": "Amount",
        "status": "Status"
      },
      "types": {
        "income": "Income",
        "carrierPay": "Carrier pay",
        "refund": "Refund",
        "tip": "Tip"
      },
      "methods": {
        "zelle": "Zelle",
        "card": "Card",
        "cash": "Cash",
        "check": "Check",
        "ach": "ACH",
        "wire": "Wire",
        "venmo": "Venmo",
        "cashapp": "Cash App",
        "paypal": "PayPal"
      },
      "statuses": {
        "created": "Created",
        "scheduled": "Scheduled",
        "awaitingConfirmation": "Awaiting confirmation",
        "partiallyPaid": "Partially paid",
        "charged": "Charged",
        "paid": "Paid",
        "processing": "Processing",
        "failed": "Failed",
        "refunded": "Refunded",
        "paymentFailed": "Payment failed",
        "canceled": "Canceled",
        "expired": "Expired"
      }
    },
    "topCustomers": {
      "title": "Top paying customers",
      "subtitle": "By revenue",
      "exportCsv": "Export CSV",
      "error": "Couldn't load top customers",
      "columns": {
        "customer": "Customer",
        "type": "Type",
        "orders": "Dispatched orders",
        "revenue": "Revenue",
        "margin": "Margin",
        "lastOrder": "Last order"
      },
      "types": {
        "business": "Business",
        "dealer": "Dealer",
        "freightBroker": "Freight broker",
        "individual": "Individual"
      }
    },
    "calls": {
      "kpi": {
        "totalCalls": "Total calls",
        "connectedRate": "Connected rate",
        "avgCallTime": "Avg call time",
        "talkMinutes": "Talk minutes",
        "voiceCost": "Est. voice cost",
        "missed": "Missed"
      },
      "notes": {
        "outboundInbound": "outbound + inbound",
        "connected": "1,114 connected",
        "perConnected": "per connected call",
        "billedCycle": "billed this cycle",
        "secCycle": "6 sec cycle",
        "noAnswer": "1,690 no-answer",
        "connected_one": "{{count, number}} connected",
        "connected_other": "{{count, number}} connected",
        "noAnswer_one": "{{count, number}} no-answer",
        "noAnswer_other": "{{count, number}} no-answer"
      }
    },
    "liveNow": {
      "title": "Live now",
      "active": "{{count}} active ·",
      "openPhone": "Open phone →",
      "channels": {
        "outbound": "Outbound",
        "inbound": "Inbound",
        "powerDialer": "Power dialer",
        "ai": "AI voice"
      }
    },
    "channelMix": {
      "title": "Calls by channel",
      "subtitle": "Human · power dialer · AI voice",
      "human": "Human",
      "powerDialer": "Power dialer",
      "aiVoice": "AI voice",
      "legend": "{{count}} ({{pct}}%)",
      "earlyAccess": "Early access",
      "error": "Couldn't load channel mix"
    },
    "pickup": {
      "title": "Pickup rate · hour × day",
      "subtitle": "When customers answer",
      "note": "Peak 31% — Tue–Thu, 10 AM – 12 PM. Schedule dial blocks there.",
      "cellTooltip": "{{day}} · {{hour}}",
      "days": {
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun"
      },
      "error": "Couldn't load the pickup heatmap"
    },
    "bestWindow": {
      "title": "Best call window by state",
      "subtitle": "Top states by volume",
      "note": "Based on recipient area code",
      "columns": {
        "state": "State",
        "calls": "Calls",
        "pickup": "Pickup",
        "window": "Best window"
      },
      "error": "Couldn't load best call windows"
    },
    "callVolume": {
      "title": "Daily call volume",
      "subtitle": "May 30 – Jun 12",
      "error": "Couldn't load call volume",
      "connected": "Connected",
      "noAnswer": "No answer"
    },
    "callsByAgent": {
      "title": "Calls by agent",
      "subtitle": "Calls, channels & talk time",
      "exportCsv": "Export CSV",
      "error": "Couldn't load calls by agent",
      "note": "AI voice calls are attributed to the agent who owns the lead.",
      "allAgents": "All agents",
      "columns": {
        "agent": "Agent",
        "calls": "Calls",
        "human": "Human",
        "dialer": "Dialer",
        "ai": "AI",
        "conn": "Conn.",
        "connPct": "Conn %",
        "avgDur": "Avg dur",
        "totalDur": "Total dur",
        "billableDur": "Billable dur"
      }
    },
    "callDuration": {
      "title": "Call duration",
      "subtitle": "Connected calls grouped by length — your per-minute cost driver",
      "axisLabel": "Call length",
      "note": "Calls over 2 minutes are {{pct}}% of connected calls — and TheCarGo bills connected time by the minute, so long calls drive the bill.",
      "buckets": {
        "u30": "<30s",
        "b30_60": "30–60s",
        "b1_2": "1–2m",
        "b2_5": "2–5m",
        "b5_10": "5–10m",
        "b10": "10m+"
      },
      "error": "Couldn't load call durations"
    },
    "callOutcomes": {
      "title": "Call outcomes",
      "subtitle": "Where {{total}} attempts landed",
      "legend": "{{count}} · {{pct}}%",
      "note": "You're billed only for connected minutes. No-answer, busy and failed attempts are free.",
      "connected": "Connected",
      "noAnswer": "No answer",
      "voicemail": "Voicemail",
      "busy": "Busy",
      "failed": "Failed",
      "error": "Couldn't load call outcomes"
    },
    "voiceBilling": {
      "title": "Voice usage & billing",
      "subtitle": "Estimated from connected minutes in the selected period",
      "error": "Couldn't load billing",
      "note": "Estimated — connected minutes only, billed per 60s. Excludes AI voice minutes (tracked separately under AI Voice).",
      "columns": {
        "channel": "Channel",
        "volume": "Volume",
        "rate": "Rate",
        "charge": "Est. charge"
      },
      "rows": {
        "outbound": "Outbound",
        "inbound": "Inbound",
        "recording": "Call recording",
        "dids": "Phone numbers (DIDs)",
        "total": "Estimated total"
      },
      "units": {
        "min": "{{volume}} min"
      }
    },
    "messaging": {
      "kpi": {
        "messagesSent": "Messages sent",
        "billableSegments": "Billable segments",
        "smsCost": "Est. SMS cost",
        "deliveryRate": "Delivery rate",
        "failed": "Failed",
        "inboundReceived": "Inbound received"
      },
      "notes": {
        "outbound": "outbound · 30d",
        "perMessage": "1.51× per message",
        "outInSegments": "out + in segments",
        "delivered": "6,742 delivered",
        "undelivered": "98 undelivered",
        "repliesIn": "replies in",
        "perMessage_one": "{{count, number}}× per message",
        "perMessage_other": "{{count, number}}× per message",
        "delivered_one": "{{count, number}} delivered",
        "delivered_other": "{{count, number}} delivered",
        "undelivered_one": "{{count, number}} undelivered",
        "undelivered_other": "{{count, number}} undelivered"
      }
    },
    "segmentDistribution": {
      "title": "Segment distribution",
      "subtitle": "Messages grouped by how many segments they used",
      "xAxis": "Segments per message",
      "note": "31% of messages spill into 2+ segments — but they account for 54% of your billable segments. Trim long templates to cut cost."
    },
    "encodingSplit": {
      "title": "Why messages split",
      "subtitle": "Character encoding",
      "legend": "{{count}} · {{pct}}%",
      "gsm7": "GSM-7",
      "gsm7Avg": "avg 1.2 seg · 160 chars per segment",
      "unicode": "Unicode",
      "unicodeAvg": "avg 2.4 seg · 70 chars per segment",
      "note": "One emoji or curly quote flips a message to Unicode — capacity drops 160 → 70 chars. Clearing them from your top 3 templates saves ≈ 620 segments/mo (~$4.90)."
    },
    "templateCosts": {
      "title": "Messages by template",
      "subtitle": "Outbound SMS · sorted by estimated cost",
      "error": "Couldn't load templates",
      "columns": {
        "template": "Template",
        "sent": "Sent",
        "avgSeg": "Avg seg",
        "totalSeg": "Total seg",
        "cost": "Est. cost"
      },
      "allTemplates": "All templates"
    },
    "emailMetrics": {
      "title": "Email",
      "subtitle": "Transactional & nurture email",
      "error": "Couldn't load email metrics",
      "sent": "Sent",
      "delivered": "Delivered",
      "openRate": "Open rate",
      "clickRate": "Click rate",
      "bounced": "Bounced",
      "spamRate": "Spam rate"
    },
    "messagingBilling": {
      "title": "Usage & billing",
      "subtitle": "Estimated charges this cycle · resets Jul 1",
      "error": "Couldn't load billing",
      "note": "Estimated — final invoice may vary.",
      "columns": {
        "channel": "Channel",
        "volume": "Volume",
        "rate": "Rate",
        "charge": "Est. charge"
      },
      "rows": {
        "outboundSms": "Outbound SMS segments",
        "inboundSms": "Inbound SMS segments",
        "mms": "MMS",
        "total": "Estimated total"
      }
    },
    "costByAgent": {
      "title": "Cost by agent",
      "subtitle": "Outbound SMS attribution · this cycle",
      "error": "Couldn't load attribution",
      "columns": {
        "agent": "Agent",
        "messages": "Messages",
        "segments": "Segments",
        "cost": "Est. cost"
      },
      "moreAgents": "{{count}} more agents",
      "allAgents": "All {{count}} agents"
    },
    "activity": {
      "kpi": {
        "activeNow": "Active now",
        "avgActiveTime": "Avg active time",
        "avgFirstLogin": "Avg first login",
        "calls": "Calls",
        "quotes": "Quotes"
      },
      "notes": {
        "offlineIdle": "4 offline or idle",
        "perAgentDay": "per agent · per day",
        "teamPeriod": "team · this period",
        "acrossTeam": "across the team"
      }
    },
    "actionsByHour": {
      "title": "Actions by hour",
      "subtitle": "Calls, SMS, quotes and edits · today",
      "peak": "Peak: 11 AM – 12 PM",
      "error": "Couldn't load actions by hour"
    },
    "agentActivity": {
      "title": "Agent activity",
      "subtitle": "{{count}} working days",
      "exportCsv": "Export CSV",
      "error": "Couldn't load agent activity",
      "note": "Status is live; all other columns cover the selected period. Per-action audit log lives in Settings → Security.",
      "moreAgents": "{{count}} more agents",
      "allAgents": "All {{count}} agents",
      "status": {
        "online": "Online",
        "idle": "Idle",
        "offline": "Offline"
      },
      "columns": {
        "agent": "Agent",
        "now": "Now",
        "avgLogin": "Avg login",
        "avgLastActive": "Avg last active",
        "activeTime": "Active time",
        "avgDay": "Avg / day",
        "days": "Days",
        "calls": "Calls",
        "sms": "SMS",
        "quotes": "Quotes",
        "tasks": "Tasks"
      }
    },
    "period": {
      "today": "Today",
      "7d": "7d",
      "30d": "30d",
      "qtd": "QTD",
      "ytd": "YTD",
      "custom": "Custom"
    },
    "tabs": {
      "overview": "Overview",
      "sales": "Sales",
      "sources": "Sources",
      "financials": "Financials",
      "calls": "Calls",
      "messaging": "Messaging",
      "activity": "Activity"
    },
    "sections": {
      "overview": {
        "title": "Overview",
        "description": "Headline numbers for the period"
      },
      "sales": {
        "title": "Sales",
        "description": "Performance by agent"
      },
      "sources": {
        "title": "Sources",
        "description": "Where leads come from and what they return"
      },
      "financials": {
        "title": "Financials",
        "description": "Where the money is"
      },
      "calls": {
        "title": "Calls",
        "description": "Voice usage & performance"
      },
      "messaging": {
        "title": "Messaging",
        "description": "SMS and email activity"
      },
      "activity": {
        "title": "Activity",
        "description": "Who's working, and when"
      }
    },
    "wasteBlocked": {
      "title": "Waste blocked",
      "subtitle": "Sends refused because the number is already known bad · this billing cycle, since {{date}}",
      "error": "Couldn't load blocked sends",
      "stats": {
        "saved": "Saved this cycle",
        "blocked": "Sends blocked",
        "rate": "Of attempts blocked"
      },
      "columns": {
        "reason": "Reason",
        "onList": "Numbers on list",
        "blocked": "Sends blocked",
        "saved": "Saved"
      },
      "total": "Total",
      "nothingBlocked": "Nothing blocked this cycle — every number attempted was clear.",
      "insight": "Without the filter, about {{errorRate}} of this cycle's sends would have failed: delivery would sit at {{without}} instead of {{with}}.",
      "optOuts_one": "{{count, number}} of them was to a number that had replied STOP.",
      "optOuts_other": "{{count, number}} of them were to numbers that had replied STOP.",
      "lifetime": "{{saved}} saved since {{date}} · {{blocked}} sends blocked in total"
    }
  },
  "automations": {
    "columns": {
      "name": "Name",
      "email": "Email",
      "sms": "SMS",
      "appliesTo": "Applies To",
      "step": "Step",
      "gap": "Gap",
      "status": "Status",
      "lastUpdated": "Last Updated"
    },
    "gap": "{{days}}d, {{hours}}h, {{minutes}}m",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "appliesTo": {
      "total": "Total {{count}}:",
      "all": "All Users",
      "user": "User",
      "more": "+{{count}}"
    },
    "recipient": {
      "customer": "Customers",
      "carrier": "Carriers",
      "user": "Users",
      "custom": "Custom"
    },
    "triggers": {
      "leadCreated": "Lead Created",
      "quoteCreated": "Quote Created",
      "orderCreated": "Order Created",
      "orderDispatched": "Order Dispatched",
      "pickedUp": "Picked Up",
      "delivered": "Delivered",
      "orderCanceled": "Order Canceled",
      "contractSigned": "Contract Signed",
      "carrierRequestCreated": "Carrier Request Created",
      "pickupUpcoming": "Pickup Upcoming",
      "deliveryUpcoming": "Delivery Upcoming"
    },
    "toolbar": {
      "filters": "Filters",
      "allStatus": "All Status",
      "active": "Active",
      "inactive": "Inactive",
      "allTriggers": "All Triggers",
      "triggerEvent": "Trigger Event",
      "newAutomation": "New Automation",
      "createSoon": "Automation builder is coming soon"
    },
    "actions": {
      "menu": "Automation actions",
      "edit": "Edit",
      "delete": "Delete"
    },
    "delete": {
      "title": "Delete automation",
      "description": "Are you sure you want to delete \"{{name}}\"? This can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete",
      "success": "Automation deleted"
    },
    "form": {
      "createTitle": "New Status Automation",
      "editTitle": "Status Automation",
      "create": "Create",
      "save": "Save",
      "cancel": "Cancel",
      "close": "Close",
      "sections": {
        "trigger": "Trigger",
        "message": "Message",
        "timing": "Timing",
        "delivery": "Delivery protection"
      },
      "fields": {
        "name": "Name",
        "status": "Status",
        "step": "Step",
        "archiveOn": "Archive on",
        "emailTemplate": "Email template",
        "smsTemplate": "SMS template",
        "fromEmail": "From email",
        "replyTo": "Reply-to",
        "fromNumber": "From number",
        "delay": "Delay",
        "sendWindow": "Send window",
        "appliesTo": "Applies to",
        "assignTo": "Assign to"
      },
      "placeholders": {
        "name": "After quoted · Day 1",
        "select": "Select",
        "selectTemplate": "Search templates",
        "addUser": "Add user",
        "addSource": "Add source",
        "defaultUsers": "Default to all active users",
        "defaultSources": "Default to all active lead sources"
      },
      "archiveOn": {
        "exception": "Exception",
        "replied": "Replied",
        "converted": "Converted",
        "never": "Never"
      },
      "senderEmail": {
        "user_email": "User email",
        "org_email": "Company email",
        "platform": "Platform"
      },
      "senderNumber": {
        "user_phone": "User phone",
        "org_number": "Company number"
      },
      "delay": {
        "day": "day",
        "hrs": "hrs",
        "min": "min"
      },
      "deliveryNote": "Pacing, spacing and daily limits are handled by TheCarGo — you can't blast all at once.",
      "createSuccess": "Automation created",
      "updateSuccess": "Automation updated",
      "saveError": "Couldn't save the automation"
    },
    "view": {
      "sendImmediately": "Send immediately",
      "allUsers": "All active users",
      "allSources": "All active lead sources"
    }
  },
  "home": {
    "header": {
      "greeting": "Good morning, {{name}}",
      "greetingNoName": "Good morning",
      "itemsDue": "{{time}} · {{count}} items need you today"
    },
    "scope": {
      "pipeline": "My pipeline",
      "company": "Company"
    },
    "actionQueue": {
      "title": "ACTION QUEUE",
      "subtitle": "— start your day here",
      "viewAll": "View all",
      "more": "+ {{count}} more",
      "section": {
        "needsAttention": "Needs attention",
        "readyToShip": "Ready to ship today",
        "waitingOnCustomer": "Waiting on customer"
      },
      "meta": {
        "needsAttention": "items · oldest {{oldest}}",
        "readyToShip": "{{posted}} posted · {{notPosted}} not posted",
        "waitingOnCustomer": "{{followUp}} follow-up · {{deposit}} deposit"
      },
      "badge": {
        "today": "Today"
      },
      "empty": "Nothing here"
    },
    "pipeline": {
      "title": "PIPELINE",
      "subtitle": "this week · vs last week",
      "filterHint": "Click any stage to filter",
      "range": {
        "sevenDays": "7d",
        "thirtyDays": "30d",
        "qtd": "QTD"
      },
      "stage": {
        "newQuotes": "New quotes",
        "active": "Active",
        "scheduled": "Scheduled",
        "posted": "Posted",
        "dispatched": "Dispatched",
        "completed": "Completed"
      },
      "footer": {
        "conversion": "Quote → Order",
        "avgDispatch": "Avg time to dispatch",
        "avgMargin": "Avg margin"
      },
      "empty": "No pipeline data"
    },
    "recentActivity": {
      "title": "RECENT ACTIVITY",
      "subtitle": "last 24h",
      "viewAll": "View all activity →",
      "segment": {
        "all": "All",
        "quotes": "Quotes",
        "orders": "Orders",
        "payments": "Payments"
      },
      "summary": {
        "create": "created {{resource}}",
        "update": "updated {{resource}}",
        "delete": "deleted {{resource}}"
      },
      "meta": "{{service}} · {{fields}}",
      "systemActor": "System",
      "empty": "No recent activity"
    },
    "today": {
      "title": "TODAY",
      "badge": {
        "pickup": "Pickup",
        "call": "Call",
        "deposit": "Deposit",
        "dropoff": "Drop-off",
        "followUp": "Follow up"
      },
      "empty": "Nothing scheduled today",
      "emptyHint": "Your day is clear — nothing to act on right now.",
      "allDay": "All day"
    },
    "monthlyTargets": {
      "title": "MONTHLY TARGETS",
      "editTargets": "Edit targets",
      "editModal": {
        "title": "Edit monthly targets",
        "subtitle": "Set Charged and Dispatched targets for each month of {{year}}",
        "yearLabel": "Year:",
        "annualTotal": "Annual total:",
        "applyRowToAll": "Apply current row to all",
        "currentPill": "Current",
        "columns": {
          "month": "MONTH",
          "charged": "CHARGED TARGET",
          "dispatched": "DISPATCHED TARGET"
        },
        "footer": {
          "scope": "Targets apply to the entire team",
          "note": "Per-agent targets coming in a future release"
        },
        "cancel": "Cancel",
        "save": "Save changes",
        "saveSuccess": "Targets saved",
        "saveError": "Failed to save targets"
      },
      "month": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      },
      "targetLabel": "target {{value}}",
      "ofLabel": "of {{value}}",
      "range": {
        "thisMonth": "This month",
        "lastMonth": "Last month",
        "earlier": "Earlier"
      },
      "earlier": {
        "pickAMonth": "PICK A MONTH",
        "lastSixMonths": "Last 6 months",
        "clear": "Clear"
      },
      "series": {
        "charged": "Charged",
        "dispatched": "Dispatched"
      },
      "chart": {
        "title": "Daily progress · {{month}}",
        "titleGeneric": "Daily progress"
      },
      "stat": {
        "highestDay": "HIGHEST DAY",
        "lowestDay": "LOWEST DAY",
        "dailyAverage": "DAILY AVERAGE"
      }
    },
    "performance": {
      "title": "PERFORMANCE",
      "pickRange": "Select a date range to view performance.",
      "range": {
        "today": "Today",
        "sevenDays": "7d",
        "thirtyDays": "30d",
        "mtd": "MTD",
        "qtd": "QTD",
        "custom": "Custom",
        "customPlaceholder": "Pick dates"
      },
      "metric": {
        "quoted": "Quoted",
        "dispatched": "Dispatched",
        "dispatchRate": "Dispatch rate",
        "avgMargin": "Avg margin / order",
        "paymentsCollected": "Payments collected"
      },
      "chart": {
        "title": "Daily progress · Last 7 days"
      },
      "chartType": {
        "bar": "Bar",
        "line": "Line"
      },
      "series": {
        "charged": "Charged",
        "dispatched": "Dispatched"
      },
      "stat": {
        "highestDay": "HIGHEST DAY",
        "lowestDay": "LOWEST DAY",
        "dailyAverage": "DAILY AVERAGE"
      },
      "empty": "No performance data"
    }
  },
  "logout": {
    "success": "You've been signed out.",
    "confirm": {
      "title": "Log out?",
      "description": "You'll be signed out of your account on this device.",
      "cancel": "Cancel",
      "confirm": "Log out"
    }
  },
  "forbidden": {
    "title": "You don't have access",
    "description": "Your role doesn't allow you to view this page. Ask an admin if you think this is a mistake.",
    "goHome": "Go to dashboard"
  },
  "userDropdown": {
    "currentOwner": "Current owner",
    "reassignTo": "Reassign to",
    "typeAName": "Type a name",
    "noResults": "No users found",
    "clearOwner": "Clear owner",
    "allUsers": "All Users",
    "meLabel": "{{name}} (me)"
  },
  "select": {
    "placeholder": "Select...",
    "empty": "No options"
  },
  "multiSelect": {
    "searchPlaceholder": "Search...",
    "noResults": "No results",
    "toggleOptions": "Toggle options",
    "removeItem": "Remove {{label}}",
    "createOption": "Create \"{{name}}\"",
    "createLabel": "Create"
  },
  "combobox": {
    "noResults": "No results",
    "noResultsHint": "Try a different search term",
    "loading": "Loading…",
    "typeToSearch": "Type at least {{min}} letters to search",
    "toggleOptions": "Toggle options"
  },
  "datePicker": {
    "placeholder": "Pick a date",
    "rangePlaceholder": "Pick a date range",
    "ariaLabel": "Open date picker",
    "rangeAriaLabel": "Open date range picker",
    "cancel": "Cancel",
    "apply": "Apply",
    "today": "Today",
    "monday": "Monday"
  },
  "archiveDropdown": {
    "trigger": "Archive",
    "title": "Select a reason to archive",
    "reasons": {
      "alreadyShipped": "Already shipped",
      "changeOfMind": "Change of mind",
      "canceled": "Canceled",
      "customerDeclined": "Customer declined",
      "unsubscribed": "Unsubscribed",
      "wrongNumber": "Wrong number",
      "duplicate": "Duplicate",
      "wentWithAnotherBroker": "Went with another broker",
      "other": "Other"
    }
  },
  "shipmentToolbar": {
    "create": {
      "success": "Saved",
      "error": "Failed to save",
      "noteSuccess": "Note added",
      "taskSuccess": "Task created",
      "contractSuccess": "Contract sent",
      "smsSuccess": "Message sent",
      "emailSuccess": "Email sent",
      "fileSuccess": "File uploaded",
      "paymentSuccess": "Payment created",
      "templateError": "Couldn't load the template",
      "customerEmailMissing": "Customer has no email address. Add an email to the customer, then send the contract."
    },
    "update": {
      "success": "Task updated",
      "error": "Failed to update task"
    }
  },
  "table": {
    "showPerPage": "Show per page",
    "showing": "Showing",
    "of": "of",
    "save": "Save",
    "saving": "Saving…",
    "open": "Open",
    "more": "+{{count}} more",
    "requests": "Requests",
    "total": "Total {{count}}:",
    "tariff": {
      "updateSuccess": "Tariff updated",
      "updateError": "Failed to update tariff",
      "activateError": "Couldn't activate lead",
      "convertedToQuote": "Converted to quote {{code}}",
      "convertedToOrder": "Converted to order {{code}}",
      "viewQuote": "View"
    },
    "marketRate": {
      "title": "Market Rate",
      "open": "Open market rate",
      "close": "Close",
      "low": "Low",
      "recommended": "Recommended",
      "high": "High",
      "perMi": "${{rate}}/mi",
      "confidence": "{{percent}}% confidence",
      "distance": "{{miles}} mi",
      "dispatchedOn": "Yes on {{date}}",
      "useRate": "Use {{price}}",
      "use": "Use",
      "empty": "No comparable rates yet",
      "fetchError": "Could not load suggested price",
      "footer": "Rates exclude broker fee · Canceled loads shown but excluded from average",
      "sampleSize_one": "{{count}} comparable load",
      "sampleSize_other": "{{count}} comparable loads",
      "referenceDistance": "Median distance {{miles}} mi",
      "statuses": {
        "delivered": "Delivered",
        "in_transit": "In transit",
        "picked_up": "Picked up",
        "dispatched": "Dispatched",
        "canceled": "Canceled",
        "listed": "Listed"
      },
      "columns": {
        "vehicle": "Type",
        "route": "Route",
        "distance": "Dist",
        "listed": "Listed",
        "price": "Price",
        "status": "Status",
        "dispatched": "Dispatched",
        "actualPrice": "Price"
      }
    },
    "columns": {
      "id": "ID",
      "created": "Created",
      "note": "Note",
      "owner": "Owner",
      "customer": "Customer",
      "contact": "Contact",
      "quotes": "Quotes",
      "orders": "Orders",
      "source": "Source",
      "quotePortal": "Quote Portal",
      "portal": "Portal",
      "vehicle": "Vehicle",
      "originDestination": "Origin > Destination",
      "tariff": "Tariff",
      "shipDate": "Ship Date",
      "updated": "Updated",
      "puDel": "PU / DEL"
    },
    "note": {
      "addNote": "Add note",
      "cancel": "Cancel",
      "addSuccess": "Note added",
      "addError": "Failed to add note"
    },
    "empty": {
      "initialTitle": "No data yet",
      "initialDescription": "Records will appear here once available.",
      "filteredTitle": "No results found",
      "filteredDescription": "Try adjusting your search or filters."
    },
    "pin": {
      "toggle": "Pin column",
      "left": "Pin to left",
      "right": "Pin to right",
      "unpin": "Unpin"
    },
    "settings": {
      "label": "Table settings",
      "reset": "Reset to defaults"
    },
    "density": {
      "title": "Row density",
      "options": {
        "large": "Large",
        "medium": "Medium",
        "small": "Small"
      }
    },
    "appearance": {
      "title": "Appearance",
      "cellDividers": "Cell dividers",
      "rowDividers": "Row dividers",
      "stripedRows": "Striped rows"
    }
  },
  "commentTool": {
    "close": "Close"
  },
  "detailSidebar": {
    "openDetail": "Open detail page",
    "close": "Close",
    "tabs": {
      "details": "Details",
      "chat": "Chat",
      "activity": "Activity",
      "loadboard": "Loadboard"
    },
    "chatCall": "Call",
    "chatEmpty": "No chat yet",
    "notes": {
      "existing": "Existing notes",
      "toggleGroup": "Toggle notes",
      "moreNotes_one": "{{count}} more note",
      "moreNotes_other": "{{count}} more notes",
      "showMore_one": "Show {{count}} more note",
      "showMore_other": "Show {{count}} more notes"
    },
    "tasks": {
      "active": "Active Task",
      "toggleGroup": "Toggle tasks",
      "moreTasks_one": "{{count}} more task",
      "moreTasks_other": "{{count}} more tasks",
      "showMore_one": "Show {{count}} more task",
      "showMore_other": "Show {{count}} more tasks"
    },
    "files": {
      "title": "Files",
      "toggleGroup": "Toggle files",
      "moreFiles_one": "{{count}} more file",
      "moreFiles_other": "{{count}} more files",
      "showMore_one": "Show {{count}} more file",
      "showMore_other": "Show {{count}} more files"
    },
    "carrier": {
      "title": "Carrier",
      "authorized": "FMCSA Authorized",
      "mc": "MC {{number}}",
      "dot": "DOT {{number}}",
      "trucks_one": "{{count}} truck",
      "trucks_other": "{{count}} trucks",
      "drivers_one": "{{count}} driver",
      "drivers_other": "{{count}} drivers",
      "insurance": "Insurance",
      "insuranceActive": "Active · {{days}}d",
      "insuranceExpired": "Expired",
      "openInsurance": "Open",
      "expDate": "Exp date",
      "autoLiability": "Auto Liability",
      "cargo": "Cargo",
      "deductible": "{{amount}} Deduct"
    },
    "loadboard": {
      "title": "Loadboard",
      "central": "Central Dispatch",
      "super": "Super Dispatch",
      "postedAgo": "Posted {{time}}",
      "dispatchedAgo": "Dispatched {{time}}",
      "notPosted": "Not posted",
      "remove": "Remove",
      "removeAll": "Remove All",
      "cancelOrder": "Cancel Order",
      "updateOrder": "Update Order",
      "updateOrderConfirm": {
        "title": "Update the posted order?",
        "description": "This will push the shipment's current details to the live Super Dispatch order, replacing the previously posted info. Make sure the shipment is updated before continuing.",
        "cancel": "Cancel",
        "confirm": "Update Order"
      },
      "updateOrderSuccess": "Order updated on Super Dispatch",
      "updateOrderError": "Couldn't update the order",
      "updateOrderNoOrder": "No Super Dispatch order to update",
      "sdUnreachable": "Couldn't reach Super Dispatch. Try again.",
      "cancelOffer": "Cancel Offer",
      "cancelOfferConfirm": {
        "title": "Cancel the offer?",
        "description": "This will cancel the offer sent to the carrier on Super Dispatch. The carrier won't be able to sign this order, and you'll need to accept another request or repost the load.",
        "cancel": "Keep Offer",
        "confirm": "Cancel Offer"
      },
      "cancelOfferNoRequest": "No active Super Dispatch offer to cancel",
      "cancelOfferSuccess": "Offer cancelled — the order stays posted",
      "cancelOfferError": "Couldn't cancel the offer",
      "sdNotConnected": "Connect Super Dispatch in Loadboards settings",
      "orderActions": "Order actions",
      "cancelSuccess": "Order cancelled",
      "cancelError": "Couldn't cancel the order",
      "noneConnected": "No loadboards connected",
      "cd": {
        "cancel": "Cancel",
        "reconnect": "Reconnect",
        "noDispatchId": "This dispatch has no Central Dispatch booking id",
        "recordUnavailable": "Couldn't read this dispatch from Central Dispatch",
        "updateDispatch": "Update Dispatch",
        "updateDates": "Update Dates",
        "assignDrivers": "Assign Drivers",
        "paymentStatus": "Payment Status",
        "paymentStatuses": {
          "unpaid": "Unpaid",
          "partiallyPaid": "Partially paid",
          "fullyPaid": "Fully paid",
          "clear": "Not set"
        },
        "fields": {
          "unset": "Not set",
          "priceTotal": "Carrier Pay",
          "codAmount": "COD Amount",
          "codPaymentMethod": "COD Method",
          "codPaymentLocation": "COD Location",
          "balanceAmount": "Balance Amount",
          "balancePaymentMethod": "Balance Method",
          "balanceTermsBeginOn": "Terms Begin On",
          "balancePaymentTime": "Payment Time",
          "releaseNotes": "Release Notes",
          "externalOrderId": "Order Reference",
          "requiresDriverVerification": "Driver must verify identity at pickup"
        },
        "updateDialog": {
          "title": "Update dispatch",
          "description": "Changes the money and terms on the booked Central Dispatch load. Only the fields you edit are sent — everything else keeps what CD already has.",
          "balanceHint": "Method, terms and timing only apply while the balance is above zero.",
          "submit": "Save Changes"
        },
        "datesDialog": {
          "title": "Update dates",
          "description": "Moves one pickup or delivery date. Dates belong to a vehicle, and Central Dispatch requires a reason for every change.",
          "vehicle": "Vehicle",
          "dateType": "Date",
          "date": "New date",
          "reason": "Reason",
          "reasonPlaceholder": "Pick a reason",
          "notes": "Notes",
          "asyncHint": "Central Dispatch applies the change on its own schedule, so it may take a moment to appear.",
          "noVehicles": "Central Dispatch reported no vehicles on this dispatch",
          "submit": "Send Change"
        },
        "driversDialog": {
          "title": "Assign drivers",
          "description": "Attaches or detaches the booked carrier's drivers on Central Dispatch.",
          "current": "On this dispatch",
          "remove": "Remove",
          "removeIds": "Driver IDs to remove",
          "add": "Driver IDs to add",
          "idPlaceholder": "One ID per line",
          "hint": "These are Central Dispatch user IDs belonging to the booked carrier — not carrier IDs, and not TheCargo drivers. Central Dispatch has no endpoint that lists them, so they have to be copied from CD.",
          "submit": "Save Drivers"
        },
        "dateTypes": {
          "estimatedPickup": "Estimated pickup",
          "shipperRequestedPickup": "Requested pickup",
          "carrierEstimatedPickup": "Carrier's estimated pickup",
          "actualPickup": "Actual pickup",
          "estimatedDropoff": "Estimated delivery",
          "shipperRequestedDropoff": "Requested delivery",
          "carrierEstimatedDropoff": "Carrier's estimated delivery",
          "actualDropoff": "Actual delivery"
        },
        "updateSuccess": "Dispatch updated on Central Dispatch",
        "updateError": "Couldn't update the dispatch",
        "datesSuccess": "Date change sent to Central Dispatch",
        "datesError": "Couldn't send the date change",
        "driversSuccess": "Drivers updated on Central Dispatch",
        "driversError": "Couldn't update the drivers",
        "paymentStatusSuccess": "Payment status updated on Central Dispatch",
        "paymentStatusError": "Couldn't update the payment status",
        "errors": {
          "notConnected": "Central Dispatch isn't connected — reconnect it in Loadboards settings",
          "permission": "This Central Dispatch connection can't manage dispatches. Reconnect CD and grant the Dispatch permission.",
          "mismatch": "This dispatch doesn't belong to the order anymore. Reload and try again.",
          "conflict": "The dispatch changed on Central Dispatch while you were editing. Reopen and try again.",
          "refused": "Central Dispatch refused the change",
          "upstream": "Couldn't reach Central Dispatch. Try again."
        }
      }
    },
    "showRoute": "Show Route",
    "hideRoute": "Hide Route",
    "activityFilters": {
      "all": "All",
      "notes": "Notes",
      "tasks": "Tasks",
      "sms": "SMS",
      "email": "Email",
      "files": "Files",
      "payments": "Payments"
    },
    "feed": {
      "today": "Today",
      "yesterday": "Yesterday",
      "system": "System",
      "addedNote": "added a note",
      "createdTask": "created a task",
      "completedTask": "completed a task",
      "sentSms": "sent an SMS",
      "repliedSms": "replied via SMS",
      "sentEmail": "sent an email",
      "receivedEmail": "received an email",
      "uploadedFile": "uploaded a file",
      "recordedPayment": "recorded a payment",
      "sentContract": "sent a contract",
      "tagAutomation": "Automation",
      "tagInbound": "Inbound",
      "income": "Income",
      "expense": "Expense",
      "emailSubject": "Subject: {{subject}}",
      "emailMeta": {
        "to": "To",
        "from": "From"
      },
      "fileView": "View",
      "fileDownload": "Download",
      "showMore": "Show more",
      "showLess": "Show less",
      "paymentMeta": {
        "method": "Method",
        "status": "Status",
        "reference": "Reference"
      },
      "taskMeta": {
        "status": "Status",
        "due": "Due",
        "priority": "Priority",
        "assignee": "Assignee"
      }
    },
    "postedToCd": "Posted to CD",
    "postedToSd": "Posted to SD",
    "postedToCdSd": "Posted to CD + SD",
    "markAsPickedup": "Mark as Pickedup",
    "markAsCompleted": "Mark as Completed"
  },
  "detailToolbar": {
    "minimize": "Minimize",
    "edit": "Edit",
    "close": "Close",
    "previous": "Previous",
    "next": "Next",
    "copyHint": "Click to copy",
    "idCopied": "Copied {{id}}",
    "requests": "Requests",
    "postToLB": "Post to LB",
    "postOptions": {
      "cd": "Post to CD",
      "slb": "Post to SLB",
      "both": "Post to CD & SLB"
    },
    "postSuccess": "Posted to loadboard",
    "postError": "Failed to post to loadboard",
    "repostSuccess": "Updated on loadboard",
    "repostError": "Failed to update on loadboard",
    "deleteSuccess": "Removed from loadboard",
    "deleteError": "Failed to remove from loadboard",
    "postReauthRequired": "Connect to Central Dispatch to continue",
    "dispatch": "Dispatch",
    "dispatchViaCd": "Dispatch via CD",
    "uploadToLB": "Upload to LB",
    "uploadToLBs": "Update to LBs",
    "deleteFromLB": "Delete from LB",
    "deleteFromLBs": "Delete from LBs",
    "remove": "Remove",
    "repost": "Repost",
    "tracking": "Tracking",
    "booking": "Booking",
    "archive": "Archive",
    "more": "More options",
    "reassignSuccess": "Reassigned successfully",
    "reassignError": "Failed to reassign",
    "reassignConfirm": {
      "title": "Reassign owner?",
      "description": "Reassign this shipment to {{name}}?",
      "cancel": "Cancel",
      "confirm": "Reassign"
    },
    "duplicateSuccess": "Shipment duplicated",
    "duplicateError": "Failed to duplicate shipment",
    "duplicateView": "View",
    "moreOptions": {
      "activityHistory": "Activity History",
      "duplicate": "Duplicate",
      "copyBookingLink": "Copy booking link",
      "copyTrackingLink": "Copy tracking link",
      "backToQuotes": "Back to Quotes",
      "markAs": "Mark as"
    },
    "backToQuote": {
      "success": "Order moved back to Quotes",
      "error": "Failed to move the order back to Quotes"
    },
    "markAsOptions": {
      "order": "New Order",
      "posted": "Posted",
      "notSigned": "Not Signed",
      "dispatched": "Dispatched",
      "issue": "Issue",
      "pickedUp": "Pickedup",
      "completed": "Completed",
      "onHold": "Hold",
      "archived": "Archived",
      "quote": "New Today",
      "followUp": "Follow up",
      "ongoing": "Active",
      "upcoming": "Scheduled"
    },
    "markAsSuccess": "Status updated",
    "markAsError": "Failed to update status",
    "archiveOptions": {
      "history": "History",
      "orderTracking": "Order Tracking",
      "backToQuotes": "Back to Quotes",
      "updateSLB": "Update Order on SLB",
      "directDispatch": "Direct Dispatch",
      "putOnHold": "Put on Hold",
      "duplicate": "Duplicate",
      "cancelCD": "Cancel Order via CD"
    }
  },
  "orderDispatch": {
    "toast": {
      "dispatching": "Dispatching to carrier…",
      "success": "Carrier dispatched",
      "error": "Could not dispatch carrier"
    }
  },
  "orderEdit": {
    "toast": {
      "saving": "Saving changes…",
      "success": "Order updated",
      "error": "Could not save changes"
    },
    "view": {
      "title": "Details",
      "cancel": "Cancel",
      "save": "Save Changes"
    },
    "customer": {
      "title": "Customer"
    }
  },
  "orderCreate": {
    "previewRoad": "Preview route",
    "priceCheck": {
      "locationRequired": "Origin and destination are required for price check",
      "vehiclesRequired": "At least one valid vehicle is required for price check",
      "originRequired": "Origin city and 2-letter state are required",
      "destinationRequired": "Destination city and 2-letter state are required"
    },
    "page": {
      "title": "New Order",
      "quoteTitle": "New Quote",
      "editTitle": "Edit Order",
      "editQuoteTitle": "Edit Quote",
      "editLeadTitle": "Edit Lead",
      "dispatchTitle": "Dispatch to Carrier",
      "dispatchNow": "Dispatch Now",
      "dispatchCarrierSearchPlaceholder": "Search by Name, MC, or DOT",
      "dispatchCarrierResultsHint": "Select one to see the details",
      "dispatchCarrierResultsEmpty": "No carriers found",
      "dispatchCarrierResultsError": "Failed to load carriers. Try again.",
      "dispatchCarrierEmptyTitle": "Find Any Carrier",
      "dispatchCarrierEmptyDescription": "Find any carrier Type a name, MC, or DOT number — we check Central Dispatch, Super Dispatch, and FMCSA at once.",
      "carrierInsuranceLabel": "Insurance",
      "carrierInsuranceUploadTitle": "Upload insurance certificate",
      "carrierInsuranceUploadDescription": "AI will auto-fill policy, dates, and amounts",
      "carrierInsuranceUploadBrowse": "Browse files",
      "carrierInsuranceUploadHint": "PDF or image · max 10MB",
      "carrierDetailViewFull": "View full details",
      "dispatchSelectCarrierRequired": "Select a carrier to dispatch",
      "carrierDetailTitle": "Carrier Information",
      "carrierDetailSelect": "Select Carrier",
      "carrierDetailCancel": "Cancel",
      "carrierDetailFoundIn": "Found in",
      "carrierDetailSourceCd": "Central Dispatch",
      "carrierDetailSourceSd": "Super Dispatch",
      "carrierDetailSourceFmcsa": "FMCSA",
      "carrierDetailFmcsaTitle": "FMCSA Snapshot",
      "carrierDetailFmcsaAuthorized": "Authorized",
      "carrierDetailFmcsaPulled": "Pulled from FMCSA",
      "carrierDetailFmcsaViewLink": "View on FMCSA",
      "carrierDetailFmcsaBusinessType": "Business type",
      "carrierDetailFmcsaUsdot": "USDOT#",
      "carrierDetailFmcsaMc": "MC#",
      "carrierDetailFmcsaAuthorizedFor": "Authorized For",
      "carrierDetailFmcsaMcs150": "MCS-150 Form Date",
      "carrierDetailFmcsaOutOfService": "Out of Service Date",
      "carrierDetailFmcsaInspections": "Inspections (24 mo)",
      "carrierDetailFmcsaVehicleOos": "Vehicle OOS Rate",
      "carrierDetailFmcsaDriverOos": "Driver OOS Rate",
      "carrierDetailFmcsaCrashes": "Crashes (24 mo)",
      "carrierDetailFmcsaInspectionsCaption": "Vehicle · Driver",
      "carrierDetailFmcsaCrashesCaption": "Fatal · Injury · Tow",
      "carrierDetailCdTitle": "Central Dispatch",
      "carrierDetailSdTitle": "Super Dispatch",
      "carrierDetailJoined": "Joined",
      "carrierDetailErrorTitle": "Couldn't load carrier",
      "carrierDetailErrorBody": "Try again or pick another carrier.",
      "carrierDetailNotAvailable": "—",
      "carrierDetailPowerUnits": "Power Units",
      "carrierDetailDrivers": "Drivers",
      "carrierDetailSelectedBadge": "Selected carrier",
      "customizeFields": "Customize Fields",
      "saveAndPost": "Save & Post to LB",
      "saveAndPostOptions": {
        "cd": "Save & Post to CD",
        "slb": "Save & Post to SLB",
        "both": "Save & Post to CD & SLB"
      },
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "toast": {
      "checkingCustomer": "Checking customer…",
      "creatingCustomer": "Creating customer…",
      "creatingShipment": "Creating shipment…",
      "success": "Order created",
      "error": "Could not create order",
      "quoteSuccess": "Quote created",
      "quoteError": "Could not create quote"
    },
    "convert": {
      "saving": "Converting to order…",
      "success": "Quote converted to order",
      "error": "Could not convert quote"
    },
    "terminal": {
      "saveError": "Could not save new terminal"
    },
    "tag": {
      "saveError": "Could not save new tag"
    },
    "customer": {
      "title": "Customer",
      "firstName": "First Name",
      "lastName": "Last Name",
      "company": "Company",
      "companyPhone": "Phone",
      "billingEmail": "Billing Email",
      "email": "Email",
      "email2": "Alternative Email",
      "phone": "Phone",
      "mobile": "Alternative Phone",
      "note": "Additional note",
      "moreDetails": "More details",
      "showLess": "Show less",
      "saveAsNewCustomer": "Save as new customer",
      "newCustomerBadge": "New customer",
      "placeholders": {
        "searchName": "Search by name",
        "searchEmail": "Search by email"
      }
    },
    "payment": {
      "title": "Payment",
      "priceCheck": "Price Check",
      "totalTariff": "Total Tariff",
      "deposit": "Deposit",
      "carrierFee": "Carrier Pay",
      "dueOnDelivery": "Due on Delivery",
      "balance": "Balance",
      "paymentMethod": "Payment Method",
      "terms": "Terms",
      "balanceMethod": "Balance Method",
      "balanceTime": "Balance Time",
      "balanceTermBegins": "Term Begins On",
      "paymentNote": "Payment note"
    },
    "shipment": {
      "title": "Shipment",
      "trailer": "Trailer",
      "source": "Source",
      "tags": "Tags",
      "shipDate": "Est. Ship Date",
      "pickupDate": "Est. Pickup Date",
      "deliveryDate": "Est. Delivery Date",
      "loadBoardNote": "Load Board Note",
      "customerNote": "Customer Note",
      "trailerOptions": {
        "OPEN": "Open",
        "ENCLOSED": "Enclosed",
        "DRIVE_AWAY": "Drive Away"
      },
      "sourceOptions": {
        "referral": "Referral",
        "direct": "Direct",
        "website": "Website"
      },
      "tagOptions": {
        "paid": "Paid",
        "urgent": "Urgent",
        "vip": "VIP"
      },
      "placeholders": {
        "trailer": "Select trailer"
      }
    },
    "dialog": {
      "title": "Create a New Order",
      "cancel": "Cancel",
      "create": "Create Order"
    },
    "details": {
      "title": "Details"
    },
    "vehicles": {
      "title": "Vehicle",
      "addVehicle": "Add vehicle",
      "addDisabledHint": "Fill in Year, Make, and Model first",
      "removeVehicle": "Remove vehicle",
      "rmv": "RMV",
      "invalidYear": "Enter a valid 4-digit year",
      "invalidVin": "VIN must be 17 characters",
      "modelRequired": "Model is required",
      "lookingUp": "Looking up…",
      "count_one": "{{count}} vehicle",
      "count_other": "{{count}} vehicles",
      "year": "Year",
      "make": "Make",
      "model": "Model",
      "inop": "INOP",
      "type": "Type",
      "typeAutoDetected": "Auto-detected — confirm",
      "lot": "Lot",
      "vin": "VIN",
      "placeholders": {
        "make": "Toyota",
        "model": "Camry"
      },
      "typeOptions": {
        "sedan": "Sedan",
        "suv": "SUV",
        "pickup": "Pickup",
        "van": "Van",
        "truck": "Truck",
        "motorcycle": "Motorcycle",
        "boat": "Boat",
        "rv": "RV",
        "atv": "ATV",
        "trailer": "Trailer",
        "heavy_equipment": "Heavy Equipment",
        "other": "Other"
      }
    },
    "location": {
      "routeTitle": "Route",
      "origin": {
        "title": "Origin",
        "address": "Pickup Address"
      },
      "destination": {
        "title": "Destination",
        "address": "Delivery Address"
      },
      "businessName": "Business Name",
      "city": "City",
      "state": "State",
      "zip": "Zip",
      "contact": "Contact",
      "phone": "Phone",
      "mobile": "Mobile",
      "additionalNote": "Additional note",
      "moreDetails": "More details",
      "type": "Type",
      "cityZipMismatch": "City might be wrong for zip code {{zip}}",
      "sameAsCustomer": "Same as Customer",
      "saveAsTerminal": "Save as new terminal",
      "saveAsContact": "Save as new contact",
      "newTerminalBadge": "New terminal",
      "newContactBadge": "New contact",
      "lookingUp": "Looking up…",
      "typeOptions": {
        "residential": "Residential",
        "business": "Business",
        "dealership": "Dealership",
        "auction": "Auction",
        "port": "Port",
        "terminal": "Terminal",
        "repo_yard": "Repo Yard",
        "military_base": "Military Base",
        "rental": "Rental",
        "other": "Other"
      },
      "typeAbbr": {
        "residential": "Res",
        "business": "Biz",
        "dealership": "Dlr",
        "auction": "Auc",
        "port": "Prt",
        "terminal": "Trm",
        "repo_yard": "Rpo",
        "military_base": "Mil",
        "rental": "Rntl",
        "other": "Othr"
      },
      "placeholders": {
        "businessName": "Search by business name",
        "zip": "Enter Zip",
        "type": "Select type"
      }
    }
  },
  "payment": {
    "title": "Payment",
    "priceTitle": "Price",
    "totalTariff": "Total Tariff",
    "deposit": "Deposit",
    "carrierFee": "Carrier Pay",
    "dueOnDelivery": "Due on Delivery",
    "balance": "Balance",
    "paidToCarrier": "Paid to Carrier",
    "editPayment": "Edit payment",
    "paymentMethod": "Payment Method",
    "terms": "Terms",
    "balanceMethod": "Balance Method",
    "balanceTime": "Balance Time",
    "balanceTermBegins": "Term Begins On",
    "paymentNote": "Payment note",
    "paymentNotePlaceholder": "Add a note for the carrier (e.g., 'Pay at delivery only')",
    "priceCheck": "Price Check",
    "samplePrice": "Sample Price",
    "cancel": "Cancel",
    "saveChanges": "Save Changes",
    "convertToQuote": "Convert to Quote"
  },
  "paymentOptions": {
    "method": {
      "cash": "Cash",
      "cashCertifiedFunds": "Cash/Certified Funds",
      "check": "Check",
      "comchek": "Comchek",
      "ach": "ACH",
      "creditCard": "Credit Card",
      "zelle": "Zelle",
      "other": "Other"
    },
    "terms": {
      "delivery": "Delivery",
      "pickup": "Pickup"
    },
    "balanceMethod": {
      "cash": "Cash",
      "certifiedFunds": "Certified Funds",
      "companyCheck": "Company Check",
      "comchek": "Comchek",
      "tch": "TCH"
    },
    "balanceTime": {
      "immediately": "Immediately",
      "twoBusinessDaysQuickPay": "2 Business days (Quick Pay)",
      "fiveBusinessDays": "5 Business days",
      "tenBusinessDays": "10 Business days",
      "fifteenBusinessDays": "15 Business days",
      "thirtyBusinessDays": "30 Business days"
    },
    "balanceTermBegins": {
      "pickup": "Pickup",
      "delivery": "Delivery",
      "receivingSignedBol": "Receiving a Signed BOL"
    }
  },
  "paymentSettlement": {
    "codCollect": "Carrier collects {{amount}} COD via {{method}} at {{terms}}",
    "codCollectFallback": "Carrier collects {{amount}} COD",
    "codNoBalance": "Settlement: even after delivery — no balance owed",
    "paidUpfront": "Customer paid in full upfront — no COD to collect",
    "settlementWeOwe": "Settlement: You will pay the carrier {{amount}} via {{method}} within {{time}} of {{trigger}}",
    "settlementCarrierOwes": "Settlement: The carrier will pay you {{amount}} via {{method}} {{time}} of {{trigger}}",
    "settlementMissing": "Settlement: choose method and timing to settle the balance"
  },
  "timezones": {
    "eastern": "Eastern Time (ET)",
    "central": "Central Time (CT)",
    "mountain": "Mountain Time (MT)",
    "pacific": "Pacific Time (PT)",
    "alaska": "Alaska Time (AKT)",
    "hawaii": "Hawaii Time (HST)"
  },
  "toolbar": {
    "searchLeads": "Search leads",
    "searchQuotes": "Search quotes",
    "searchOrders": "Search orders",
    "searchCustomers": "Search name, phone or email",
    "searchCarriers": "Search name, phone or email",
    "newCustomer": "New Customer",
    "filters": "Filters",
    "addFilter": "Add filter",
    "applyFilter": "Apply Filter",
    "cancel": "Cancel",
    "clear": "Clear",
    "clearAll": "Clear all filters",
    "searchByCityOrZip": "Search by City or ZIP",
    "searchSources": "Search sources",
    "filterOptions": {
      "firstShip": "First Avail Date",
      "lastEdited": "Last Edited",
      "leadDate": "Lead Date",
      "quoteDate": "Quote Date",
      "orderDate": "Order Date",
      "convertedDate": "Converted",
      "dispatchedDate": "Dispatched Date",
      "pickedUpDate": "Picked Up",
      "deliveredDate": "Delivered",
      "taskDeadline": "Task Deadline",
      "timeZone": "Time Zone",
      "pickupState": "Pickup State",
      "deliveryState": "Delivery State",
      "sources": "Sources",
      "statuses": "Statuses"
    },
    "filterPlaceholders": {
      "timezones": "Select time zone",
      "pickupStates": "Search by State",
      "deliveryStates": "Search by State",
      "sources": "Search sources",
      "statuses": "Select statuses"
    },
    "filterChipOverflow": "+{{count}}",
    "updatingResults": "Updating…",
    "removeFilter": "Remove {{label}} filter",
    "selectedCount": "{{count}} selected",
    "actions": {
      "sms": "SMS",
      "email": "Email",
      "reassign": "Reassign",
      "autoDial": "Power Dial",
      "archive": "Archive",
      "comingSoon": "Coming soon",
      "markAs": "Mark As",
      "more": "More actions"
    },
    "newLead": "+ New Lead",
    "newQuote": "+ New Quote",
    "newOrder": "+ New Order",
    "pagination": {
      "all": "All",
      "sumTariff": "SUM Tariff",
      "sumDeposit": "SUM Deposit"
    },
    "selectAll": "Select all {{total}} matching this filter",
    "clearSelection": "Clear selection",
    "massActions": {
      "archiveTitle_one": "Archive {{count}} shipment?",
      "archiveTitle_other": "Archive {{count}} shipments?",
      "markAsTitle_one": "Mark {{count}} shipment as {{status}}?",
      "markAsTitle_other": "Mark {{count}} shipments as {{status}}?",
      "reassignTitle_one": "Reassign {{count}} shipment to {{name}}?",
      "reassignTitle_other": "Reassign {{count}} shipments to {{name}}?",
      "description": "Runs on each ticked row. Rows the server rejects are skipped and reported.",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "running": "Updating…",
      "success_one": "{{count}} shipment updated",
      "success_other": "{{count}} shipments updated",
      "partial": "{{done}} updated, {{failed}} couldn't be updated",
      "failed": "None of the selected shipments could be updated",
      "allSkipped_one": "Nothing changed — {{count}} row could not be moved",
      "allSkipped_other": "Nothing changed — {{count}} rows could not be moved",
      "jobProgress": "{{processed}} of {{total}} processed"
    }
  },
  "task": {
    "toolbar": {
      "search": "Search tasks"
    },
    "columns": {
      "due": "Due",
      "name": "Name",
      "type": "Type",
      "priority": "Priority",
      "owner": "Owner",
      "created": "Created"
    },
    "filters": {
      "status": "Status",
      "type": "Type",
      "priority": "Priority"
    }
  },
  "quickCreateMenu": {
    "createQuote": "Create Quote",
    "createOrder": "Create Order",
    "createCustomer": "Create Customer",
    "addCarrier": "Add Carrier",
    "createTask": "Create Task"
  },
  "carrierRequests": {
    "title": "Carrier Request",
    "close": "Close",
    "empty": "No carrier requests yet.",
    "orderNumber": "Order #{{number}}",
    "distanceMiles": "{{miles}} mi",
    "totalTariff": "Total Tariff",
    "carrierPay": "Carrier Pay",
    "postedDate": "Posted {{date}}",
    "pickup": "Pickup",
    "delivery": "Delivery",
    "requestsWaiting_one": "{{count}} request waiting",
    "requestsWaiting_other": "{{count}} requests waiting",
    "respondedRequests_one": "{{count}} responded request",
    "respondedRequests_other": "{{count}} responded requests",
    "verifiedBySd": "Verified by SD",
    "unverifiedBySd": "Unverified by SD",
    "cargoInsurance": "Cargo insurance",
    "insuranceLine": "limit is {{limit}} with {{deductible}} deductible",
    "largestCapacity": "Largest trailer capacity is {{label}}",
    "accepts": "Accepts",
    "superPay": "SuperPay",
    "moreThanCod": "+{{amount}} over COD",
    "pricePerMile": "{{value}}/mi",
    "counterOfferPlaceholder": "Counter offer",
    "acceptBid": "Accept Bid",
    "acceptRequest": "Accept Request",
    "counterOffer": "Counter Offer",
    "decline": "Decline",
    "cancelCounterOffer": "Cancel Counter Offer",
    "cancelOffer": "Cancel Offer",
    "sendOffer": "Send Offer",
    "acceptSuccess": "Offer sent",
    "acceptError": "Failed to send offer",
    "counterSuccess": "Counter offer sent",
    "counterError": "Failed to send counter offer",
    "declineSuccess": "Request declined",
    "declineError": "Failed to decline request",
    "cancelSuccess": "Offer canceled",
    "cancelError": "Failed to cancel offer",
    "sendOfferSuccess": "Offer sent to carrier",
    "sendOfferError": "Failed to send offer",
    "carrierPlacedBid": "Carrier Placed Bid on Counter Offer",
    "offerSent": "Offer Sent",
    "counterOfferSent": "Counter Offer Sent",
    "carrierAcceptedOffer": "Carrier Accepted Offer",
    "offerSentFor": "Offer Sent for {{amount}}",
    "counterOfferSentFor": "Counter Offer Sent for {{amount}}",
    "carrierAcceptedOfferFor": "Carrier Accepted Offer for {{amount}}",
    "requestAutoDeclined": "Request Auto-Declined",
    "carrierCanceledRequest": "Carrier Canceled Request",
    "offerCanceled": "Offer Canceled",
    "termsCod": "COD",
    "termsCop": "COP",
    "totalDispatchedByYou_one": "{{count}} total order dispatched by you",
    "totalDispatchedByYou_other": "{{count}} total orders dispatched by you",
    "ago": {
      "seconds_one": "Requested {{count}}s ago",
      "seconds_other": "Requested {{count}}s ago",
      "minutes_one": "Requested {{count}}m ago",
      "minutes_other": "Requested {{count}}m ago",
      "hours_one": "Requested {{count}}h ago",
      "hours_other": "Requested {{count}}h ago",
      "days_one": "Requested {{count}}d ago",
      "days_other": "Requested {{count}}d ago"
    }
  },
  "similarLoads": {
    "title": "Similar Loads",
    "openCentralDispatch": "Open on Central Dispatch",
    "close": "Close",
    "totalFound": "{{count}} similar loads found",
    "strongMatch": "Strong match",
    "tariff": "Tariff",
    "cod": "COD",
    "pickupShort": "PU {{date}}",
    "deliveryShort": "DEL {{date}}",
    "milesRate": "{{miles}} mi · ${{rate}}/mi",
    "dateRange": "{{from}} → {{to}}",
    "posted": "Posted {{date}}",
    "loadId": "ID: {{id}}",
    "noteLabel": "Note: {{note}}",
    "empty": "No similar loads available.",
    "error": "Could not load similar loads."
  },
  "customer": {
    "favorite": {
      "add": "Add to favorites",
      "remove": "Remove from favorites",
      "error": "Could not update favorite."
    },
    "portalInvite": {
      "invite": "Invite",
      "resend": "Resend",
      "sending": "Sending…",
      "active": "Active",
      "noEmail": "Add an email to this customer to invite them",
      "sent": "Portal invite created",
      "error": "Couldn't create the portal invite"
    }
  },
  "customerCreate": {
    "dialog": {
      "title": "Create Customer",
      "cancel": "Cancel",
      "create": "Create",
      "creating": "Creating…"
    },
    "toast": {
      "success": "Customer created",
      "error": "Could not create customer"
    }
  },
  "header": {
    "create": "Create",
    "scrollToTop": "Scroll to top",
    "globalSearch": "Global Search",
    "searchPlaceholder": "Search anything",
    "pasteSuggestion": "Paste",
    "pasteDismiss": "Dismiss paste suggestion",
    "tabs": {
      "newLeads": "New Leads",
      "archived": "Archived",
      "allCustomers": "All Customers",
      "favoriteCustomers": "Favorite",
      "allCarriers": "All Carriers",
      "favoriteCarriers": "Favorite",
      "debt": "Debt",
      "credit": "Credit",
      "newToday": "New Today",
      "followUp": "Follow up",
      "active": "Active",
      "scheduled": "Scheduled",
      "hold": "Hold",
      "onHold": "Hold",
      "allTasks": "All Tasks",
      "allQuotes": "All Quotes",
      "allOrders": "All Orders",
      "new": "New",
      "booked": "Booked",
      "posted": "Posted",
      "notSigned": "Not signed",
      "dispatched": "Dispatched",
      "issue": "Issue",
      "pickedup": "Pickedup",
      "completed": "Completed",
      "users": "Users",
      "leads": "Leads",
      "company": "Company",
      "numbers": "Numbers",
      "warm": "Warm",
      "notNow": "Not Now"
    }
  },
  "recipients": {
    "remove": "Remove {{label}}"
  },
  "announcements": {
    "close": "Close announcement"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all read",
    "viewAll": "View all notifications",
    "toast": {
      "newLeadTag": "New lead"
    },
    "unreadBadge_one": "{{count}} unread notification",
    "unreadBadge_other": "{{count}} unread notifications",
    "empty": {
      "title": "You're all caught up",
      "description": "New notifications will show up here."
    },
    "tabs": {
      "all": "All",
      "carriers": "Carriers",
      "mentions": "Mentions"
    },
    "sections": {
      "needsAttention": "Needs attention",
      "today": "Today",
      "yesterday": "Yesterday",
      "earlier": "Earlier"
    }
  },
  "admin": {
    "subtabs": {
      "allUsers": "All Users",
      "teams": "Teams",
      "accessRoles": "Access Roles"
    },
    "leadsSubtabs": {
      "providers": "Sources",
      "distribution": "Distribution"
    },
    "quoteLinks": {
      "label": "Quote request page",
      "openLink": "Open link",
      "copyLink": "Copy link",
      "copyEmbed": "Copy iframe code",
      "embedCopied": "Iframe code copied"
    },
    "leadSource": {
      "notConfigured": "Email not configured",
      "tooltipTitle": "Your lead intake address",
      "tooltipBody": "Share this with lead providers. Leads emailed here are auto-captured as new providers you can review and confirm."
    },
    "numbersSubtabs": {
      "number": "Number",
      "order": "Order",
      "porting": "Porting",
      "brand": "Brand",
      "campaign": "Campaign",
      "texting": "Texting Automation"
    },
    "companySubtabs": {
      "company": "Company",
      "contract": "Contract",
      "paymentMethods": "Payment Methods",
      "phoneNumbers": "Phone Numbers",
      "template": "Template",
      "loadboard": "Loadboard"
    },
    "values": {
      "yes": "Yes",
      "no": "No"
    },
    "status": {
      "all": "All Status",
      "active": "Active",
      "inactive": "Inactive"
    },
    "newUser": "+ New User",
    "newTeam": "+ New Team",
    "newRole": "+ New Role",
    "newProvider": "+ New Source",
    "newDistribution": "+ New Distribution",
    "newContract": "+ New Contract",
    "newPaymentMethod": "+ New Payment Method",
    "newTemplate": "+ New Template",
    "newLoadboard": "+ New Load Board",
    "columns": {
      "username": "Username",
      "name": "Name",
      "source": "Source",
      "accessRole": "Access Role",
      "team": "Team",
      "tier": "Tier",
      "phone": "Phone",
      "status": "Status",
      "lastUpdated": "Last Updated",
      "created": "Created",
      "teamName": "Team Name",
      "members": "Members",
      "lead": "Team Lead",
      "roleName": "Role Name",
      "description": "Description",
      "usersCount": "Users",
      "type": "Type",
      "default": "Default",
      "leadsInQueue": "Leads in Queue",
      "email": "Email",
      "subject": "Subject"
    },
    "providers": {
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "pending": "Pending",
        "pendingHint": "Open this lead source, review all details and parsing results. If everything looks correct, set it to Active to start receiving leads."
      },
      "type": {
        "standard": "Standard",
        "loadboard": "Loadboard",
        "external": "External",
        "internal": "Internal",
        "organic": "Organic",
        "b2b": "B2B",
        "provider": "Provider"
      }
    }
  },
  "editableInfoCard": {
    "edit": "Edit",
    "cancel": "Cancel",
    "save": "Save"
  },
  "passwordInput": {
    "show": "Show password",
    "hide": "Hide password"
  },
  "adminTeams": {
    "columns": {
      "users": "Users",
      "totalPrefix": "Total {{count}}:"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "menu": "Team actions",
      "edit": "Edit",
      "delete": "Delete"
    },
    "detail": {
      "title": "Team",
      "close": "Close",
      "teamInformation": "Team Information",
      "teamName": "Team Name",
      "status": "Status",
      "totalMembers": "Total Members",
      "totalMembersHint": "managed via Members list",
      "members": "Members",
      "noMembers": "No members yet",
      "addMember": "+ Add member",
      "removeMember": "Remove member",
      "memberSearchPlaceholder": "Search by name or email",
      "memberSearchLoading": "Loading users…",
      "memberSearchNoResults": "No users match",
      "history": "History",
      "historyCount_one": "{{count}} event",
      "historyCount_other": "{{count}} events",
      "edit": "Edit team information",
      "cancel": "Cancel",
      "save": "Save"
    },
    "form": {
      "create": {
        "title": "Create a New Team",
        "submit": "Create Team"
      },
      "edit": {
        "title": "Edit Team",
        "submit": "Save Changes"
      },
      "cancel": "Cancel",
      "fields": {
        "name": "Team Name",
        "status": "Status"
      },
      "placeholders": {
        "name": "e.g. Sales Team"
      }
    },
    "delete": {
      "title": "Delete team",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Team created",
      "updated": "Team updated",
      "deleted": "Team deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminUsers": {
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "avatar": {
      "view": "View {{name}}'s photo",
      "alt": "{{name}}'s photo",
      "close": "Close photo"
    },
    "actions": {
      "menu": "User actions",
      "view": "View",
      "delete": "Delete"
    },
    "detail": {
      "title": "User",
      "close": "Close",
      "userInformation": "User Information",
      "phoneNumber": "Phone Number",
      "accessInformation": "Access Information",
      "userStatus": "User Status",
      "tier": "Tier",
      "firstName": "First Name",
      "lastName": "Last Name",
      "phone": "Phone",
      "ext": "Ext",
      "email": "Email",
      "photo": "Photo",
      "accessRole": "Access Role",
      "team": "Team",
      "password": "Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "empty": "—",
      "unassigned": "Unassigned",
      "sessions": "Sessions",
      "currentPassword": "Current Password"
    },
    "tier": {
      "trainee": "Trainee",
      "junior": "Junior",
      "middle": "Middle",
      "senior": "Senior",
      "supervisor": "Supervisor",
      "manager": "Manager",
      "owner": "Owner"
    },
    "create": {
      "title": "Create a New User",
      "cancel": "Cancel",
      "submit": "Create User"
    },
    "delete": {
      "title": "Delete user",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "resetPassword": {
      "title": "Reset password",
      "description": "Set a new password for \"{{name}}\"? This signs them out of all active sessions and they'll need the new password to log back in.",
      "cancel": "Cancel",
      "confirm": "Reset password",
      "mismatch": "Passwords don't match"
    },
    "placeholders": {
      "firstName": "e.g. Maria",
      "lastName": "e.g. Lawson",
      "email": "name@company.com",
      "password": "Minimum 8 characters",
      "confirmPassword": "Re-enter the new password",
      "phone": "(000) 000-0000",
      "ext": "000",
      "select": "Select",
      "currentPassword": "Your current password",
      "deviceLimit": "0"
    },
    "toast": {
      "created": "User created",
      "updated": "User updated",
      "deleted": "User deleted",
      "passwordReset": "Password updated",
      "error": "Something went wrong. Please try again."
    },
    "photo": {
      "change": "Change photo",
      "uploading": "Uploading…",
      "remove": "Remove photo",
      "uploadError": "Couldn't upload the photo. Please try again."
    },
    "deviceLimit": {
      "unlimited": "Unlimited",
      "count_one": "{{count}} device",
      "count_other": "{{count}} devices",
      "hint": "0 = unlimited, up to 10. Changing this never signs anyone out."
    }
  },
  "adminRoles": {
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "menu": "Role actions",
      "view": "View",
      "delete": "Delete"
    },
    "levels": {
      "none": "---",
      "own": "Own",
      "team": "Team",
      "all": "All"
    },
    "permissions": {
      "title": "Permissions",
      "features": "Features",
      "loading": "Loading permissions…",
      "permissionLabel": "Permission:",
      "cycleHint": "Click to cycle:",
      "scopeDescriptions": {
        "none": "No access",
        "own": "Own records",
        "all": "All records"
      },
      "actions": {
        "view": "View",
        "create": "Create",
        "update": "Edit",
        "delete": "Delete"
      }
    },
    "detail": {
      "title": "Access Role",
      "roleDetails": "Role Details",
      "close": "Close",
      "edit": "Edit",
      "information": "Role Information",
      "roleName": "Role Name",
      "status": "Status",
      "lastUpdated": "Last Updated",
      "assignedUsers": "Assigned users ({{count}})",
      "assignUsersLabel": "Assign Users",
      "empty": "—"
    },
    "assignedUsers": {
      "add": "+ Add user",
      "remove": "Remove user",
      "pickerTitle": "Select a user to add",
      "searchPlaceholder": "Type a name",
      "loading": "Loading users…",
      "noResults": "No users match"
    },
    "templates": {
      "label": "Start from a template"
    },
    "create": {
      "title": "Create a New Access Role",
      "cancel": "Cancel",
      "submit": "Create"
    },
    "edit": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "delete": {
      "title": "Delete role",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "placeholders": {
      "name": "e.g. Sales Person, Dispatcher"
    },
    "toast": {
      "created": "Role created",
      "updated": "Role updated",
      "deleted": "Role deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminProviders": {
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "pending": "Pending"
    },
    "type": {
      "standard": "Standard",
      "loadboard": "Loadboard",
      "external": "External",
      "internal": "Internal",
      "organic": "Organic",
      "b2b": "B2B",
      "provider": "Provider"
    },
    "values": {
      "yes": "Yes",
      "no": "No"
    },
    "autoQuoteMode": {
      "high": "Central Dispatch Maximum",
      "best": "Central Dispatch Best",
      "low": "Central Dispatch Minimum",
      "super_dispatch": "Super Dispatch Pricing"
    },
    "marginType": {
      "fixed_amount": "Fixed Amount",
      "percent": "Percent"
    },
    "autoPriceMode": {
      "off": "Off",
      "on": "On",
      "manual": "Manual"
    },
    "brokerFeeMode": {
      "fixed": "Fixed",
      "percent": "Percent",
      "min": "Minimum",
      "off": "Off"
    },
    "actions": {
      "menu": "Provider actions",
      "view": "View",
      "delete": "Delete"
    },
    "detail": {
      "title": "Lead Source",
      "close": "Close",
      "sourceDetails": "Source Details",
      "autoPrice": "Auto Price",
      "autoQuote": "Auto Quote",
      "mode": "Mode",
      "marginType": "Margin Type",
      "marginAmount": "Margin Amount",
      "minMargin": "Min Margin",
      "minTariff": "Min Tariff",
      "providerName": "Provider Name",
      "status": "Status",
      "type": "Type",
      "priority": "Priority",
      "effective": "Effective",
      "exclusive": "Exclusive",
      "costPerLead": "Cost per Lead",
      "defaultDeposit": "Default Deposit",
      "email": "Email",
      "subject": "Subject",
      "apiEndpoint": "API Endpoint",
      "autoPriceMode": "Auto Price Mode",
      "brokerFeeMode": "Broker Fee Mode",
      "brokerFeeValue": "Broker Fee Value",
      "notConfigured": "Not configured",
      "empty": "—",
      "assignedUsersLabel": "Assigned Users"
    },
    "assignedUsers": {
      "add": "+ Add user",
      "remove": "Remove user",
      "pickerTitle": "Select a user to add",
      "searchPlaceholder": "Type a name",
      "loading": "Loading users…",
      "noResults": "No users match",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected"
    },
    "edit": {
      "cancel": "Cancel",
      "save": "Save Changes"
    },
    "activate": {
      "missingFields": "Cannot activate — these required lead fields are empty: {{fields}}",
      "noSample": "Add a sample lead email before activating this source."
    },
    "originalEmail": {
      "title": "Original email",
      "from": "From",
      "subject": "Subject",
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "parsing": {
      "title": "Parsing Fields",
      "matched": "{{count}} matched",
      "toReview": "{{count}} to review",
      "vehiclesFound_one": "{{count}} vehicle found",
      "vehiclesFound_other": "{{count}} vehicles found",
      "updating": "Updating…",
      "notFound": "Not found — add manually",
      "keywordPlaceholder": "Add keyword",
      "matchedFrom": "matched from \"{{line}}\"",
      "noMatch": "no match found in email",
      "add": "Add",
      "addVehicle": "Add Vehicle",
      "removeVehicle": "Remove vehicle",
      "removeKeyword": "Remove keyword {{keyword}}",
      "defaultGroupName": "Detected mappings",
      "status": {
        "matched": "Matched",
        "review": "Review"
      }
    },
    "history": {
      "title": "History"
    },
    "create": {
      "title": "Create a New Lead Source",
      "cancel": "Cancel",
      "submit": "Create"
    },
    "delete": {
      "title": "Delete lead source",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "placeholders": {
      "name": "e.g. TheCarGo Leads",
      "email": "leads@company.io",
      "subject": "Leads From Quote Request Form",
      "deposit": "0",
      "value": "0",
      "body": "Paste the original lead email body"
    },
    "toast": {
      "created": "Lead source created",
      "updated": "Lead source updated",
      "deleted": "Lead source deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminDistributions": {
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "menu": "Distribution actions",
      "view": "View",
      "delete": "Delete"
    },
    "columns": {
      "user": "Users",
      "today": "Today",
      "queue": "Queue",
      "multiple": "Multiple",
      "receivingHours": "Receiving Hrs",
      "status": "Status",
      "activeHours": "Active Hours",
      "multiplier": "Multiplier",
      "lastUpdated": "Last Updated"
    },
    "detail": {
      "title": "Distribution",
      "close": "Close",
      "information": "Distribution Information",
      "user": "User",
      "status": "Provider Status",
      "activeHours": "Active Hours",
      "multiplier": "Multiplier",
      "receivedToday": "Received Today",
      "queueNow": "Queue Now",
      "empty": "—",
      "hoursTo": "→"
    },
    "create": {
      "title": "Create a New Distribution",
      "cancel": "Cancel",
      "submit": "Create Distribution"
    },
    "delete": {
      "title": "Delete distribution",
      "description": "Are you sure you want to delete this distribution? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "placeholders": {
      "multiplier": "1.0",
      "selectUser": "Select a user"
    },
    "toast": {
      "created": "Distribution created",
      "updated": "Distribution updated",
      "deleted": "Distribution deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminLoadboards": {
    "empty": "—",
    "values": {
      "yes": "Yes",
      "no": "No"
    },
    "connection": {
      "title": "Connection",
      "connected": "Connected",
      "connectedYes": "Connected",
      "connectedNo": "Not connected",
      "webhook": "Webhook",
      "active": "Active",
      "inactive": "Inactive",
      "scopeOk": "Available",
      "scopeFail": "Unavailable",
      "scopeNotGranted": "Not granted",
      "connect": "Connect",
      "disconnect": "Disconnect",
      "disconnected": "Central Dispatch disconnected",
      "reconnected": "Central Dispatch reconnected"
    },
    "scopes": {
      "fullIntegration": "Full Integration"
    },
    "actions": {
      "menu": "Load board actions",
      "view": "View",
      "delete": "Delete",
      "restart": "Clean"
    },
    "columns": {
      "name": "Name",
      "webhook": "Webhook",
      "spoces": "Spoces",
      "restart": "Restart",
      "status": "Status",
      "lastUpdated": "Last Updated"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "type": {
      "central": "Central Dispatch",
      "super": "Super Dispatch"
    },
    "method": {
      "cash": "Cash",
      "check": "Check",
      "cashiers_check": "Cashier's Check",
      "money_order": "Money Order",
      "comchek": "Comchek",
      "ach": "ACH",
      "direct_deposit": "Direct Deposit",
      "credit_card": "Credit Card",
      "venmo": "Venmo",
      "cashapp": "Cash App",
      "uship": "uShip",
      "zelle": "Zelle",
      "superpay": "SuperPay",
      "other": "Other",
      "CASH": "Cash",
      "CERTIFIED_FUNDS": "Certified Funds",
      "COMPANY_CHECK": "Company Check",
      "COMCHEK": "Comchek",
      "TCH": "TCH"
    },
    "terms": {
      "check_on_delivery": "Check on Delivery",
      "check_on_pickup": "Check on Pickup",
      "cash_on_pickup": "Cash on Pickup",
      "cash_on_delivery": "Cash on Delivery"
    },
    "balanceTime": {
      "IMMEDIATELY": "Immediately",
      "TWO_BUSINESS_DAYS_QUICK_PAY": "2 Business Days (Quick Pay)",
      "FIVE_BUSINESS_DAYS": "5 Business Days",
      "TEN_BUSINESS_DAYS": "10 Business Days",
      "FIFTEEN_BUSINESS_DAYS": "15 Business Days",
      "THIRTY_BUSINESS_DAYS": "30 Business Days"
    },
    "balanceBegins": {
      "PICKUP": "Pickup",
      "DELIVERY": "Delivery",
      "RECEIVING_SIGNED_BOL": "Receiving Signed BOL"
    },
    "detail": {
      "title": "Load Board",
      "close": "Close",
      "information": "Load Board Information",
      "paymentTermsTitle": "Payment Terms",
      "name": "Name",
      "status": "Status",
      "type": "Type",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "clientIdRequired": "Client ID *",
      "clientSecretRequired": "Client Secret *",
      "clientIdPlaceholder": "Paste your Client ID",
      "clientSecretPlaceholder": "Paste your Client Secret",
      "clientSecretKeep": "Leave blank to keep current",
      "secretMasked": "••••••••",
      "paymentMethod": "Payment Method",
      "paymentTerms": "Payment Terms",
      "balanceMethod": "Balance Method",
      "balanceTime": "Balance Time",
      "balanceBegins": "Balance Begins",
      "notConfigured": "Not configured"
    },
    "create": {
      "title": "New Load Board",
      "cancel": "Cancel",
      "submit": "Create"
    },
    "delete": {
      "title": "Delete load board",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Load board created",
      "updated": "Load board updated",
      "deleted": "Load board deleted",
      "error": "Something went wrong. Please try again.",
      "restartUnavailable": "Restart isn't available yet"
    }
  },
  "adminTemplates": {
    "empty": "—",
    "searchPlaceholder": "Search templates",
    "type": {
      "all": "All"
    },
    "actions": {
      "menu": "Template actions",
      "view": "View",
      "delete": "Delete"
    },
    "columns": {
      "name": "Name",
      "used": "Used",
      "category": "Category",
      "type": "Type",
      "status": "Status",
      "lastUpdated": "Last Updated"
    },
    "channel": {
      "email": "Email",
      "sms": "SMS"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "allCategories": "All categories",
    "category": {
      "verifyCode": "Verification code",
      "quoteSend": "Quote send",
      "leadContactConfirmation": "Lead contact confirmation",
      "leadContactInternal": "Lead contact (internal)",
      "leadOnboardingConfirmation": "Lead onboarding confirmation",
      "leadOnboardingInternal": "Lead onboarding (internal)",
      "leadSourceReview": "Lead source review",
      "contractSend": "Contract send",
      "contractSign": "Contract sign",
      "paymentInvoice": "Payment invoice",
      "paymentReceipt": "Payment receipt",
      "trackingInfo": "Tracking info",
      "weeklyStats": "Weekly stats",
      "followUp": "Follow up",
      "referral": "Referral",
      "reEngagement": "Re-engagement",
      "return": "Return",
      "dispatchUpdate": "Dispatch update",
      "pickupNotification": "Pickup notification",
      "deliveryConfirmation": "Delivery confirmation",
      "carrierRequest": "Carrier request"
    },
    "editor": {
      "nameLabel": "Template name",
      "namePlaceholder": "e.g. Pickup confirmation — Standard",
      "channelLabel": "Channel",
      "categoryLabel": "Category",
      "categoryPlaceholder": "Select category…",
      "subjectLabel": "Subject",
      "subjectPlaceholder": "Type a subject or / for dynamic fields",
      "bodyLabel": "Message body",
      "bodyHint": "— use the Field button to insert dynamic values",
      "bodyPlaceholder": "Type your message or / for dynamic fields",
      "insertField": "Insert field",
      "recentFields": "Recent",
      "loadingVariables": "Loading fields…",
      "noVariables": "No fields available",
      "wordCount_one": "{{count}} word",
      "wordCount_other": "{{count}} words",
      "charCount_one": "{{count}} char",
      "charCount_other": "{{count}} chars",
      "fieldCount_one": "{{count}} field",
      "fieldCount_other": "{{count}} fields"
    },
    "create": {
      "title": "New Template",
      "cancel": "Cancel",
      "submit": "Create"
    },
    "edit": {
      "title": "Template",
      "submit": "Save"
    },
    "delete": {
      "title": "Delete template",
      "description": "Are you sure you want to delete \"{{name}}\"? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Template created",
      "updated": "Template updated",
      "deleted": "Template deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminNumbers": {
    "title": "Phone Numbers",
    "subtitle": "Numbers, porting, and texting compliance for your brokerage.",
    "buyNumber": "Buy Number",
    "mainlineTag": "Main",
    "sharedlineTag": "Shared",
    "addMainline": "Add mainline",
    "search": "Search number or agent",
    "sections": {
      "mainlines": "Main",
      "sharedlines": "Shared",
      "personal": "Direct"
    },
    "filters": {
      "status": "Status",
      "assigned": "Assignment"
    },
    "assignedFilter": {
      "all": "All Agents",
      "assigned": "Assigned",
      "unassigned": "Unassigned"
    },
    "columns": {
      "name": "Name",
      "status": "Status",
      "appliesTo": "Applies To",
      "capabilities": "Capabilities",
      "purchased": "Purchased",
      "monthly": "Monthly"
    },
    "appliesTo": {
      "members_one": "{{count}} member",
      "members_other": "{{count}} members",
      "everyone": "Everyone"
    }
  },
  "textingAutomation": {
    "intro": "Rules that watch your text messages — automate status changes, enforce quiet hours, and flag risky conversations.",
    "noChange": "— No change —",
    "direction": {
      "inbound": "Inbound",
      "outbound": "Outbound",
      "both": "Both"
    },
    "matchMode": {
      "contains": "Contains",
      "exactly": "Exactly matches"
    },
    "matchModeRow": {
      "contains": "contains",
      "exactly": "exactly matches"
    },
    "quoteStatus": {
      "quote": "New Today",
      "followUp": "Follow up",
      "warm": "Warm",
      "ongoing": "Active",
      "upcoming": "Scheduled",
      "onHold": "Hold",
      "notNow": "Not Now",
      "archived": "Archived"
    },
    "consent": {
      "doNotCall": "Do not call",
      "doNotText": "Do not text",
      "wrongNumber": "Wrong number",
      "allowed": "Texts allowed"
    },
    "status": {
      "title": "Status automation",
      "description": "Change a quote's status the moment a matching text arrives. Rules run top to bottom — first match wins.",
      "addRule": "Add Rule",
      "cantEdit": "Can't be edited",
      "toggle": "Enable rule"
    },
    "alerts": {
      "title": "Compliance alerts",
      "description": "Email a manager when a message matches a watched phrase — the alert includes the full message, both numbers, and the agent.",
      "addAlert": "Add Alert",
      "email": "Email",
      "toggle": "Enable alert"
    },
    "quietHours": {
      "title": "Quiet hours",
      "scope": "Mass & automated",
      "description": "Hold mass texts and automated sends outside the allowed window — recipient's local time, detected from their area code.",
      "sendBetween": "Send between",
      "and": "and",
      "localTime": "recipient's local time",
      "help": "Held texts go out when the window reopens. One-on-one conversations are never blocked — a single text during quiet hours shows the agent a heads-up with a Send at 8:00 AM option. The 8 AM – 9 PM default matches TCPA quiet-hour rules."
    },
    "dialog": {
      "close": "Close",
      "cancel": "Cancel",
      "save": "Save",
      "delete": "Delete",
      "addRule": "Add Rule",
      "addAlert": "Add Alert",
      "newRuleTitle": "New status rule",
      "editRuleTitle": "Edit status rule",
      "newAlertTitle": "New compliance alert",
      "editAlertTitle": "Edit compliance alert",
      "whenText": "When a text is",
      "andIt": "And it",
      "matchPhrases": "Matches these phrases",
      "phrasePlaceholder": "Type a phrase, press Enter…",
      "phraseHint": "Add several phrases to one rule. Matching ignores case and punctuation.",
      "moveQuote": "Move the quote to",
      "labelNumber": "Label the number as",
      "emailPeople": "Email these people",
      "addManager": "Add a manager…",
      "emailHint": "The alert email includes the full message, both numbers, and the agent on the thread.",
      "noManagers": "No teammates found"
    },
    "toast": {
      "error": "Something went wrong. Please try again.",
      "ruleCreated": "Rule added",
      "ruleUpdated": "Rule updated",
      "ruleDeleted": "Rule deleted",
      "ruleReordered": "Rule order updated",
      "alertCreated": "Alert added",
      "alertUpdated": "Alert updated",
      "alertDeleted": "Alert deleted",
      "quietHoursUpdated": "Quiet hours updated"
    }
  },
  "adminNumberSettings": {
    "close": "Close",
    "imessage": {
      "desc": "Premium line — calling and texting, no MMS."
    },
    "strip": {
      "local": "Local",
      "voice": "Voice",
      "sms": "SMS",
      "purchased": "Purchased {{date}}",
      "perMonth": "{{cost}} / month"
    },
    "fields": {
      "type": "Type",
      "typePersonal": "Personal number",
      "typeSharedline": "Shared line",
      "typeMainline": "Mainline",
      "label": "Label",
      "labelPlaceholder": "Add a label",
      "assignedTo": "Assigned to",
      "lineName": "Line name",
      "lineNamePlaceholder": "Name this line",
      "lineNameRequired": "A mainline needs a line name"
    },
    "members": {
      "title": "Members",
      "subtitle": "Who can use this line. Each channel is independent.",
      "add": "Add member",
      "user": "User",
      "inbound": "Inbound",
      "outbound": "Outbound",
      "call": "Call",
      "sms": "SMS",
      "empty": "No members yet.",
      "remove": "Remove member",
      "newMember": "New member",
      "cancelAdd": "Cancel",
      "saveFirst": "Save the switch to Mainline to start adding members.",
      "added": "Member added",
      "updated": "Member updated",
      "removed": "Member removed"
    },
    "monitors": {
      "title": "Monitors · read-only",
      "subtitle": "See the full call & SMS log without receiving anything.",
      "add": "Add monitor",
      "inbound": "Inbound",
      "outbound": "Outbound",
      "both": "Both",
      "empty": "No monitors yet.",
      "remove": "Remove monitor",
      "newMonitor": "New monitor",
      "added": "Monitor added",
      "updated": "Monitor updated",
      "removed": "Monitor removed"
    },
    "messaging": {
      "title": "Messaging",
      "textingEnabled": "Texting enabled",
      "textingDisabled": "Texting disabled",
      "campaign": "{{useCase}} campaign",
      "campaignStatus": "Campaign {{status}}",
      "domesticSmsMms": "Domestic SMS & MMS",
      "domesticSms": "Domestic SMS",
      "domesticMms": "Domestic MMS",
      "managedBy": "managed by {{name}}",
      "unavailable": "Messaging status is unavailable right now"
    },
    "voice": {
      "title": "Voice services",
      "hdVoice": "HD Voice",
      "hdVoiceDesc": "Higher call quality on supported carriers",
      "cnamLookup": "Caller ID lookup (CNAM)",
      "cnamLookupDesc": "Shows the caller's name on inbound calls",
      "cnamListing": "Caller ID listing (CNAM)",
      "cnamListingDesc": "Publishes your brokerage name when agents call out",
      "calledIdPlaceholder": "Called ID",
      "spam": "Spam call screening",
      "spamDesc": "Checks inbound calls against carrier spam lists",
      "spamFlag": "Flag suspicious calls",
      "spamReject": "Reject suspicious calls",
      "forwarding": "Call forwarding",
      "forwardingDesc": "Sends calls to another number when agents can't answer",
      "forwardNumberPlaceholder": "Forward to number",
      "forwardUnanswered": "Only when unanswered",
      "forwardAlways": "Always",
      "voicemail": "Voicemail",
      "voicemailDesc": "Missed calls record a voicemail in the call log",
      "recordInbound": "Record inbound calls",
      "recordInboundDesc": "Recordings attach to the call entry in the log",
      "noiseSuppression": "Noise suppression",
      "noiseSuppressionDesc": "Cleans up background noise on agent calls",
      "cnamNameRequired": "Enter 1–15 characters — letters, numbers and spaces only",
      "forwardNumberRequired": "Enter the number calls should forward to",
      "voicemailPinPlaceholder": "Voicemail PIN",
      "voicemailPinRequired": "Enter a 4–10 digit PIN"
    },
    "preventDeletion": "Prevent deletion",
    "preventDeletionDesc": "Blocks release until turned off — protects numbers printed on marketing",
    "release": {
      "title": "Release number",
      "desc": "Stops billing immediately and returns the number to the carrier",
      "action": "Release"
    },
    "ivr": {
      "title": "Auto-receptionist",
      "subtitle": "Plays a phone menu when callers reach this line, then routes them by key press.",
      "greeting": "Greeting",
      "greetingAudio": "Audio",
      "greetingTts": "Text-to-speech",
      "greetingReplace": "Replace",
      "greetingPlays": "Plays before the menu",
      "ttsPlaceholder": "Type your message…",
      "whenPressed": "When a caller presses…",
      "connectTo": "Connect to",
      "addKey": "Add key",
      "cancelKey": "Cancel",
      "noKey": "If no key is pressed",
      "noKeyDesc": "After the menu repeats twice",
      "pressHash": "Press #",
      "pressStar": "Press *",
      "menuLanguage": "Menu language",
      "ringOperator": "Ring operator",
      "repeatMenu": "Repeat menu greeting",
      "previousMenu": "Return to previous menu",
      "sendVoicemail": "Send to voicemail",
      "hangUp": "Hang up",
      "langEnUs": "English (U.S.)",
      "langEsUs": "Spanish (U.S.)",
      "langFrFr": "French (France)",
      "keyAdded": "Menu key added",
      "keyUpdated": "Menu key updated",
      "keyRemoved": "Menu key removed"
    },
    "removeMainline": "Remove mainline",
    "cancel": "Cancel",
    "save": "Save changes",
    "loadError": "Couldn't load number settings. Please try again.",
    "toast": {
      "saved": "Number settings saved",
      "released": "Number released",
      "error": "Something went wrong. Please try again."
    }
  },
  "adminPhoneNumbers": {
    "empty": "—",
    "search": "Search numbers",
    "default": "Default",
    "unassigned": "Unassigned",
    "columns": {
      "number": "Number",
      "assignedTo": "Assigned To",
      "label": "Label",
      "capabilities": "Capabilities",
      "status": "Status"
    },
    "capabilities": {
      "voice": "Voice",
      "sms": "SMS",
      "fax": "Fax"
    },
    "detail": {
      "information": "Number Information",
      "close": "Close"
    },
    "assign": {
      "userPlaceholder": "Select a user",
      "noUsers": "No users found"
    },
    "toast": {
      "reassigned": "Number reassigned",
      "error": "Something went wrong"
    }
  },
  "carriers": {
    "empty": "—",
    "columns": {
      "carrier": "Carrier",
      "contact": "Contact",
      "loadBoard": "Load Board",
      "orders": "Orders",
      "done": "Done",
      "balance": "Balance",
      "note": "Note",
      "insurance": "Insurance",
      "created": "Created"
    },
    "status": {
      "all": "All Status",
      "active": "Active",
      "inactive": "Inactive"
    },
    "tab": {
      "all": "All Carriers",
      "favorite": "Favorite",
      "debt": "Debt",
      "credit": "Credit"
    },
    "filters": {
      "status": "Status",
      "tab": "Carriers"
    },
    "insurance": {
      "unavailable": "Unavailable",
      "upload": "Upload",
      "uploading": "Uploading…",
      "error": "Could not upload insurance."
    },
    "favorite": {
      "add": "Add to favorites",
      "remove": "Remove from favorites",
      "error": "Could not update favorite."
    },
    "note": {
      "error": "Could not save note."
    }
  },
  "adminPaymentMethods": {
    "empty": "—",
    "actions": {
      "menu": "Payment method actions",
      "view": "View",
      "delete": "Delete"
    },
    "columns": {
      "name": "Name",
      "accountName": "Account Name",
      "username": "Username",
      "qrCode": "QR Code",
      "status": "Status"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "typeLabel": {
      "card": "Card",
      "zelle": "Zelle",
      "cash": "Cash",
      "check": "Check",
      "ach": "ACH",
      "wire": "Wire",
      "venmo": "Venmo",
      "cashapp": "Cash App",
      "paypal": "PayPal",
      "stripe": "Stripe",
      "authorize_net": "Authorize.Net",
      "quickbooks": "QuickBooks",
      "square": "Square",
      "firstdata": "FirstData"
    },
    "detail": {
      "title": "Payment Method",
      "close": "Close",
      "status": "Status",
      "type": "Type",
      "accountName": "Account Name",
      "username": "User Name",
      "link": "Link",
      "qrCode": "QR Code",
      "login": "Login",
      "password": "Password",
      "pinCode": "Pin Code",
      "stripeSecretKey": "Secret Key",
      "stripePublishableKey": "Publishable Key",
      "paypalSecretKey": "Secret Key",
      "surchargeFee": "Surcharge Fee",
      "chargeMode": "Payment collection",
      "require3ds": "3-D Secure",
      "squareAccessToken": "Access Token",
      "squareApplicationId": "Application ID"
    },
    "placeholders": {
      "status": "Select status",
      "accountName": "Legal or display name",
      "username": "@ handle",
      "link": "venmo.com/u/…",
      "login": "merchant@example.com",
      "password": "Enter password",
      "pinCode": "4–6 digits",
      "secretKey": "Enter secret key",
      "publishableKey": "Enter publishable key",
      "keepCurrent": "Leave blank to keep current",
      "surchargeFee": "Add default surcharge fee",
      "accessToken": "Enter access token"
    },
    "qr": {
      "label": "QR code",
      "upload": "Click to upload",
      "dragHint": "or drag QR image here",
      "constraints": "PNG, JPG · max 2 MB",
      "uploading": "Uploading…",
      "uploaded": "Uploaded · {{size}}"
    },
    "create": {
      "title": "New Payment Method",
      "cancel": "Cancel",
      "submit": "Save"
    },
    "delete": {
      "title": "Delete payment method",
      "description": "Are you sure you want to delete this {{name}} payment method? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Payment method created",
      "updated": "Payment method updated",
      "deleted": "Payment method deleted",
      "qrError": "Could not upload the QR image. Please try again.",
      "error": "Something went wrong. Please try again."
    },
    "chargeMode": {
      "instant": {
        "label": "Instant charge",
        "description": "Customer enters their card and pays. Funds captured immediately."
      },
      "on_demand": {
        "label": "On-demand charge",
        "description": "Customer enters their card and agrees to your terms. You charge it whenever you're ready."
      }
    },
    "require3ds": {
      "toggle": "Require 3-D Secure",
      "on": "On",
      "off": "Off",
      "description": "Ask the cardholder's bank to verify every pay-page card payment. A passed check moves fraud-chargeback liability to the bank. Banks can still ask for one with this off."
    },
    "quickbooks": {
      "connection": "Connection",
      "connected": "Connected",
      "notConnected": "Not connected",
      "connect": "Connect QuickBooks",
      "connecting": "Connecting…",
      "disconnect": "Disconnect",
      "disconnecting": "Disconnecting…",
      "realmId": "Company ID",
      "refreshExpiresAt": "Reconnect by",
      "connectHint": "QuickBooks connects through Intuit's sign-in popup — no keys to paste. Save the payment method, then use the Connect button on this screen.",
      "refreshExpiryWarning_one": "The QuickBooks connection expires in {{count}} day. Reconnect now to keep card payments working.",
      "refreshExpiryWarning_other": "The QuickBooks connection expires in {{count}} days. Reconnect now to keep card payments working.",
      "toast": {
        "connected": "QuickBooks connected",
        "cancelled": "QuickBooks connection was not completed",
        "disconnected": "QuickBooks disconnected"
      }
    },
    "square": {
      "tokenHint": "Paste the access token from developer.squareup.com → your application → Credentials (pick Sandbox or Production at the top). Square fills in the application ID, location and webhook key on its own once the method is saved."
    }
  },
  "adminCompanyInfo": {
    "empty": "—",
    "sections": {
      "logo": "Logo",
      "contact": "Company Information",
      "hours": "Working Hours"
    },
    "fields": {
      "name": "Company Name",
      "department": "Department",
      "mainline": "Main Line",
      "fax": "Fax",
      "email": "Email",
      "supportEmail": "Support Email",
      "accountingEmail": "Accounting Email",
      "address": "Address",
      "website": "Website",
      "logo": "Logo",
      "monFri": "Mon–Fri",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "placeholders": {
      "name": "Company name",
      "department": "Department",
      "mainline": "(555) 123-4567",
      "fax": "(555) 123-4568",
      "email": "contact@company.com",
      "address": "Street, City, State ZIP",
      "website": "https://company.com",
      "logo": "https://…",
      "hours": "09:00-17:00"
    },
    "hours": {
      "closed": "Closed",
      "to": "to"
    },
    "toast": {
      "updated": "Company info updated",
      "error": "Something went wrong. Please try again.",
      "invalid": "Invalid value in: {{fields}}"
    },
    "logo": {
      "change": "Change logo",
      "uploading": "Uploading…",
      "remove": "Remove logo",
      "uploadError": "Couldn't upload the logo. Please try again."
    }
  },
  "adminContracts": {
    "values": {
      "yes": "Yes",
      "no": "No"
    },
    "typeLabel": {
      "ground": "Ground",
      "hawaii": "Hawaii/Alaska",
      "international": "International"
    },
    "typeShortLabel": {
      "ground": "Ground",
      "hawaii": "HI/AK",
      "international": "Intl."
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "menu": "Contract actions",
      "view": "View",
      "delete": "Delete"
    },
    "columns": {
      "name": "Name",
      "status": "Status",
      "type": "Type",
      "default": "Default",
      "created": "Created",
      "lastUpdated": "Last Updated"
    },
    "detail": {
      "title": "Contract",
      "close": "Close",
      "information": "Contract Information",
      "name": "Contract Name",
      "namePlaceholder": "e.g. Ground 1.2",
      "type": "Type",
      "default": "Default",
      "defaultYes": "Yes — used for new orders",
      "defaultNo": "No",
      "status": "Status",
      "lastUpdated": "Last Updated"
    },
    "terms": {
      "title": "Terms & Conditions",
      "wordCount_one": "{{count}} word",
      "wordCount_other": "{{count}} words",
      "edit": "Edit terms",
      "save": "Save",
      "empty": "—",
      "placeholder": "Write the terms and conditions…",
      "reviewWarning": "Please review all terms and conditions before providing your signature."
    },
    "create": {
      "title": "Create a New Contract",
      "cancel": "Cancel",
      "submit": "Create Contract"
    },
    "delete": {
      "title": "Delete contract",
      "description": "Are you sure you want to delete this contract? This action can't be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "toast": {
      "created": "Contract created",
      "updated": "Contract updated",
      "deleted": "Contract deleted",
      "error": "Something went wrong. Please try again."
    }
  },
  "accessRoleView": {
    "dialog": {
      "title": "Access Role",
      "cancel": "Cancel",
      "edit": "Edit"
    },
    "fields": {
      "status": "Status",
      "created": "Created",
      "lastUpdated": "Last Updated"
    },
    "assignedUsers_one": "Assigned users ({{count}})",
    "assignedUsers_other": "Assigned users ({{count}})",
    "legend": {
      "permission": "Permission:"
    }
  },
  "accessRoleForm": {
    "create": {
      "title": "Create a New Access Role",
      "cancel": "Cancel",
      "submit": "Create Role"
    },
    "edit": {
      "title": "Edit Access Role",
      "cancel": "Cancel",
      "submit": "Save Changes"
    }
  },
  "accessRoleCreate": {
    "dialog": {
      "title": "Create a New Access Role",
      "cancel": "Cancel",
      "submit": "Create Role"
    },
    "fields": {
      "name": "Role Name",
      "status": "Status"
    },
    "placeholders": {
      "name": "e.g. Sales Person, Dispatcher"
    },
    "statusOptions": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "templates": {
      "label": "Start from a template",
      "noAccess": "No Access",
      "salesAgent": "Sales agent",
      "dispatcher": "Dispatcher",
      "manager": "Manager",
      "fullAccess": "Full Access"
    },
    "legend": {
      "clickToCycle": "Click to cycle:",
      "noAccess": "No access",
      "ownRecords": "Own records",
      "allRecords": "All records"
    },
    "permissionLevels": {
      "none": "---",
      "own": "Own",
      "all": "All"
    },
    "table": {
      "features": "Features"
    },
    "actions": {
      "view": "View",
      "create": "Create",
      "edit": "Edit",
      "delete": "Delete"
    },
    "sections": {
      "sales": "Sales",
      "operations": "Operations",
      "billing": "Billing",
      "system": "System"
    },
    "features": {
      "sales": {
        "leads": "Leads",
        "quotes": "Quotes",
        "orders": "Orders",
        "customers": "Customers"
      },
      "operations": {
        "carrier": "Carrier",
        "tasks": "Tasks",
        "insights": "Insights",
        "dashboard": "Dashboard"
      },
      "billing": {
        "invoice": "Invoice",
        "payment": "Payment",
        "payroll": "Payroll"
      },
      "system": {
        "userManagement": "User Management",
        "user": "User",
        "team": "Team",
        "accessRole": "Access Role",
        "leadManagement": "Lead Management",
        "contracts": "Contracts",
        "companyManagement": "Company Management"
      }
    }
  },
  "orderDetails": {
    "editAll": "Edit All",
    "details": {
      "title": "Details",
      "similarLoads": "Similar Loads",
      "fields": {
        "vehicle": "Vehicle",
        "vehicle2": "Vehicle #2",
        "origin": "Origin",
        "destination": "Destination",
        "trailerTags": "Trailer / Tags",
        "shipDate": "Ship Date",
        "transit": "Transit",
        "lbNote": "LB Note",
        "cmNote": "CM Note"
      },
      "tags": {
        "biz": "Biz",
        "res": "Res",
        "open": "Open",
        "paid": "Paid"
      }
    },
    "customer": {
      "title": "Customer",
      "edit": "Edit Customer",
      "empty": "—",
      "phoneMain": "Main",
      "phoneAlt": "Alt",
      "fields": {
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "company": "Company",
        "note": "Note"
      }
    },
    "payment": {
      "title": "Payment",
      "priceTitle": "Price",
      "priceCheck": "Price Check",
      "samplePrice": "Sample Price",
      "checkRate": "Check Rate",
      "checkingRate": "Checking rate…",
      "checkRateRetryHint": "Click to retry",
      "marketPositionTitle": "Tariff sits at {{percent}}% of the market low–high range",
      "paid": "Paid: {{amount}}",
      "noPriceYet": "No price yet",
      "noPriceDescription": "Set a price to send to Quotes.",
      "addPrice": "Add Price",
      "fields": {
        "tariff": "Total Tariff",
        "deposit": "Deposit",
        "paid": "Paid",
        "paidFull": "Taken across every payment on this order, minus refunds",
        "carrierPay": "Carrier Pay",
        "dod": "DOD",
        "dodFull": "Due on Delivery",
        "note": "Note:"
      },
      "useRateHint": "Use this price as the total tariff"
    },
    "carrier": {
      "title": "Carrier",
      "badge": "Carrier",
      "favorite": "Favorite carrier",
      "mc": "MC {{number}}",
      "usdot": "USDOT {{number}}",
      "insurance": "Insurance {{amount}}",
      "termsMet": "100% Payment terms met",
      "rating": "{{rating}} ({{count}})",
      "phone": "Phone",
      "email": "Email",
      "fields": {
        "willBePaidBy": "Will be Paid by",
        "paymentTerm": "Payment Term",
        "termBegins": "Term begins",
        "codMethod": "COD method",
        "paymentType": "Payment type"
      }
    },
    "tasks": {
      "title": "Task"
    },
    "history": {
      "title": "History",
      "noEntries": "No entries yet",
      "loading": "Loading…",
      "tabs": {
        "all": "All history",
        "note": "Note",
        "task": "Task",
        "phone": "Phone",
        "email": "Email",
        "file": "File",
        "contract": "Contract",
        "payment": "Payment",
        "activity": "Activity"
      },
      "empty": {
        "all": {
          "title": "Nothing here yet",
          "hint": "Activity on this shipment will show up here"
        },
        "note": {
          "title": "No notes yet",
          "hint": "Notes you add will appear here"
        },
        "task": {
          "title": "No completed tasks yet",
          "hint": "Tasks you complete or archive will appear here"
        },
        "phone": {
          "title": "No calls yet",
          "hint": "Call logs will appear here"
        },
        "email": {
          "title": "No emails yet",
          "hint": "Emails you send will appear here"
        },
        "file": {
          "title": "No files yet",
          "hint": "Files you attach will appear here"
        },
        "contract": {
          "title": "No contracts yet",
          "hint": "Contracts you send will appear here"
        },
        "payment": {
          "title": "No payments yet",
          "hint": "Payments will appear here"
        },
        "activity": {
          "title": "No activity yet",
          "hint": "Recent updates will appear here"
        }
      },
      "actions": {
        "openMenu": "Open actions",
        "markAsDone": "Mark as Done",
        "view": "View"
      },
      "loadMore": "Load more",
      "email": {
        "noSubject": "(no subject)",
        "events": {
          "empty": "No delivery events yet",
          "error": "Couldn't load delivery events",
          "type": {
            "processed": "Processed",
            "delivered": "Delivered",
            "opened": "Opened",
            "clicked": "Link clicked",
            "bounced": "Bounced",
            "dropped": "Dropped",
            "deferred": "Deferred",
            "spam_reported": "Marked as spam",
            "unsubscribed": "Unsubscribed",
            "resubscribed": "Resubscribed"
          }
        }
      },
      "contract": {
        "expires": "Expires",
        "types": {
          "shipping_order": "Shipping Order",
          "bill_of_lading": "Bill of Lading"
        },
        "status": {
          "draft": "Draft",
          "sent": "Sent",
          "viewed": "Viewed",
          "signed": "Signed",
          "notSigned": "Not Signed",
          "expired": "Expired",
          "cancelled": "Cancelled"
        }
      }
    },
    "comment": {
      "placeholder": "Click here to write a note",
      "tabs": {
        "note": "Note",
        "task": "Task",
        "phone": "Phone",
        "email": "Email",
        "file": "File",
        "contract": "Contract",
        "payment": "Payment"
      },
      "payment": {
        "sendInvoice": "Send Invoice",
        "settle": "Settle",
        "more": "More",
        "attach": "Attach",
        "charge": "Charge",
        "charging": "Charging…",
        "sendReceipt": "Send Receipt",
        "view": "View",
        "archive": "Archive",
        "copyInvoiceLink": "Copy invoice link",
        "copyStripeLink": "Copy Stripe link",
        "commentAction": "Comment",
        "commentDialog": {
          "title": "Comment",
          "placeholder": "Add a comment for this payment…",
          "save": "Save",
          "cancel": "Cancel",
          "saveSuccess": "Comment saved",
          "saveError": "Failed to save comment"
        },
        "emptyDescription": "Create a payment invoice to collect deposit or full payment from your customer.",
        "create": "Create Payment",
        "toast": {
          "archiveSuccess": "Payment archived",
          "archiveError": "Failed to archive payment",
          "sendInvoiceSuccess": "Invoice sent",
          "sendInvoiceError": "Failed to send invoice",
          "sendReceiptSuccess": "Receipt sent",
          "sendReceiptError": "Failed to send receipt",
          "chargeSuccess": "Payment charged",
          "chargeError": "Failed to charge payment",
          "noCardGateway": "No active card gateway is configured"
        },
        "disabledReason": {
          "noRecipient": "No recipient email on this payment",
          "noCustomerEmail": "We don't have a customer email for this shipment"
        },
        "detail": {
          "title": "Payment Recorded",
          "close": "Close",
          "done": "Done",
          "paymentDetails": "Payment details",
          "paymentRef": "Transaction #{{id}}",
          "proof": "Proof of payment",
          "proofView": "View",
          "proofMeta": "{{size}} · Uploaded {{when}}",
          "sendReceiptTo": "Send receipt to {{email}}",
          "sendReceipt": "Send receipt",
          "splitCount": "Split into {{count}} payments",
          "amountOf": "{{amount}} of {{total}}",
          "heroMeta": "via {{method}} · {{date}} at {{time}}",
          "receivedAt": "{{date}} · {{time}}",
          "loading": "Loading payment…",
          "loadError": "Could not load this payment",
          "headline": {
            "received": "received",
            "refunded": "refunded"
          },
          "rows": {
            "status": "Status",
            "method": "Method",
            "amount": "Amount",
            "received": "Received",
            "reference": "Reference",
            "recordedBy": "Recorded by"
          },
          "txStatus": {
            "succeeded": "Paid",
            "pending": "Pending",
            "failed": "Failed"
          },
          "method": {
            "zelle": "Zelle",
            "card": "Card",
            "cash": "Cash",
            "check": "Check",
            "ach": "ACH",
            "wire": "Wire",
            "venmo": "Venmo",
            "cashapp": "Cash App",
            "paypal": "PayPal"
          }
        }
      },
      "contract": {
        "emptyDescription": "Send the transport contract to your customer for review and e-signature.",
        "send": "Send Contract"
      }
    }
  },
  "addCard": {
    "title": "Add Card",
    "close": "Close",
    "cancel": "Cancel",
    "submit": "Save Card",
    "submitting": "Saving…",
    "cardDetails": "Card details",
    "authnet": {
      "cardNumber": "Card number",
      "cardNumberPlaceholder": "1234 1234 1234 1234",
      "expiry": "Expiry",
      "expiryPlaceholder": "MM / YY",
      "cvc": "CVC",
      "cvcPlaceholder": "123"
    },
    "cardholderName": "Cardholder name",
    "cardholderNameHint": "Enter the full name — first and last — exactly as it appears on the card.",
    "firstName": "First name",
    "firstNamePlaceholder": "John",
    "lastName": "Last name",
    "lastNamePlaceholder": "Doe",
    "nickname": "Nickname",
    "nicknamePlaceholder": "e.g. Personal Visa",
    "setAsDefault": "Set as default card",
    "billing": {
      "title": "Billing address",
      "optional": "Optional",
      "address": "Street address",
      "addressPlaceholder": "12482 Foothill Blvd",
      "apartment": "Apt / Suite / Unit",
      "apartmentPlaceholder": "Apt 4B",
      "city": "City",
      "cityPlaceholder": "Mission Hills",
      "state": "State",
      "statePlaceholder": "CA",
      "zip": "ZIP code",
      "zipPlaceholder": "91345",
      "country": "Country",
      "countryPlaceholder": "US"
    },
    "unavailable": {
      "title": "Card payments unavailable",
      "hint": "No payment gateway is configured for this organization. Contact an administrator to enable card payments."
    },
    "httpsRequired": {
      "title": "Secure connection required",
      "hint": "This payment provider requires an HTTPS connection to enter card details. Open this page over https://."
    },
    "toast": {
      "success": "Card saved",
      "error": "Failed to save card"
    },
    "quickbooks": {
      "cardNumber": "Card number",
      "cardNumberPlaceholder": "1234 1234 1234 1234",
      "expiry": "Expiry",
      "expiryPlaceholder": "MM / YY",
      "cvc": "CVC",
      "cvcPlaceholder": "123",
      "tokenizeError": "Could not verify the card with QuickBooks. Check the details and try again."
    },
    "square": {
      "tokenizeError": "Could not verify the card with Square. Check the details and try again.",
      "loadError": "Could not load the Square card form. Check your connection and try again."
    }
  },
  "settlePayment": {
    "title": "Settle Payment",
    "recordedTitle": "Payment Recorded",
    "close": "Close",
    "back": "Back",
    "cancel": "Cancel",
    "done": "Done",
    "submitting": "Processing…",
    "toast": {
      "chargeSuccess": "Card charged",
      "chargeError": "Failed to charge card",
      "noCardGateway": "No active card gateway is configured",
      "recordSuccess": "Payment recorded",
      "recordError": "Failed to record payment",
      "uploadError": "Failed to upload proof image"
    },
    "paymentVia": "Payment via",
    "amountToCharge": "Amount to charge",
    "amountReceived": "Amount received",
    "dateReceived": "Date received",
    "reference": "Reference",
    "referencePlaceholder": "Type your memo…",
    "referenceOtherPlaceholder": "e.g. Zelle confirmation #ABC1234",
    "via": {
      "card": "Card",
      "other": "Other methods"
    },
    "type": {
      "income": "Income",
      "refund": "Refund",
      "carrier_pay": "Carrier Pay"
    },
    "flow": {
      "customer_to_broker": "CUSTOMER → BROKER",
      "broker_to_customer": "BROKER → CUSTOMER",
      "broker_to_carrier": "BROKER → CARRIER",
      "unknown": "—"
    },
    "summary": {
      "createdOn": "Created {{date}}"
    },
    "card": {
      "chargeWith": "Charge with",
      "addNew": "+ Add new card",
      "empty": "No saved cards",
      "emptyHint": "Add a card for this customer to charge it here.",
      "exp": "Exp {{exp}}",
      "updatedAt": "Updated {{date}}",
      "default": "Default",
      "badge": {
        "cardOnFile": "Card on file",
        "ccaOnFile": "CCA on file"
      },
      "amountOverLimit": "Amount can't exceed the {{total}} charge total.",
      "connected": "Connected card",
      "otherCards": "Other cards",
      "searchPlaceholder": "Search cards",
      "searchEmpty": "No cards match your search."
    },
    "other": {
      "methodReceived": "Method received",
      "recordedHint": "Previously selected",
      "amountOverLimit": "Amount can't exceed the {{total}} total."
    },
    "proof": {
      "label": "Proof of payment",
      "cta": "Drop files here or tap to upload",
      "ctaMore": "Add another file",
      "hint": "PNG, JPG, or PDF · up to 10MB each",
      "remove": "Remove"
    },
    "cta": {
      "charge": "Charge {{amount}}",
      "chargePartial": "Charge {{amount}} of {{total}}",
      "markAsPaid": "Mark as paid"
    },
    "recorded": {
      "headlineCharged": "charged",
      "headlineReceived": "received",
      "viaVia": "via {{brand}}",
      "viaPlain": "via {{method}}",
      "transactionDetails": "Transaction details",
      "paymentDetails": "Payment details",
      "status": "Status",
      "statusPaid": "Paid",
      "method": "Method",
      "transactionId": "Transaction ID",
      "amount": "Amount",
      "charged": "Charged",
      "received": "Received",
      "reference": "Reference",
      "chargedBy": "Charged by",
      "recordedBy": "Recorded by",
      "sendReceipt": "Send receipt to {{email}}",
      "viewProof": "View",
      "proofMeta": "{{size}} · Uploaded just now"
    }
  },
  "activityHistory": {
    "title": "Activity History",
    "close": "Close",
    "today": "TODAY",
    "yesterday": "YESTERDAY",
    "edited": "edited",
    "expand": "Expand",
    "collapse": "Collapse",
    "changeCount_one": "{{count}} change",
    "changeCount_other": "{{count}} changes",
    "columns": {
      "field": "Field",
      "oldValue": "Old value",
      "newValue": "New value"
    },
    "actions": {
      "exportCsv": "Export CSV",
      "loadMore": "Load more"
    },
    "events": {
      "created": "created this record",
      "deleted": "deleted this record"
    },
    "footer": {
      "shownOf": "Showing {{shown}} of {{total}} edit sessions",
      "shownOnly": "Showing {{shown}} edit sessions"
    },
    "empty": {
      "title": "No edits yet",
      "hint": "Changes to this order will appear here"
    }
  },
  "leadDetails": {
    "toolbar": {
      "convertToOrder": "Convert to Order"
    }
  },
  "shipmentCard": {
    "title": "Shipment",
    "editAll": "Edit All",
    "edit": "Edit",
    "editVehicle": "Edit Vehicle",
    "editRoute": "Edit Route",
    "editNotes": "Edit Notes",
    "vehicle": "Vehicle",
    "route": "Route",
    "notes": "Notes",
    "vehicleCount_one": "{{count}} vehicle",
    "vehicleCount_other": "{{count}} vehicles",
    "noVehicles": "No vehicles",
    "trailerValue": "{{trailer}} Trailer",
    "est": "Est. {{date}}",
    "availFrom": "Avail from {{date}}",
    "carrier": "Carrier {{amount}}",
    "deposit": "Deposit {{amount}}",
    "saveToQuote": "Save to Quote",
    "empty": "—",
    "lbNote": "LB Note:",
    "cmNote": "CM Note:",
    "lbNoteShort": "LB:",
    "cmNoteShort": "CM:",
    "customerNotePlaceholder": "Note from customer can be shown here",
    "cancel": "Cancel",
    "saveChanges": "Save",
    "updateSuccess": "Shipment updated",
    "updateError": "Failed to update shipment"
  },
  "quoteDetails": {
    "commentPlaceholder": "Click here to type, @name...",
    "tasks": {
      "title": "Active Tasks",
      "due": "Due {{when}}",
      "markAsDone": "Mark \"{{title}}\" as done",
      "markAsPending": "Reopen \"{{title}}\""
    },
    "toolbar": {
      "convertToOrder": "Convert to Order"
    },
    "map": {
      "title": "Map",
      "placeholder": "Map preview",
      "empty": "No route addresses yet",
      "routeError": "Unable to find route. Please enter correct address.",
      "zipNotFound": "We couldn't find that ZIP code. Check the city, state and ZIP."
    },
    "pricing": {
      "title": "Pricing",
      "totalTariff": "Total Tariff",
      "deposit": "Deposit"
    },
    "archiveReasons": {
      "title": "Select a reason to archive",
      "loading": "Loading…",
      "empty": "No archive reasons",
      "emptyHint": "Ask an admin to configure reasons for this stage.",
      "archiveSuccess": "Shipment archived",
      "archiveError": "Failed to archive"
    }
  },
  "editor": {
    "note": {
      "placeholder": "Write your note here, tag @name...",
      "cancel": "Cancel",
      "save": "Save"
    },
    "slash": {
      "searchHint": "Type to search",
      "noResults": "No fields found",
      "navigateHint": "↑↓ Navigate",
      "insertHint": "↵ Insert",
      "closeHint": "esc Close"
    },
    "phone": {
      "placeholder": "Write your message...",
      "from": "From",
      "to": "To",
      "cc": "cc",
      "bcc": "bcc",
      "ccToggle": "CC",
      "bccToggle": "BCC",
      "addRecipient": "add recipient",
      "removeRecipient": "Remove {{label}}",
      "fromAria": "From number",
      "template": "Template",
      "selectTemplate": "Select from templates",
      "searchTemplate": "Search for template",
      "noTemplates": "No templates found",
      "insertField": "Insert field",
      "uploadFile": "Upload file",
      "save": "Send",
      "sending": "Sending…"
    },
    "email": {
      "placeholder": "Write your message...",
      "subject": "Subject",
      "save": "Send",
      "sending": "Sending…",
      "orderFiles": "Order files",
      "templates": {
        "welcome": "Welcome",
        "followUp": "Follow-up",
        "paymentReminder": "Payment reminder"
      },
      "insertFields": {
        "customerName": "Customer name",
        "quoteNumber": "Quote number",
        "trackingLink": "Tracking link"
      }
    },
    "payment": {
      "description": "Create a payment invoice to collect deposit or full payment from your customer.",
      "create": "Create Payment",
      "createNew": "Create New Payment",
      "cancel": "Cancel",
      "archive": "Archive",
      "cols": {
        "amount": "AMOUNT",
        "surcharge": "SURCHARGE",
        "discount": "DISCOUNT",
        "totalCharge": "TOTAL CHARGE",
        "totalPay": "TOTAL PAY",
        "charged": "CHARGED",
        "paid": "PAID"
      },
      "totals": {
        "total": "TOTAL",
        "collected": "COLLECTED",
        "refunded": "REFUNDED",
        "paidToCarrier": "PAID TO CARRIER"
      },
      "flowShort": {
        "customerToBroker": "C2B",
        "brokerToCustomer": "B2C",
        "brokerToCarrier": "B2CR"
      },
      "modal": {
        "title": "New Payment",
        "close": "Close",
        "fields": {
          "type": "Payment type",
          "direction": "Payment Direction",
          "amount": "Amount",
          "method": "Payment method",
          "date": "Due date",
          "memo": "Memo"
        },
        "amount": {
          "amount": "AMOUNT",
          "surcharge": "SURCHARGE %",
          "discount": "DISCOUNT",
          "totalCharge": "TOTAL CHARGE"
        },
        "type": {
          "income": "Income",
          "refund": "Refund",
          "carrierPay": "Carrier Pay",
          "tip": "Tip"
        },
        "direction": {
          "customerToBroker": "CUSTOMER → BROKER",
          "brokerToCustomer": "BROKER → CUSTOMER",
          "brokerToCarrier": "BROKER → CARRIER"
        },
        "methodPlaceholder": "Select method",
        "memoPlaceholder": "Type your memo...",
        "addReference": "+ Add reference or memo",
        "submit": "Create Payment",
        "cancel": "Cancel"
      }
    },
    "contract": {
      "description": "Send the transport contract to your customer for review and e-signature.",
      "send": "Send Contract",
      "sendNew": "Send New Contract",
      "sentTo": "Sent to",
      "awaiting": "Awaiting signature",
      "signed": "Signed",
      "view": "View",
      "cca": "CCA",
      "addNote": "Add a note",
      "editNote": "Edit note",
      "copySignLink": "Copy sign link",
      "saveNote": "Save note",
      "cancel": "Cancel",
      "noteSuccess": "Note saved",
      "noteError": "Failed to save note",
      "ccaError": "Failed to update CCA"
    },
    "file": {
      "placeholder": "Type a name or paste a file...",
      "cancel": "Cancel",
      "save": "Save",
      "remove": "Remove {{name}}",
      "pick": "Attach a file",
      "clear": "Clear name"
    },
    "task": {
      "description": "Create tasks to track follow-ups, calls, payments, and other actions for this order.",
      "create": "Create Task",
      "save": "Save Task",
      "cancel": "Cancel",
      "fields": {
        "task": "Task",
        "type": "Type",
        "date": "Date",
        "priority": "Priority",
        "user": "User",
        "assignee": "Assignee"
      },
      "setTime": "Set Time",
      "saveShort": "Save",
      "placeholder": "What needs to be done?",
      "types": {
        "phone": "Phone",
        "email": "Email",
        "payment": "Payment",
        "general": "General"
      },
      "quickDates": {
        "today": "Today",
        "tomorrow": "Tomorrow",
        "nextWeek": "Next week"
      },
      "priorities": {
        "low": "Low",
        "medium": "Medium",
        "high": "High"
      },
      "addUser": "Add user",
      "removeUser": "Remove {{name}}",
      "searchUser": "Search users...",
      "users": {
        "empty": "No users found",
        "emptyHint": "Try a different search"
      }
    },
    "attachments": {
      "label": "Order files",
      "summary": "{{label}} ({{count}} attached)",
      "view": "View",
      "selectAria": "Select {{name}}"
    },
    "size": {
      "b": "{{value}} B",
      "kb": "{{value}} KB",
      "mb": "{{value}} MB"
    },
    "toolbar": {
      "undo": "Undo",
      "redo": "Redo",
      "normal": "Normal text",
      "h1": "Heading 1",
      "h2": "Heading 2",
      "h3": "Heading 3",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strike": "Strikethrough",
      "code": "Inline code",
      "bulletList": "Bullet list",
      "orderedList": "Numbered list",
      "blockquote": "Blockquote",
      "codeBlock": "Code block",
      "hr": "Horizontal rule",
      "alignLeft": "Left",
      "alignCenter": "Center",
      "alignRight": "Right",
      "alignJustify": "Justify",
      "link": "Link",
      "linkPrompt": "Enter URL (leave empty to remove)",
      "image": "Upload image",
      "table": "Table",
      "tableInsert": "Insert table",
      "tableAddRow": "Add row",
      "tableAddCol": "Add column",
      "tableDelRow": "Delete row",
      "tableDelCol": "Delete column",
      "tableDelete": "Delete table",
      "source": "HTML source",
      "textStyle": "Text style",
      "fontFamily": "Font",
      "fontSize": "Font size",
      "align": "Alignment",
      "fontDefault": "Default font",
      "sizeDefault": "Default size",
      "lineHeight": "Line height",
      "lineHeightDefault": "Default spacing",
      "textColor": "Text color",
      "highlightColor": "Highlight color",
      "removeColor": "Remove color",
      "superscript": "Superscript",
      "subscript": "Subscript",
      "clearFormatting": "Clear formatting",
      "taskList": "Checklist",
      "indent": "Increase indent",
      "outdent": "Decrease indent",
      "emoji": "Emoji",
      "specialChars": "Special characters",
      "emojiGroups": {
        "smileys": "Smileys",
        "gestures": "People & gestures",
        "hearts": "Hearts & symbols",
        "objects": "Objects & work",
        "travel": "Travel & places",
        "nature": "Nature & food",
        "fun": "Activities & fun"
      }
    },
    "image": {
      "uploading": "Uploading image…",
      "uploadFailed": "Couldn't upload the image. Please try again.",
      "tooLarge": "Images must be 25 MB or smaller.",
      "open": "Open image",
      "remove": "Remove image"
    }
  },
  "sentry": {
    "dsnNotFound": "Sentry DSN not found. Error tracking is disabled.",
    "nonErrorCaught": "Non-Error object caught"
  },
  "development": {
    "detailsMode": "development mode",
    "errorLogged": "Error logged:",
    "messageLogged": "Message logged:",
    "nonErrorBoundary": "Non-Error object caught in fallback:",
    "errorBoundaryLog": "Error Boundary caught an error:",
    "sentryEvent": "Sentry event:"
  },
  "sidePanel": {
    "open": "Open phone panel",
    "resize": "Resize panel"
  },
  "onboarding": {
    "topmeta": {
      "default": "Guided setup · about 3 minutes",
      "agent": "Agent setup · about 3 minutes",
      "manager": "Manager setup · about 3 minutes"
    },
    "hero": {
      "eyebrow": "Welcome",
      "title": "Become the <0>top broker in your shop</0> — without adding hours.",
      "subtitle": "TheCarGo runs the busywork that slows brokers down: the follow-ups, the status changes, the copy-paste between tabs. You focus on booking loads. Pick your seat to start.",
      "trust": "Works in any browser — desktop, laptop, or phone. Nothing to install. Pick up any deal from anywhere.",
      "cta": "See my setup",
      "roles": {
        "agent": {
          "title": "I close deals",
          "who": "Sales agent / broker",
          "promise": "Turn the leads you already pay for into booked orders — and out-work a bigger desk without working longer."
        },
        "manager": {
          "title": "I run the team",
          "who": "Manager / owner",
          "promise": "Grow output without new hires. Full transparency, texting compliance handled, and the busywork off your team's plate."
        }
      }
    },
    "tour": {
      "stepCount": "Step {{step}} of {{total}}",
      "back": "Back",
      "next": "Next",
      "finish": "Finish setup",
      "skip": "Skip tour",
      "comingSoon": "Coming soon",
      "keysHint": "Tip: use the ← → arrow keys to move between steps"
    },
    "finish": {
      "showAround": "Show me around",
      "explore": "Explore on my own",
      "restart": "Start over",
      "agent": {
        "title": "You're set up to close more.",
        "sub": "Every lead followed up, every status current, every call one click away. Here's what changes on day one:",
        "wins": {
          "followUp": "You stop losing leads you already paid for — follow-up runs on its own.",
          "autoMove": "You never re-type a status again — a customer's reply moves the deal for you.",
          "phone": "Calls and texts live inside the deal — the order opens itself when a customer reaches out.",
          "onePanel": "Everything about a deal lives in one panel — no more copy-paste between tabs."
        }
      },
      "manager": {
        "title": "You're set up to scale.",
        "sub": "More booked loads per agent, texting compliance handled, full visibility — without adding headcount. Here's what changes:",
        "wins": {
          "output": "Your team's output climbs without new hires — automations do the busywork.",
          "compliance": "You stop losing messages to compliance blocks — 10DLC is handled.",
          "visibility": "You see every agent, number and deal from one screen, with a full audit trail.",
          "tracking": "You out-differentiate competitors with branded 24/7 live tracking."
        }
      }
    },
    "dash": {
      "step": "Quick tour · {{step}} of {{total}}",
      "skip": "Skip tour",
      "next": "Next",
      "done": "Done",
      "nav": {
        "title": "Your pipeline lives here",
        "body": "Leads become quotes, quotes become orders — same deal, three stages. Everything else (tasks, customers, carriers, insights) is one click down the rail."
      },
      "search": {
        "title": "Find anything instantly",
        "body": "Search customers, orders, phone numbers — one box for the whole workspace. Paste a number and it finds the deal."
      },
      "create": {
        "title": "Create in one click",
        "body": "New quote, order or customer from anywhere — no need to leave the page you're on."
      },
      "notifications": {
        "title": "Never miss a reply",
        "body": "New leads, replies and status changes land here in real time, so nothing goes cold quietly."
      },
      "tabs": {
        "title": "Workspace tabs",
        "body": "This strip works like browser tabs, inside the app: park an order in one tab, a lead list in another, and flip between them instantly. Unlock it and it collapses into a tiny notch that takes zero space."
      }
    },
    "whatsNew": {
      "eyebrow": "New",
      "gotIt": "Got it",
      "workspaceTabs": {
        "title": "Meet workspace tabs",
        "body": "This strip works like browser tabs, inside the app: park an order in one tab, a lead list in another, and flip between them instantly. Ctrl-click any link to open it in a new tab. Prefer the space back? The lock on the right hides the strip until you hover the top edge."
      }
    },
    "tracks": {
      "agent": {
        "phases": {
          "setup": "Set up",
          "run": "Run your day",
          "win": "Win more deals",
          "standout": "Stand out"
        },
        "intro": {
          "nav": "About your desk",
          "kicker": "Quick question",
          "title": "Where do most of your deals come from?",
          "lede": "One tap so we can show you the fastest path to more booked orders. You can change anything later.",
          "options": {
            "leads": {
              "title": "Bought leads",
              "sub": "You buy volume and need to work every one"
            },
            "dealers": {
              "title": "Dealers & repeat clients",
              "sub": "Rate confirmations and repeat loads"
            },
            "mix": {
              "title": "A mix of both",
              "sub": "A bit of everything"
            }
          }
        },
        "steps": {
          "dashboard": {
            "nav": "Your dashboard",
            "kicker": "Leads · Quotes · Orders",
            "title": "Open the app and it already knows what needs you.",
            "lede": "No blank screen, no hunting. Your Leads, Quotes and Orders sort themselves by what's slipping — so the first thing you see is the next thing to do.",
            "aha": "Brokers lose deals in the gaps, not the calls. TheCarGo surfaces the gap before it goes cold."
          },
          "quoting": {
            "nav": "One simple quote",
            "kicker": "Quoting",
            "title": "Quoting is one screen — nothing new to learn.",
            "lede": "Enter the route and the vehicle; the price fields are right there. And soon, customers will get your own branded quote page that prices itself 24/7 while you sleep.",
            "aha": "Nobody wants to learn new software. So the fastest path to a price is one exact form, not a maze of options."
          },
          "automation": {
            "nav": "Follow-up on autopilot",
            "kicker": "Automations",
            "title": "You follow up 100% of the time — without lifting a finger.",
            "lede": "Set it once. TheCarGo texts and emails your quote on schedule. The moment a customer replies \"yes\", the deal moves forward on its own. Reply \"STOP\" and it archives cleanly — compliant, no manual cleanup.",
            "aha": "Most leads book after the 5th touch — the one busy brokers never send. Now it always gets sent."
          },
          "phone": {
            "nav": "Phone in the deal",
            "kicker": "TheCarGo Phone",
            "title": "The phone lives where the deal lives.",
            "lede": "Call and text from inside the order — the whole history is right there. When a customer texts, TheCarGo finds them and opens their orders instantly. No more copy-pasting a number into another tab to figure out who's calling.",
            "aha": "Killing the tab-hunt saves minutes on every call — hours back across a full day of dialing."
          },
          "dialer": {
            "nav": "Power dialing",
            "kicker": "10x your output",
            "title": "Make far more calls in the same hours.",
            "lede": "Load your follow-up list and TheCarGo will dial the next number the second you hang up. No dialing, no waiting on ring-outs — just talking. Same input, multiples of the output.",
            "aha": "Booking is a numbers game. Double the conversations, double your shots on goal — no new hires."
          },
          "panel": {
            "nav": "Everything in one panel",
            "kicker": "Order detail",
            "title": "Open a deal and the whole story is on one panel.",
            "lede": "Customer, route, vehicle, payments and documents — all in the order panel. Nothing lives in a second system. Nothing needs copying anywhere.",
            "aha": "The richer the single view, the fewer tabs, tools and mistakes. One source of truth per deal."
          },
          "tabs": {
            "nav": "Workspace tabs",
            "kicker": "Multitask like a browser",
            "title": "Keep every deal you're juggling one click away.",
            "lede": "Workspace tabs work like browser tabs, inside the app: park an order here, a lead list there, and flip between them instantly. They sit in a slim strip at the top — lock it away and it shrinks to a tiny notch that takes zero screen space.",
            "aha": "Juggling five deals used to mean five browser tabs and five logins' worth of waiting. Now it's one click."
          },
          "tracking": {
            "nav": "24/7 tracking",
            "kicker": "Branded live tracking",
            "title": "Your customers track their car themselves — around the clock.",
            "lede": "Every customer gets a live tracking page: the route on a map, the truck moving along it, and the current status — any time, on any device. Fewer \"where's my car\" calls for you, and you look like the pro they were right to pick.",
            "aha": "Live tracking is what separates you from the shop that still answers with \"I'll check and call you back.\""
          }
        }
      },
      "manager": {
        "phases": {
          "setup": "Set up",
          "visibility": "See everything",
          "leads": "Never lose a lead",
          "scale": "Scale without hires",
          "differentiate": "Differentiate"
        },
        "intro": {
          "nav": "About your desk",
          "kicker": "Quick question",
          "title": "How big is your desk?",
          "lede": "One tap so we can show you where the biggest wins are. Nothing is locked — you can adjust later.",
          "options": {
            "solo": {
              "title": "Solo operator",
              "sub": "Just you, running the whole desk"
            },
            "small": {
              "title": "2–5 agents",
              "sub": "A small growing team"
            },
            "large": {
              "title": "6–15 agents",
              "sub": "High lead volume, every month"
            }
          }
        },
        "steps": {
          "insights": {
            "nav": "One screen, full visibility",
            "kicker": "Insights",
            "title": "See every agent and every deal in one place.",
            "lede": "Conversion, response times, revenue by agent — plus an audit trail of who touched what. No more asking around. The whole desk is visible at a glance.",
            "aha": "You can't coach what you can't see. This turns \"I think Marcus is behind\" into a number you act on today."
          },
          "numbers": {
            "nav": "Numbers & 10DLC",
            "kicker": "Compliance",
            "title": "Never lose a text to a compliance block again.",
            "lede": "Manage every phone number, opt-out and 10DLC campaign from one screen. Flip compliance on and every message stays deliverable — automatically.",
            "aha": "A blocked text is a lost booking you already paid the lead for. This closes that leak for good."
          },
          "loadboards": {
            "nav": "Two-way load boards",
            "kicker": "Super Dispatch + Central Dispatch",
            "title": "Post to both boards from one screen — and stop the double-work.",
            "lede": "Two-way integration with Super Dispatch and Central Dispatch. Post, repost and dispatch from inside TheCarGo — no stale posts, no flood of calls on cars that already moved.",
            "aha": "When your cross-post link breaks, you post the same load twice and forget to remove it. This makes that problem disappear."
          },
          "automations": {
            "nav": "Output without hires",
            "kicker": "The digital workforce",
            "title": "Grow output without growing headcount.",
            "lede": "Auto follow-up, auto status changes, posting to both boards — the repetitive work that used to eat an agent's day now runs on its own. Each agent handles more without working more.",
            "aha": "The cheapest capacity you'll ever add is the work your team stops doing by hand."
          },
          "roles": {
            "nav": "Roles & security",
            "kicker": "Access control",
            "title": "Every agent sees their own book — and you see all of it.",
            "lede": "Agents access only their own data; managers see everything. Per-user audit logs mean no silent data leaks. Roles and permissions match who's actually ready for what.",
            "aha": "Security isn't a feature you sell — it's the reason a dealer trusts you with their fleet. Get it wrong once and it's over."
          },
          "templates": {
            "nav": "Templates & brand",
            "kicker": "Email & SMS",
            "title": "Lock the message, open the brand.",
            "lede": "Your team can't break the wording or the compliance — the content is set once, centrally. Every customer gets the same on-brand, compliant message, with the opt-out line always in place.",
            "aha": "Consistency is trust. No rogue copy, no missed opt-out line, no surprises in front of a customer."
          },
          "tracking": {
            "nav": "Differentiate & win",
            "kicker": "Branded 24/7 tracking",
            "title": "Give customers something your competitors can't.",
            "lede": "Live 24/7 tracking under your name, on any device: the route on a map, the truck moving along it, and the current status. It wins the dealers and repeat-freight clients who expect a real portal — while your team sleeps.",
            "aha": "When a shipper compares you to a broker with no tracking page, the decision makes itself."
          }
        }
      }
    },
    "mocks": {
      "triage": {
        "title": "My work",
        "newQuote": "+ New Quote",
        "tabLeads": "Leads",
        "tabQuotes": "Quotes",
        "tabOrders": "Orders",
        "attention": "3 quotes waiting on you · 1 quote expiring today",
        "quotedAgo": "Quoted 4h ago",
        "repliedAgo": "Replied 2m ago",
        "expiresToday": "Expires today",
        "followUp": "Follow up",
        "newReply": "New reply",
        "expiring": "Expiring"
      },
      "quote": {
        "portalNote": "your branded page",
        "from": "From",
        "to": "To",
        "vehicle": "Year / Make / Model",
        "instant": "Instant quote",
        "bookNow": "Book now"
      },
      "peek": {
        "order": "Order {{id}}",
        "active": "Active",
        "customer": "Customer",
        "name": "Name",
        "route": "Route",
        "vehicleLabel": "Vehicle",
        "payments": "Payments",
        "deposit": "Deposit received",
        "income": "Income",
        "carrierPay": "Carrier pay scheduled",
        "carrierPayTag": "Carrier Pay",
        "documents": "Documents"
      },
      "chat": {
        "autoFollowUp": "Auto follow-up · touch 3 of 8",
        "awaitingReply": "Awaiting reply",
        "active": "Active",
        "followUpMsg": "Hi Marcus, still planning that Dallas → Phoenix move? Your quote of {{price}} is locked for you. Reply YES to book.",
        "replyYes": "yes let's book it",
        "movedNote": "Deal moved to Active automatically — no click needed.",
        "tryIt": "▶ See what happens when they reply"
      },
      "match": {
        "inboundMatched": "Inbound text · matched in 0.2s",
        "live": "Live",
        "inMsg": "Hey is my car still on track for Friday?",
        "openedNote": "Opened Order {{order}} — {{name}}. Full history loaded.",
        "outMsg": "Hi Dan! Yes — carrier confirmed, pickup Friday AM. Sending tracking now."
      },
      "dialer": {
        "queue": "Call queue",
        "left": "{{count}} left",
        "onCall": "On call",
        "next": "next",
        "multiplier": "10x",
        "caption": "calls per hour vs. dialing by hand"
      },
      "tabs": {
        "caption": "The tab strip sits at the top of the screen — unlock it and it collapses to a notch."
      },
      "tracking": {
        "status": "In transit",
        "eta": "On its way — estimated delivery Dec 8",
        "liveTitle": "Live tracking",
        "liveDetail": "Last reported near Brunswick, GA · updated 9:12 AM"
      },
      "insights": {
        "booked": "Booked this month",
        "bookedDelta": "↑ 18% vs last",
        "response": "Avg. response",
        "responseDelta": "↓ fastest ever",
        "leadRate": "Lead → book rate",
        "leadRateDelta": "2 agents lagging",
        "chartCaption": "Booked orders · last 7 weeks",
        "auditQuoted": "{{name}} quoted Order {{order}}",
        "auditWhen1": "2m ago",
        "auditPay": "{{name}} changed carrier pay",
        "auditWhen2": "14m ago"
      },
      "numbers": {
        "mainLine": "Main line",
        "sharedLine": "Shared line",
        "directLine": "Direct line",
        "compliant": "Compliant",
        "toggleTitle": "Auto opt-out handling (STOP / START)",
        "toggleSub": "Consent stored on the number · survives re-imports",
        "okNote": "All numbers compliant · 0 messages blocked",
        "blockedNote": "12 messages blocked this week"
      },
      "boards": {
        "dispatchOrder": "Dispatch Order",
        "updateBoard": "Update LB",
        "acceptRequest": "Accept Request",
        "post": "Post to LB",
        "repost": "Repost",
        "connected": "Two-way · connected",
        "note": "Delivered loads removed from both boards · 0 stale posts"
      },
      "autos": {
        "title": "Running for your team right now",
        "followUp": "Auto follow-up",
        "followUpStat": "1,240 touches sent this week",
        "statusOnReply": "Auto status on reply",
        "statusOnReplyStat": "86 deals moved to Active",
        "crossPost": "Cross-post CD + SD",
        "crossPostStat": "Post & repost from one screen",
        "cleanup": "Delivered loads removed",
        "cleanupStat": "No stale posts, no call floods",
        "on": "On"
      },
      "roles": {
        "senior": "Senior",
        "mid": "Mid",
        "junior": "Junior",
        "ownBook": "Own book",
        "you": "{{name}} (you)",
        "manager": "Manager",
        "fullAccess": "Full access + audit"
      },
      "template": {
        "title": "Quote follow-up — SMS",
        "body": "Hi <0>First name</0>, your <1>Route</1> quote of <2>Price</2> is locked. Reply YES to book. Reply STOP to opt out.",
        "lockRow": "Content locked · GSM-7 compliant · opt-out included"
      }
    },
    "samples": {
      "unknownInitials": "?",
      "portalHost": "quote.yourbrokerage.com",
      "tracking": {
        "host": "tracking.yourbrokerage.com",
        "origin": "Glassboro, NJ",
        "destination": "Auburndale, FL"
      },
      "inboundNumber": "+1 (602) 555-0147",
      "orderId": "#4821",
      "deals": {
        "d1": {
          "customer": "Marcus Webb",
          "route": "Dallas → Phoenix",
          "vehicle": "2021 Ford F-150"
        },
        "d2": {
          "customer": "Priya Nadar",
          "route": "Miami → Newark",
          "vehicle": "2020 Honda Accord"
        },
        "d3": {
          "customer": "Dan Ramos",
          "route": "Reno → Austin",
          "vehicle": "2022 Toyota 4Runner"
        },
        "d4": {
          "customer": "Lena Ortiz",
          "route": "Tampa → Denver",
          "vehicle": "2019 Jeep Wrangler"
        }
      },
      "quote": {
        "price": "$850",
        "from": "Dallas, TX",
        "to": "Phoenix, AZ"
      },
      "lines": {
        "l1": "+1 (214) 555-0100",
        "l2": "+1 (214) 555-0142",
        "l3": "+1 (602) 555-0147"
      },
      "tabs": {
        "t1": "Orders",
        "t2": "Marcus Webb",
        "t3": "Insights"
      },
      "stats": {
        "booked": "312",
        "response": "2m 40s",
        "leadRate": "14.2%"
      },
      "team": {
        "a1": "Aydos S.",
        "a2": "Lena Ortiz",
        "a3": "Marcus Webb",
        "manager": "Ray T."
      },
      "boards": {
        "sd": "Super Dispatch",
        "cd": "Central Dispatch"
      },
      "docs": {
        "d1": "Contract.pdf",
        "d2": "Invoice.pdf",
        "d3": "BOL.pdf"
      }
    }
  },
  "phonePanel": {
    "title": "Phone",
    "copyNumber": "Click to copy",
    "numberCopied": "Number copied",
    "coach": {
      "skip": "Skip tour",
      "next": "Next",
      "done": "Done",
      "step": "Step {{step}} of {{total}}",
      "open": {
        "title": "Your Phone lives here",
        "body": "Call, text, and see every conversation without leaving your work. Click to open it."
      },
      "line": {
        "title": "Pick your line",
        "body": "Calls and texts go out from this number. Switch it anytime — the whole Phone follows."
      },
      "filters": {
        "title": "One inbox for everything",
        "body": "Calls, texts, voicemail, missed — all here, in time order. Filter with the chips."
      },
      "openchat": {
        "title": "Open a conversation",
        "body": "Tap any row to see the rest — a customer's live orders and the full call & text history."
      },
      "orders": {
        "title": "The order comes to you",
        "body": "A customer's live loads sit at the top of the thread. Tap one to open the order — no searching."
      },
      "mic": {
        "title": "Talk or type, never leave",
        "body": "Start a call or text from any order. Hold the mic to dictate instead of typing."
      }
    },
    "collapse": "Collapse panel",
    "dialpad": "Dialpad",
    "newMessage": "New message",
    "searchPlaceholder": "Search messages, emails, transcripts, numbers and names…",
    "refresh": "Refresh",
    "linePlaceholder": "No active line",
    "lineCannotText": "The selected line can't send texts. Pick another line to send.",
    "callDisabled": {
      "connecting": "The phone is connecting…",
      "offline": "The phone isn't connected.",
      "busy": "Another call is in progress.",
      "loadingLines": "Loading your phone lines…",
      "lineCannotCall": "This line can't place calls. Pick another line."
    },
    "filter": "Filter",
    "callBack": "Call back",
    "aiTag": "AI",
    "date": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "preview": {
      "you": "You: {{text}}",
      "failed": "Failed to send · Tap to retry",
      "media": "📷 Photo"
    },
    "newSms": {
      "aria": "New message from {{name}}. Tap to open."
    },
    "unreadBadge": "{{count}} unread conversations",
    "list": {
      "empty": "No conversations yet",
      "error": "Couldn't load conversations"
    },
    "actionToast": {
      "favorite": "Added to favorites",
      "unfavorite": "Removed from favorites",
      "block": "Number blocked",
      "unblock": "Number unblocked",
      "read": "Marked as read",
      "unread": "Marked as unread",
      "mute": "Notifications muted",
      "unmute": "Notifications unmuted",
      "delete": "Conversation deleted",
      "error": "Couldn't complete that action"
    },
    "filters": {
      "all": "All",
      "unread": "Unread",
      "calls": "Calls",
      "sms": "SMS",
      "missed": "Missed",
      "voicemail": "Voicemail"
    },
    "retry": "Retry",
    "expand": "Expand",
    "newText": {
      "title": "New text",
      "to": "To",
      "toPlaceholder": "Name or number",
      "clear": "Clear recipient",
      "contacts": "Contacts",
      "selectContact": "Message {{name}}",
      "emptyState": "Pick a contact or enter a number to start",
      "noRecipient": "Enter a recipient number first"
    },
    "favorites": {
      "count_one": "{{count}} favorite",
      "count_other": "{{count}} favorites",
      "manage": "Manage",
      "done": "Done",
      "recentActivity": "Recent activity",
      "empty": "No favorites yet",
      "emptyHint": "Star a contact to keep it one tap away.",
      "call": "Call {{name}}",
      "text": "Message {{name}}",
      "remove": "Remove {{name}} from favorites"
    },
    "blocked": {
      "tab": "Blocked",
      "count_one": "{{count}} blocked number",
      "count_other": "{{count}} blocked numbers",
      "empty": "No blocked numbers",
      "emptyHint": "Numbers you block will show up here."
    },
    "onCall": {
      "via": "Via {{line}}",
      "status": "On call",
      "calling": "Calling…",
      "held": "On hold",
      "liveTranscript": "Live transcript",
      "startTranscript": "Start",
      "stopTranscript": "Stop",
      "transcriptOffHint": "Transcription is off — start it to see live captions of the caller.",
      "transcribing": "Transcribing",
      "collapseTranscript": "Collapse transcript",
      "expandTranscript": "Expand transcript",
      "transcriptError": "Transcript unavailable",
      "copyTranscript": "Copy transcript",
      "transcriptCopied": "Transcript copied",
      "transcriptDisclaimer": "AI-generated — transcription may not be 100% accurate",
      "notePlaceholder": "Add a note during the call…",
      "noteNoShipment": "No linked order to note",
      "saveNote": "Save note to order",
      "noteSaved": "Note added to the order",
      "noteError": "Couldn't save the note",
      "mute": "Mute",
      "unmute": "Unmute",
      "keypad": "Keypad",
      "keypadDigits": "Digits sent to the call",
      "keypadEmpty": "Dial digits for phone menus",
      "hold": "Hold",
      "transfer": "Transfer",
      "endCall": "End call",
      "minimize": "Minimize — call stays active",
      "minimizeAction": "Minimize call"
    },
    "voicemail": {
      "transcription": "Transcription",
      "text": "Text",
      "markAsHeard": "Mark as heard"
    },
    "keypad": {
      "title": "New call",
      "callingFrom": "Calling from",
      "placeholder": "Enter name or number",
      "backspace": "Delete",
      "call": "Call",
      "callContact": "Call {{name}}"
    },
    "filterPanel": {
      "title": "Filters",
      "reset": "Reset",
      "apply": "Apply filters",
      "direction": "Direction",
      "directionAll": "All",
      "inbound": "Inbound",
      "outbound": "Outbound",
      "status": "Status",
      "unread": "Unread",
      "failed": "Failed",
      "favorites": "Favorites",
      "muted": "Muted",
      "agent": "Agent",
      "allAgents": "All agents",
      "you": "You",
      "date": "Date",
      "dateAll": "All time",
      "today": "Today",
      "last7": "Last 7 days",
      "last30": "Last 30 days"
    },
    "menu": {
      "more": "More options",
      "copy": "Copy number",
      "copied": "Number copied",
      "openOrder": "Open order",
      "markUnread": "Mark as unread",
      "markRead": "Mark as read",
      "favorite": "Add to favorites",
      "unfavorite": "Remove from favorites",
      "mute": "Mute notifications",
      "unmute": "Unmute notifications",
      "select": "Select conversations",
      "block": "Block number",
      "unblock": "Unblock number",
      "delete": "Delete conversation"
    },
    "actions": {
      "call": "Call",
      "sms": "Send message"
    },
    "darkMode": "Toggle dark mode",
    "select": {
      "count": "{{count}} selected",
      "selectAll": "Select all in current filter",
      "actionsHint": "Mark read · Mute · Delete",
      "markRead": "Mark read",
      "mute": "Mute",
      "delete": "Delete",
      "close": "Cancel selection",
      "deleteTitle_one": "Delete conversation?",
      "deleteTitle_other": "Delete conversations?",
      "deleteBody_one": "This permanently deletes {{count}} conversation. This can't be undone.",
      "deleteBody_other": "This permanently deletes {{count}} conversations. This can't be undone.",
      "deleteConfirm": "Delete",
      "cancel": "Cancel"
    },
    "call": {
      "onCall": "On call · {{name}}",
      "onHold": "On hold · {{name}}",
      "calling": "Calling · {{name}}",
      "mute": "Mute",
      "unmute": "Unmute",
      "hangUp": "Hang up",
      "missed": "Missed",
      "noAnswer": "No answer",
      "outbound": "Outbound",
      "inbound": "Inbound",
      "aiOutbound": "AI outbound",
      "inboundCall": "Inbound call",
      "outboundCall": "Outbound call",
      "missedCall": "Missed call"
    },
    "conversation": {
      "back": "Back",
      "call": "Call",
      "more": "More options",
      "filterFromDate": "Jump to {{date}}",
      "dateFilterTitle": "Jump to date",
      "dateFilterClose": "Close",
      "jumpToLatest": "Jump to latest",
      "activeLoads_one": "{{count}} active load",
      "activeLoads_other": "{{count}} active loads",
      "noActiveLoads": "No active loads",
      "showAll": "Show all",
      "hideAll": "Hide all",
      "loadStage": {
        "lead": "Leads",
        "quote": "Quotes",
        "order": "Orders"
      },
      "aiCallSummary": "AI Call Summary",
      "noRecording": "No recording available",
      "loadingRecording": "Loading recording…",
      "play": "Play recording",
      "pause": "Pause recording",
      "seek": "Seek recording",
      "playbackSpeed": "Playback speed",
      "from": "From",
      "placeholder": "Text message…",
      "attach": "Attach file",
      "send": "Send message",
      "voice": "Dictate a message",
      "openOrder": "Open order #{{code}}",
      "removeAttachment": "Remove attachment",
      "maxFiles": "You can attach up to {{max}} files",
      "maxSize": "Attachments must total under {{max}} MB",
      "blockedNotice": "You blocked this number",
      "unblock": "Unblock",
      "scrollToBottom": "Scroll to latest",
      "viewPhoto": "View photo",
      "photo": "Photo",
      "closePhoto": "Close photo",
      "downloadPhoto": "Download photo",
      "prevPhoto": "Previous photo",
      "nextPhoto": "Next photo",
      "photoCounter": "{{current}} / {{total}}",
      "dropToAttach": "Drop files to attach",
      "loading": "Loading conversation…",
      "empty": "No messages yet",
      "failureDetails": "Delivery failure details",
      "sendError": "Couldn't send your message",
      "sendRejectedOptedOut": "This contact has opted out of texts (replied STOP)",
      "sendRejectedBlocked": "Texting this number is blocked",
      "sendRejectedUndeliverable": "This number can't receive texts",
      "sendRejectedDuplicate": "This message was already sent",
      "noLine": "No SMS-capable line available"
    },
    "search": {
      "chats": "Chats",
      "messages": "Messages",
      "seeAll": "See all",
      "youPrefix": "You: ",
      "empty": "No matches found",
      "error": "Couldn't run the search",
      "inThread": "Search in conversation"
    }
  },
  "adminBuyNumbers": {
    "back": "Numbers",
    "title": "Buy numbers",
    "subtitle": "Search available numbers and buy them in one order. {{amount}} per number per month.",
    "tabs": {
      "standard": "Standard",
      "imessage": "Premium"
    },
    "imessage": {
      "subtitle": "Premium numbers. Calling and texting — no MMS.",
      "empty": "No premium numbers are available right now — check back later.",
      "error": "Couldn't load available premium numbers.",
      "retry": "Try again",
      "buy": "Buy",
      "buying": "Buying…",
      "toast": {
        "purchased": "Premium number {{number}} purchased — assign it from the Number tab."
      }
    },
    "types": {
      "local": "Local",
      "toll_free": "Toll-Free",
      "mobile": "Mobile",
      "national": "National"
    },
    "form": {
      "type": "Type",
      "areaCode": "Area code",
      "contains": "Contains",
      "containsPlaceholder": "Optional",
      "search": "Search numbers"
    },
    "table": {
      "number": "Number",
      "location": "Location",
      "monthly": "Monthly",
      "add": "Add",
      "added": "Added"
    },
    "cart": {
      "title": "Cart ({{count}})",
      "empty": "No numbers added yet.",
      "remove": "Remove from cart",
      "monthly": "Monthly",
      "perMonth": "{{amount}} / mo",
      "dueToday": "Due today",
      "buy_one": "Buy {{count}} number",
      "footnote": "Numbers go live immediately — assign them to agents from the Number tab.",
      "buy_other": "Buy {{count}} numbers"
    },
    "toast": {
      "purchased_one": "{{count}} number purchased",
      "error": "Something went wrong",
      "purchased_other": "{{count}} numbers purchased"
    },
    "confirm": {
      "title": "Confirm purchase",
      "subtitle_one": "{{count}} local number, billed to the card on file.",
      "subtitle_other": "{{count}} local numbers, billed to the card on file.",
      "monthly": "Monthly",
      "payment": "Payment",
      "cardOnFile": "{{brand}} ·· {{last4}} on file",
      "dueToday": "Due today",
      "footnote": "Charged now. Numbers go live immediately and can be released anytime.",
      "cancel": "Cancel",
      "confirm": "Confirm & buy"
    }
  },
  "adminOrders": {
    "empty": "—",
    "status": {
      "completed": "Completed"
    },
    "columns": {
      "purchased": "Purchased",
      "orderId": "Order ID",
      "number": "Number",
      "type": "Type",
      "status": "Status",
      "total": "Total",
      "placedBy": "Placed by"
    },
    "detail": {
      "title": "Order details",
      "placedBy": "{{date}} · Placed by {{email}}",
      "close": "Close",
      "status": "Status",
      "orderId": "Order ID",
      "country": "Country",
      "countryValue": "United States",
      "phoneNumbers": "Phone numbers ({{count}})",
      "copyAll": "Copy all",
      "copied": "Copied to clipboard",
      "number": "Number",
      "locality": "Locality",
      "numberStatus": "Status",
      "footnote": "Numbers from this order are live in your My Numbers tab."
    }
  },
  "adminPorting": {
    "empty": "—",
    "description": "Ports usually complete in 7–10 business days. We handle the carrier paperwork once you submit.",
    "unconfirmed": "Unconfirmed",
    "notSubmitted": "Not submitted",
    "detail": {
      "title": "Porting request",
      "information": "Porting details",
      "close": "Close",
      "loadError": "Couldn't load this porting request.",
      "status": "Status",
      "numbers": "Numbers",
      "currentCarrier": "Current carrier",
      "customerReference": "Customer reference",
      "focDate": "FOC date",
      "lastStatus": "Latest status",
      "supportKey": "Support key",
      "telnyxId": "Carrier order ID",
      "created": "Created",
      "updated": "Updated"
    },
    "more": "+{{count}}",
    "newPorting": "New porting request",
    "numbers": "Numbers",
    "heading": "New porting request",
    "subheading": "Move your existing business numbers onto TheCarGo. Most ports complete in 7–10 business days.",
    "back": "Back",
    "cancel": "Cancel",
    "saveDraft": "Save as draft",
    "required": "Required",
    "optional": "Optional",
    "orderMeta": "{{ref}} · {{count}} numbers",
    "steps": {
      "check": "Check portability",
      "create": "Create order",
      "details": "Order details",
      "documents": "Documents",
      "review": "Review & submit"
    },
    "rail": {
      "note": "Ports usually complete in 7–10 business days. We handle the carrier paperwork after you submit."
    },
    "check": {
      "title": "Check portability",
      "numbersLabel": "Phone numbers",
      "numbersHint": "Separate numbers with commas or line breaks. Numbers outside North America need E.164 format (+44…).",
      "numbersPlaceholder": "+13454533453\n+19084470212\n+17326180945",
      "notice": "We check each number with the carrier. Only portable numbers continue to the order — nothing changes on your current service yet.",
      "submit": "Check portability"
    },
    "create": {
      "title": "Create order",
      "subtitle": "Portable numbers ({{count}})",
      "number": "Number",
      "carrier": "Carrier",
      "type": "Type",
      "status": "Status",
      "portable": "Portable",
      "notice": "Creating the order reserves these numbers with the carrier. Your current service keeps working until the port completes.",
      "submit": "Create order"
    },
    "details": {
      "title": "Order details",
      "accountTitle": "Account with current carrier",
      "accountHint": "Must match what is on file with the carrier you are leaving — mismatches get ports rejected.",
      "endUserName": "End user name (business)",
      "authorizedName": "Authorized person",
      "billingPhone": "Billing telephone number (BTN)",
      "accountNumber": "Account number",
      "pinPasscode": "PIN / passcode",
      "customerReference": "Customer reference",
      "addressTitle": "Service address",
      "addressHint": "Where the numbers sit on the carrier records — usually not the billing address.",
      "address": "Address",
      "suite": "Suite or unit",
      "suitePlaceholder": "Apt, suite, floor",
      "city": "City",
      "state": "State / region",
      "zip": "ZIP / postal code",
      "country": "Country",
      "countryUs": "United States",
      "activationTitle": "Activation",
      "portType": "Port type",
      "fullPort": "Full port",
      "fullPortHint": "— every number on the account moves",
      "partialPort": "Partial port",
      "partialPortHint": "— only the numbers in this order move",
      "expedited": "Eligible for expedited porting — same-week activation is available for these numbers.",
      "activationDate": "Requested activation date",
      "earliest": "Earliest available date",
      "specific": "Specific date",
      "activationMode": "On the activation date",
      "manual": "I will activate the numbers myself",
      "automatic": "Activate automatically at the scheduled time",
      "timeLocal": "{{time}} (local)",
      "focNote": "Dates are not guaranteed — the losing carrier confirms the final activation date (FOC). We notify you the moment it locks.",
      "setupTitle": "Number setup",
      "setupHint": "Handled by TheCarGo — nothing to configure here.",
      "setupVoice": "Voice, texting, and routing are configured automatically when the port completes.",
      "setupSms": "SMS is enabled on every ported number.",
      "next": "Next: Documents"
    },
    "documents": {
      "title": "Documents",
      "intro": "The carrier verifies these against the account details from step 3. Mismatched names or missing numbers are the top cause of rejected ports.",
      "invoiceLabel": "Carrier invoice — issued within the last 90 days",
      "invoiceHint": "The most recent bill from your current carrier showing the business name, account number, and the numbers being ported.",
      "loaLabel": "Letter of Authorization (LOA)",
      "loaHint": "Generated from this order — the business name, service address, account number, and every number being ported are already filled in. You only collect the signature.",
      "loaStepGenerate": "Generate the pre-filled LOA",
      "loaStepSign": "Print and sign it — the authorized person from the order details signs, nothing else to fill in",
      "loaStepUpload": "Upload the signed copy",
      "loaUploadHint": "The carrier verifies the signature against the authorized person on the order.",
      "generate": "Generate LOA",
      "cta": "Drop a file here or tap to upload",
      "uploading": "Uploading…",
      "formats": "PNG, JPG, or PDF · up to 10MB",
      "replace": "Replace",
      "download": "Download",
      "sendForSignature": "Send for signature",
      "loaGenerated": "LOA downloaded — collect the signature, then upload the signed copy in step 3.",
      "signatureSoon": "Sending for signature isn't available yet.",
      "next": "Next: Review"
    },
    "review": {
      "title": "Review & submit",
      "businessName": "Business name",
      "authorizedPerson": "Authorized person",
      "serviceAddress": "Service address",
      "billingPhone": "Billing telephone number",
      "portType": "Port type",
      "activationDate": "Activation date",
      "earliestAvailable": "Earliest available",
      "activation": "Activation",
      "manualActivation": "Manual — you activate",
      "autoActivation": "Automatic at {{time}} (local)",
      "documents": "Documents",
      "invoice": "Invoice",
      "loa": "LOA",
      "numbers": "Numbers ({{count}})",
      "notice": "Submitting sends the request to the carrier. Track it in the Porting tab — we update the status at every stage and email you when the activation date locks.",
      "submit": "Submit porting request"
    },
    "toast": {
      "submitted": "Porting request submitted",
      "draftSaved": "Draft saved"
    },
    "errors": {
      "required": "Required",
      "invalidNumbers": "These numbers aren't valid: {{list}}",
      "noNumbers": "Enter at least one phone number.",
      "noPortable": "No portable numbers to create an order.",
      "checkFailed": "Couldn't check portability",
      "createFailed": "Couldn't create the porting order",
      "saveFailed": "Couldn't save order details",
      "uploadFailed": "Couldn't upload the document",
      "loaFailed": "Couldn't generate the LOA",
      "submitFailed": "Couldn't submit the porting request"
    },
    "filters": {
      "status": "Status"
    },
    "statusFilter": {
      "all": "All"
    },
    "columns": {
      "status": "Status",
      "name": "Name",
      "currentCarrier": "Current Carrier",
      "focDate": "FOC date",
      "submitted": "Submitted"
    },
    "status": {
      "draft": "Draft",
      "in_process": "In process",
      "submitted": "Submitted",
      "exception": "Exception",
      "foc_date_confirmed": "FOC confirmed",
      "cancel_pending": "Cancel pending",
      "cancelled": "Cancelled",
      "activation_in_progress": "Activating",
      "ported": "Completed"
    }
  },
  "adminBrands": {
    "empty": "—",
    "search": "Search brands",
    "filters": {
      "status": "Status"
    },
    "statusFilter": {
      "all": "All"
    },
    "columns": {
      "status": "Status",
      "name": "Name",
      "campaigns": "Campaigns",
      "registered": "Registered",
      "contact": "Brand contact"
    },
    "status": {
      "pending": "Pending",
      "ok": "OK",
      "registration_pending": "Registration pending",
      "registration_failed": "Registration failed",
      "deleted": "Deleted",
      "self_declared": "Self-declared",
      "verified": "Verified",
      "vetted_verified": "Vetted & verified",
      "unverified": "Unverified",
      "failed": "Failed"
    }
  },
  "adminCampaigns": {
    "empty": "—",
    "filters": {
      "brand": "Brand",
      "status": "Status"
    },
    "brandFilter": {
      "all": "All brands"
    },
    "statusFilter": {
      "all": "All"
    },
    "columns": {
      "useCase": "Use case",
      "brand": "Brand",
      "status": "Status",
      "numbers": "Numbers",
      "registered": "Registered"
    },
    "status": {
      "pending": "In review",
      "active": "Active",
      "expired": "Expired",
      "failed": "Failed",
      "registered": "Registered",
      "review": "In review",
      "rejected": "Rejected",
      "suspended": "Suspended",
      "tcr_pending": "TCR pending",
      "tcr_suspended": "TCR suspended",
      "tcr_expired": "TCR expired",
      "tcr_accepted": "TCR accepted",
      "tcr_failed": "TCR failed",
      "telnyx_accepted": "Carrier accepted",
      "telnyx_failed": "Carrier failed",
      "mno_pending": "Carrier pending",
      "mno_accepted": "Carrier accepted",
      "mno_rejected": "Carrier rejected",
      "mno_provisioned": "Carrier provisioned",
      "mno_provisioning_failed": "Carrier provisioning failed"
    },
    "useCase": {
      "2FA": "2FA",
      "ACCOUNT_NOTIFICATION": "Account notifications",
      "CUSTOMER_CARE": "Customer care",
      "DELIVERY_NOTIFICATION": "Delivery",
      "FRAUD_ALERT": "Fraud alert",
      "HIGHER_EDUCATION": "Higher education",
      "MARKETING": "Marketing",
      "MIXED": "Mixed",
      "POLLING_VOTING": "Polling & voting",
      "PUBLIC_SERVICE_ANNOUNCEMENT": "Public service announcement",
      "SECURITY_ALERT": "Security alert",
      "LOW_VOLUME": "Low volume"
    },
    "detail": {
      "close": "Close",
      "loadError": "Couldn't load this campaign.",
      "registered": "Registered {{date}}",
      "provider": "Carrier 10DLC",
      "copy": "Copy",
      "copied": "Copied to clipboard",
      "fields": {
        "useCase": "Use case",
        "tcrCampaignId": "TCR Campaign ID",
        "provider": "Provider",
        "campaignId": "Campaign ID"
      },
      "numbers": {
        "title": "Numbers",
        "assignedCount": "{{count}} assigned",
        "assignedCountOf": "{{count}} of {{total}} assigned",
        "assign": "+ Assign numbers",
        "empty": "No numbers assigned yet.",
        "unassign": "Unassign number"
      },
      "assign": {
        "searchPlaceholder": "Search numbers",
        "unassigned": "Unassigned",
        "cancel": "Cancel",
        "add_one": "Add {{count}} number",
        "add_other": "Add {{count}} numbers",
        "addDisabled": "Add numbers",
        "empty": "No numbers available.",
        "loadError": "Couldn't load numbers.",
        "toast": {
          "assigned_one": "{{count}} number assigned",
          "assigned_other": "{{count}} numbers assigned",
          "failed_one": "{{count}} number couldn't be assigned",
          "failed_other": "{{count}} numbers couldn't be assigned",
          "error": "Couldn't assign numbers"
        }
      },
      "sections": {
        "description": "Description",
        "messageFlow": "Message flow",
        "keywords": "Keywords",
        "autoResponses": "Auto-responses",
        "sampleMessages": "Sample messages",
        "complianceLinks": "Compliance links",
        "attributes": "Attributes",
        "webhooks": "Webhooks"
      },
      "keywords": {
        "optin": "Opt-in",
        "optout": "Opt-out",
        "help": "Help"
      },
      "autoResponses": {
        "optin": "Opt-in message",
        "optout": "Opt-out message",
        "help": "Help message"
      },
      "sampleMessage": "Message {{index}}",
      "compliance": {
        "privacy": "Privacy policy",
        "terms": "Terms and conditions",
        "embedded": "Embedded link"
      },
      "attributes": {
        "subscriberOptin": "Subscriber opt-in",
        "subscriberOptout": "Subscriber opt-out",
        "subscriberHelp": "Subscriber help",
        "numberPool": "Number pooling",
        "directLending": "Direct lending",
        "embeddedLink": "Embedded link",
        "embeddedPhone": "Embedded phone number",
        "ageGated": "Age-gated content",
        "yes": "Yes",
        "no": "No"
      },
      "webhooks": {
        "url": "Webhook URL",
        "failover": "Failover URL"
      },
      "readOnlyNote": "Submitted campaigns are read-only. To change content, create a new campaign.",
      "emptyValue": "—"
    },
    "newCampaign": "New campaign",
    "breadcrumb": "Numbers",
    "form": {
      "createTitle": "New campaign",
      "createSubtitle": "Registers your texting use case with carriers. $15 carrier review fee per submission.",
      "detailTitle": "Campaign details",
      "detailSubtitle": "Review your registered texting use case.",
      "required": "Required",
      "brandUseCase": "Brand & use case",
      "details": "Campaign details",
      "brandOption": "{{name}} — Verified",
      "fields": {
        "brand": "Brand",
        "useCase": "Use case",
        "description": "Description",
        "sampleMessages": "Sample messages",
        "messageFlow": "Opt-in / message flow",
        "helpMessage": "HELP reply"
      },
      "hints": {
        "brand": "Only verified brands can register campaigns.",
        "useCase": "Covers quotes, delivery updates, and promotions in one campaign — the default for brokers.",
        "switchHint": "Only sending transactional updates? Switch to Customer care — it clears carrier review faster.",
        "description": "Describe what the campaign does in 2–4 sentences (40–1024 characters).",
        "sampleMessages": "Add 2–5 example messages recipients will receive.",
        "messageFlow": "Explain how recipients opt in to receive messages.",
        "helpMessage": "Reply sent when a recipient texts HELP."
      },
      "placeholders": {
        "brand": "Select a brand",
        "description": "TheCarGo sends shipping quotes, pickup and delivery updates, and occasional promotions to customers who request a quote or place an order.",
        "sampleMessage": "Your TheCarGo quote is ready — view it here: https://...",
        "messageFlow": "Customers opt in at checkout or by texting START to our number.",
        "helpMessage": "TheCarGo: For help call (555) 123-4567. Reply STOP to unsubscribe."
      },
      "addSample": "Add message",
      "removeSample": "Remove",
      "next": "Next: Campaign details",
      "nextReview": "Next: Review & submit",
      "submit": "Submit for review",
      "cancel": "Cancel",
      "back": "Back",
      "reviewSubmit": "Review & submit",
      "edit": "Edit",
      "summary": {
        "brand": "Brand",
        "useCase": "Use case",
        "sampleMessages": "Sample messages",
        "sampleCount_one": "{{count}} message",
        "sampleCount_other": "{{count}} messages"
      },
      "fees": {
        "carrierReview": "Carrier review fee",
        "carrierReviewHint": "One-time, includes resubmissions if carriers request changes",
        "carrierReviewAmount": "$15.00",
        "campaign": "Campaign fee",
        "campaignHint": "Starts when the campaign is approved",
        "campaignAmount": "$10.00 / month",
        "dueToday": "Due today",
        "dueTodayAmount": "$25.00"
      },
      "consent": "I authorize the $25.00 carrier review fee, billed to the card on file.",
      "rail": {
        "step1": "Brand & use case",
        "step2": "Campaign details",
        "step3": "Review & submit",
        "note": "Submitting charges the $15 review fee. Carriers typically respond within 1–3 business days — your numbers can text once approved."
      },
      "errors": {
        "brand": "Select a verified brand.",
        "required": "This field is required.",
        "description": "Description must be at least 40 characters.",
        "descriptionMax": "Description must be 1024 characters or fewer.",
        "sampleMin": "Add at least 2 sample messages.",
        "sampleMax": "Add no more than 5 sample messages.",
        "messageFlowMax": "Message flow must be 2048 characters or fewer.",
        "helpMessageMax": "HELP reply must be 512 characters or fewer."
      },
      "toast": {
        "created": "Campaign submitted for review",
        "error": "Couldn't register campaign"
      }
    }
  },
  "adminRegisterBrand": {
    "registerBrand": "Register brand",
    "back": "Back to brands",
    "businessInfo": "Business information",
    "contact": "Brand contact",
    "required": "Required",
    "submit": "Register Brand",
    "cancel": "Cancel",
    "consent": "I authorize the one-time brand registration fee, billed to the card on file.",
    "fields": {
      "companyName": "Legal company name",
      "displayName": "DBA or brand name",
      "entityType": "Legal form",
      "ein": "EIN",
      "vertical": "Vertical",
      "website": "Website",
      "address": "Business address",
      "email": "Brand email",
      "phone": "Brand phone"
    },
    "placeholders": {
      "ein": "12-3456789",
      "website": "yourcompany.com",
      "address": "Street, City, ST ZIP",
      "email": "ops@yourcompany.com",
      "phone": "+1 (555) 000-0000"
    },
    "hints": {
      "vertical": "Set automatically for auto transport brokerages.",
      "email": "Carriers may use this address to verify the brand."
    },
    "search": {
      "typeToSearch": "Type to search your customers…"
    },
    "entityType": {
      "PRIVATE_PROFIT": "Private (for-profit)",
      "PUBLIC_PROFIT": "Public (for-profit)",
      "NON_PROFIT": "Non-profit",
      "GOVERNMENT": "Government",
      "SOLE_PROPRIETOR": "Sole proprietor"
    },
    "vertical": {
      "PROFESSIONAL": "Professional services",
      "REAL_ESTATE": "Real estate",
      "HEALTHCARE": "Healthcare",
      "HUMAN_RESOURCES": "Human resources",
      "ENERGY": "Energy",
      "ENTERTAINMENT": "Entertainment",
      "RETAIL": "Retail",
      "AGRICULTURE": "Agriculture",
      "INSURANCE": "Insurance",
      "POSTAL": "Postal & delivery",
      "EDUCATION": "Education",
      "HOSPITALITY": "Hospitality",
      "FINANCIAL": "Financial",
      "POLITICAL": "Political",
      "GAMBLING": "Gambling",
      "LEGAL": "Legal",
      "CONSTRUCTION": "Construction",
      "NGO": "NGO",
      "MANUFACTURING": "Manufacturing",
      "GOVERNMENT": "Government",
      "TECHNOLOGY": "Technology",
      "COMMUNICATION": "Communication",
      "TRANSPORTATION": "Logistics & Transportation"
    },
    "rail": {
      "title": "What happens next",
      "step1": "We submit your details to The Campaign Registry.",
      "step2": "Verification usually completes within 1 business day.",
      "step3": "Once verified, register campaigns and start texting.",
      "note": "Webhooks, throughput, and carrier settings are managed automatically by TheCarGo."
    },
    "errors": {
      "required": "This field is required.",
      "ein": "Enter a valid EIN (XX-XXXXXXX).",
      "email": "Enter a valid email address.",
      "phone": "Enter a valid US phone number.",
      "website": "Enter a valid website (e.g. example.com).",
      "address": "Enter as Street, City, ST ZIP.",
      "consent": "Please authorize the registration fee to continue."
    },
    "toast": {
      "success": "Brand submitted for verification",
      "error": "Couldn't register brand"
    }
  },
  "themeSwitcher": {
    "label": "Change theme",
    "title": "Appearance",
    "light": "Light",
    "dark": "Night",
    "midnight": "Dark"
  },
  "inbox": {
    "search": "Search mail",
    "refresh": "Refresh",
    "moreActions": "More actions",
    "markAllRead": "Mark all as read",
    "clearSelection": "Clear selection",
    "selectAll": "Select all",
    "selectMessage": "Select \"{{subject}}\"",
    "messageList": "Messages",
    "range": "{{from}}–{{to}} of {{total}}",
    "newer": "Newer",
    "older": "Older",
    "star": "Star",
    "unstar": "Remove star",
    "hasAttachment": "Has attachment",
    "yesterday": "Yesterday",
    "toggleReadingPane": "Toggle reading pane",
    "unreadCount": "{{folder}}: {{count}} unread",
    "layout": {
      "label": "Layout",
      "list": "List view",
      "split": "Split view"
    },
    "folders": {
      "label": "Mail folders",
      "inbox": "Inbox",
      "starred": "Starred",
      "sent": "Sent",
      "drafts": "Drafts",
      "archive": "Archive",
      "trash": "Trash"
    },
    "empty": {
      "title": "Nothing here",
      "description": "New mail for this folder will show up here.",
      "filteredTitle": "No matching mail",
      "filteredDescription": "Try a different name, subject, or order number."
    },
    "reading": {
      "label": "Reading pane",
      "emptyTitle": "No message selected",
      "emptyDescription": "Pick a message from the list to read it here."
    },
    "selectedCount": "{{count}} selected",
    "actions": {
      "archive": "Archive",
      "delete": "Delete",
      "markRead": "Mark as read"
    },
    "toPrefix": "To: {{name}}",
    "opened": "Opened",
    "openedAt": "Recipient opened this on {{at}}",
    "draft": "Draft",
    "draftPane": "Draft editor",
    "noSubject": "(no subject)",
    "expandRail": "Expand folders",
    "collapseRail": "Collapse folders",
    "fields": {
      "to": "To",
      "subject": "Subject",
      "body": "Message body"
    },
    "compose": "Compose",
    "composer": {
      "send": "Send",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "link": "Insert link",
      "list": "Bulleted list",
      "attach": "Attach a file",
      "templates": "Templates",
      "discard": "Discard draft",
      "saved": "Saved {{when}}",
      "linkPlaceholder": "Paste or type a link",
      "linkApply": "Apply",
      "templateError": "The template couldn't be loaded. Please try again.",
      "maxFiles": "You can attach up to {{max}} files",
      "maxSize": "Attachments must total under {{max}} MB",
      "removeAttachment": "Remove attachment",
      "sending": "Sending…",
      "sent": "Sent",
      "sendError": "The message couldn't be sent. Please try again.",
      "missingRecipient": "Add at least one recipient before sending.",
      "invalidRecipient": "\"{{email}}\" doesn’t look like a valid email address.",
      "noMailbox": "Connect a mailbox before sending mail.",
      "to": "To",
      "cc": "Cc",
      "bcc": "Bcc",
      "recipientsPlaceholder": "Add recipients, comma separated",
      "removeRecipient": "Remove {{email}}"
    },
    "toMe": "to me",
    "reply": "Reply",
    "replyTo": "Reply to {{name}}",
    "replyPlaceholder": "Write a reply…",
    "moveToInbox": "Move to inbox",
    "trash": {
      "retention": "Messages in Trash are deleted after 30 days.",
      "emptyNow": "Empty Trash now"
    },
    "composeWindow": {
      "title": "New Message",
      "minimize": "Minimize",
      "restore": "Restore",
      "expand": "Expand",
      "shrink": "Shrink",
      "close": "Close",
      "ccBcc": "Cc  Bcc",
      "subjectPlaceholder": "Subject",
      "signature": "TheCarGo Logistics · (555) 010-2244",
      "sentWith": "Sent with",
      "from": "From"
    },
    "newMail": {
      "aria": "New email from {{name}}. Tap to open.",
      "unknownSender": "New email",
      "noSubject": "(no subject)"
    },
    "closeSearch": "Close search",
    "exitSelection": "Leave selection",
    "messageBody": "Message body",
    "messageCount": "{{count}} messages in this conversation",
    "starred": "Starred",
    "today": "Today",
    "undated": "Earlier",
    "accounts": {
      "filter": "Show only {{mailbox}}",
      "showAll": "Show all mailboxes",
      "mark": "Arrived in {{mailboxes}}",
      "settings": "Mailbox settings",
      "label": "Mailboxes",
      "settingsShort": "Settings",
      "show": "Show mailboxes",
      "hide": "Hide mailboxes",
      "add": "Add mailbox"
    },
    "replyAll": "Reply all",
    "forward": "Forward",
    "backToList": "Back to the list",
    "confirm": {
      "cancel": "Cancel",
      "archiveTitle_one": "Archive {{count}} message?",
      "archiveTitle_other": "Archive {{count}} messages?",
      "archiveDescription": "They move out of this folder into Archive, in TheCargo and in your mail account.",
      "deleteTitle_one": "Move {{count}} message to Trash?",
      "deleteTitle_other": "Move {{count}} messages to Trash?",
      "deleteDescription": "They move to Trash in your mail account. You can put them back from there.",
      "markReadTitle_one": "Mark {{count}} message as read?",
      "markReadTitle_other": "Mark {{count}} messages as read?",
      "markReadDescription": "They are marked read here and in your mail account.",
      "markAllReadTitle_one": "Mark the {{count}} unread message as read?",
      "markAllReadTitle_other": "Mark all {{count}} unread messages as read?",
      "emptyTrashTitle": "Empty Trash?",
      "emptyTrashDescription": "The listed messages are deleted from your mail account permanently. This cannot be undone.",
      "emptyTrashConfirm": "Delete forever"
    },
    "actionError": "The mail action failed. Please try again.",
    "downloadError": "The attachment couldn't be downloaded. Please try again.",
    "connectGate": {
      "title": "No mailbox connected",
      "description": "Connect your work email to read and send mail without leaving TheCargo.",
      "connect": "Connect mailbox"
    },
    "rowMenu": {
      "openOrder": "Open order",
      "favorite": "Add to favorites",
      "unfavorite": "Remove from favorites",
      "markRead": "Mark as read",
      "markUnread": "Mark as unread",
      "select": "Select conversations",
      "archive": "Archive"
    },
    "openOrderError": "The order couldn't be opened. Please try again.",
    "downloadNotSynced": "This attachment isn't available yet — the message is still syncing with your mail provider. Try again in a minute.",
    "attachment": {
      "openNamed": "Open {{name}}",
      "downloadNamed": "Download {{name}}",
      "openError": "The file couldn't be opened. Please try again.",
      "popupBlocked": "Your browser blocked the new tab, so the file was downloaded instead. Allow pop-ups for this site to open files in a tab."
    }
  },
  "campaign": {
    "close": "Close",
    "sms": {
      "title": "New SMS campaign"
    },
    "email": {
      "title": "New email campaign"
    },
    "name": {
      "label": "Campaign",
      "rename": "Rename",
      "save": "Save",
      "placeholder": "Campaign name",
      "editLabel": "Campaign name"
    },
    "section": {
      "audience": "AUDIENCE",
      "message": "MESSAGE",
      "delivery": "DELIVERY"
    },
    "audience": {
      "editSelection": "Edit selection",
      "review": "Review",
      "viewRemoved": "View {{count}} removed",
      "recipients": "{{count}} recipients",
      "ofSelected": "of {{count}} selected",
      "fromFilter": "From filter",
      "removedSummary": "{{count}} removed  ·  {{breakdown}}"
    },
    "message": {
      "from": "From",
      "fromPlaceholder": "Select number",
      "noNumbers": "No numbers available",
      "noTemplates": "No templates",
      "templatePlaceholder": "Choose a template",
      "previewAndTest": "Preview & test send",
      "subject": "Subject",
      "subjectPlaceholder": "Subject line",
      "preview": "Preview",
      "previewPlaceholder": "Preview text",
      "smsPlaceholder": "Type your message...",
      "emailPlaceholder": "Write your message...",
      "counter": "{{chars}} characters  ·  {{segments}} segments each",
      "counterTotal": "{{recipients}} × {{segments}} = {{total}} SMS total"
    },
    "delivery": {
      "sendRate": "Send rate",
      "start": "Start",
      "now": "Now",
      "schedule": "Schedule",
      "finishes": "Finishes ≈ {{time}}",
      "scheduledFor": "Starts {{when}}",
      "rate": {
        "smsSteady": "Steady · 1 / 6 sec",
        "smsFast": "Fast · 1 / 2 sec",
        "emailNatural": "Natural · 20 / hr",
        "emailSteady": "Steady · 60 / hr",
        "emailFast": "Fast · 100 / hr"
      },
      "quietHours": {
        "on": "Quiet hours on",
        "off": "Quiet hours off",
        "description": "Nothing sends before 8:00 AM or after 9:00 PM in the recipient’s timezone."
      },
      "businessHours": {
        "on": "Business hours only",
        "off": "Any hour",
        "description": "Sends 8:00 AM – 6:00 PM in the recipient’s timezone. Overflow rolls to the next business day."
      },
      "smsNote": "Steady pacing keeps carriers from filtering your number. Recipients can reply STOP to opt out at any time.",
      "emailNote": "Steady pacing protects your sender reputation. Your unsubscribe link and mailing address are added automatically, as required by CAN-SPAM."
    },
    "footer": {
      "cancel": "Cancel",
      "reviewAndStart": "Review & start",
      "sms": "{{count}} will receive  ·  {{total}} SMS",
      "smsDetail": "{{chars}} characters  ·  {{segments}} segments each",
      "email": "{{count}} will receive  ·  {{total}} emails"
    },
    "removed": {
      "title": "Removed from this campaign",
      "willReceive": "{{count}} will receive",
      "heldBack": "{{count}} held back",
      "addableBack": "{{count}} can be added back",
      "noneAddable": "Nothing can be added back",
      "group": {
        "duplicate": "DUPLICATES  ·  {{count}}",
        "unsubscribed": "UNSUBSCRIBED  ·  {{count}}",
        "invalid": "INVALID NUMBER  ·  {{count}}",
        "bounced": "HARD BOUNCED  ·  {{count}}"
      },
      "hint": {
        "duplicate": "Included by default — one message per person",
        "unsubscribed": "Locked — replying STOP is a legal opt-out",
        "invalid": "Fix the number to include them",
        "bounced": "Correct the address to include them"
      },
      "toggle": "Include {{name}}",
      "note": "Unsubscribed contacts can never be added to a campaign.",
      "back": "Back to campaign"
    },
    "confirm": {
      "title": "Start this campaign?",
      "campaign": "Campaign",
      "recipients": "Recipients",
      "recipientsValue": "{{count}} of {{total}}",
      "messages": "Messages",
      "messagesSms": "{{total}} SMS · {{segments}} segments each",
      "messagesEmail": "{{total}} emails",
      "pacing": "Pacing",
      "starts": "Starts",
      "startsNow": "Now · finishes ≈ {{time}}",
      "warning": "Sent messages can’t be recalled. You can pause or stop the campaign at any point — anything not yet sent will be held.",
      "back": "Back",
      "start": "Start campaign"
    },
    "scheduleDialog": {
      "title": "Schedule campaign",
      "date": "Date",
      "time": "Time",
      "interpretAs": "Interpret that time as",
      "recipientLocal": "Each recipient’s local time",
      "senderLocal": "My time · {{zone}}",
      "recipientNote": "{{count}} recipients span {{zones}} timezones. Everyone gets it at {{time}} their time — the campaign runs from {{from}} to {{to}} {{zone}}.",
      "senderNote": "Everyone gets it at {{time}} {{zone}}, whatever timezone they are in.",
      "quietHours": "Respect quiet hours",
      "quietHoursDescription": "Nothing before 8:00 AM or after 9:00 PM local, even if scheduled.",
      "cancel": "Cancel",
      "confirm": "Set schedule"
    }
  },
  "mailboxConnect": {
    "title": "Mailboxes",
    "description": "Connect your work email to read, send and file mail inside TheCargo.",
    "connect": "Connect",
    "connecting": "Waiting…",
    "unavailable": "Not available on this deployment",
    "manualComingSoon": "Manual IMAP setup is coming soon",
    "noProviders": "No mail providers are set up for this workspace yet.",
    "loadFailed": "Couldn't load your mailboxes.",
    "retry": "Try again",
    "connectedTitle": "Connected mailboxes",
    "addTitle": "Add a mailbox",
    "syncing_one": "{{count}} message imported…",
    "syncing_other": "{{count}} messages imported…",
    "authError": "Reconnect needed",
    "reconnect": "Reconnect",
    "connected": "{{email}} connected",
    "connectFailed": "Couldn't start the connection. Please try again.",
    "popupBlocked": "Your browser blocked the sign-in window. Allow pop-ups for TheCargo, then try again.",
    "disconnect": "Disconnect",
    "disconnectConfirm": "Disconnect",
    "disconnecting": "Disconnecting…",
    "cancel": "Cancel",
    "disconnected": "{{email}} disconnected",
    "disconnectFailed": "Could not disconnect that mailbox.",
    "back": "Back",
    "appPassword": {
      "use": "Use an app password instead",
      "title": "Connect {{provider}} with an app password",
      "help": "An app password is a 16-character code Google generates for one app. Your account needs 2-Step Verification turned on.",
      "helpLink": "Get an app password",
      "email": "Email address",
      "emailPlaceholder": "you@gmail.com",
      "emailInvalid": "Enter a valid email address.",
      "password": "App password",
      "passwordPlaceholder": "abcd efgh ijkl mnop",
      "invalidLength": "An app password is 16 characters. Spaces are fine.",
      "failed": "Could not connect this mailbox. Check the address and app password.",
      "displayName": "Name (optional)",
      "displayNamePlaceholder": "e.g. Sales inbox",
      "connecting": "Verifying…"
    },
    "close": "Close",
    "disconnectWarning": "Stops the sync and removes this mailbox from every list."
  },
  "carrierDirectory": {
    "result": {
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "sourceFmcsa": "FMCSA",
      "sourceCd": "CD",
      "worked_one": "Worked {{count}}×",
      "worked_other": "Worked {{count}}×"
    },
    "history": {
      "workedRated_one": "Worked {{count}}× · {{rating}}",
      "workedRated_other": "Worked {{count}}× · {{rating}}"
    },
    "selected": {
      "fmcsaAuthorized": "FMCSA Authorized"
    },
    "contact": {
      "label": "Contact"
    },
    "risk": {
      "label": "Risk & Docs",
      "vehOos": "Veh OOS",
      "drvOos": "Drv OOS",
      "crashes": "Crashes"
    },
    "fmcsa": {
      "notAuthorized": "Not Authorized",
      "none": "None",
      "vsNatlAvg": "vs {{value}}% nat'l avg"
    },
    "insurance": {
      "cargo": "Cargo",
      "deductible": "Deductible",
      "by": "By"
    },
    "addCarrier": {
      "title": "Add Carrier",
      "cancel": "Cancel",
      "submit": "Add Carrier",
      "subtitle": "Search and verify across FMCSA, Central Dispatch, and Super Dispatch.",
      "yourHistoryTitle": "Your History",
      "yourHistoryOrders": "Orders",
      "yourHistoryYourRating": "Your rating",
      "selectPrompt": "Select a carrier to add",
      "toastSuccess": "Carrier added",
      "toastError": "Failed to add carrier",
      "alreadyAdded": "Already in your carriers"
    },
    "emptyState": {
      "title": "No carriers yet",
      "description": "Add your first carrier to start dispatching orders."
    }
  },
  "devices": {
    "pageTitle": "Devices",
    "pageDescription": "Everywhere your account is signed in. Sign a device out to end its session and free its slot.",
    "browserOnOs": "{{browser}} on {{os}}",
    "browserOnly": "{{browser}}",
    "osOnly": "{{os}}",
    "unknownDevice": "Unrecognized device",
    "meta": "Signed in {{when}}",
    "metaWithIp": "{{ip}} · signed in {{when}}",
    "lastActive": "Active {{when}}",
    "thisDevice": "This device",
    "signOut": "Sign out",
    "signOutOthers": "Sign out all others",
    "retry": "Try again",
    "empty": "No signed-in devices.",
    "active": {
      "title": "Signed-in devices"
    },
    "slots": {
      "unlimited": "No device limit on this account.",
      "used": "{{used}} of {{limit}} device slots in use",
      "fullHint": "Sign a device out to free a slot"
    },
    "confirmOne": {
      "title": "Sign this device out?",
      "description": "{{device}} will be signed out right away and its slot will be free.",
      "cancel": "Cancel",
      "confirm": "Sign it out"
    },
    "confirmOthers": {
      "title": "Sign out all other devices?",
      "description_one": "{{count}} other device will be signed out. This device stays signed in.",
      "description_other": "{{count}} other devices will be signed out. This device stays signed in.",
      "cancel": "Cancel",
      "confirm": "Sign them out"
    },
    "toasts": {
      "terminated": "Device signed out.",
      "terminatedOthers_one": "{{count}} other device signed out.",
      "terminatedOthers_other": "{{count}} other devices signed out.",
      "historyCleared_one": "{{count}} past session removed.",
      "historyCleared_other": "{{count}} past sessions removed."
    },
    "errors": {
      "load": "Couldn't load your devices.",
      "terminate": "Couldn't sign that device out. Please try again.",
      "clear": "Couldn't clear the history. Please try again."
    },
    "history": {
      "title": "Past sessions",
      "clear": "Clear history",
      "empty": "No past sessions yet.",
      "emptyHint": "Sessions show up here once they end.",
      "noEnd": "Expired",
      "columns": {
        "device": "Device",
        "signedIn": "Signed in",
        "ended": "Ended",
        "reason": "Reason"
      },
      "errors": {
        "load": "Couldn't load your session history."
      },
      "confirmClear": {
        "title": "Clear session history?",
        "description": "This removes the past-session records only. Devices signed in right now are not affected.",
        "cancel": "Cancel",
        "confirm": "Clear history"
      },
      "reasons": {
        "manual": "Signed out",
        "terminated": "Signed out remotely",
        "superseded": "Replaced by a new sign-in",
        "expired": "Expired",
        "password_change": "Password changed",
        "email_change": "Email changed",
        "deactivated": "Account deactivated",
        "admin_reset": "Password reset by admin",
        "user_deleted": "Account deleted",
        "unknown": "Ended"
      }
    }
  },
  "campaigns": {
    "activity": {
      "empty": "Nothing here yet.",
      "exportLog": "Export log",
      "filters": {
        "all": "All",
        "edits": "Edits",
        "failures": "Failures",
        "replies": "Replies",
        "sends": "Sends",
        "statusChanges": "Status changes",
        "unanswered": "Unanswered"
      },
      "retention": "Every change is recorded with who made it, including who answered which reply. Kept for 24 months.",
      "system": "System"
    },
    "channel": {
      "email": "Email",
      "sms": "SMS",
      "task": "Task"
    },
    "columns": {
      "booked": "Booked",
      "campaign": "Campaign",
      "lastSend": "Last send",
      "margin": "Margin",
      "owner": "Owner",
      "people": "People",
      "replies": "Replies",
      "status": "Status",
      "waitingOnUs": "Waiting on us"
    },
    "composer": {
      "cancel": "Cancel",
      "editTitle": "Step {{position}}",
      "emailFooter": "Sends multipart, with a plain-text version generated from this. One-click unsubscribe is added to the headers — required, and it keeps people off the spam button.",
      "formatNote": "Formatting only. No images, no template blocks — that is what keeps it out of Promotions.",
      "inboxPreview": "HOW IT LANDS IN THE INBOX",
      "lockedByThread": "Locked by thread",
      "messageLabel": "Step message",
      "newSubjectNote": "A new subject starts a fresh thread in their inbox. Use it when the message is a new offer, not a follow-up — a bump with a new subject reads as a second blast.",
      "noLine": "No sending line",
      "onlyIf": "only if {{conditions}}",
      "preview": "PREVIEW",
      "previewText": "Preview text",
      "rate": {
        "fast": "Fast · 100 / min",
        "natural": "Natural · 20 / min",
        "steady": "Steady · 60 / min"
      },
      "save": "Save step",
      "saveChanges": "Save changes",
      "scheduleDate": "Pick a date",
      "scheduleNote": "Holds this step until then. The step delay still applies — whichever comes later wins.",
      "scheduleTime": "Time",
      "sendAs": "Send as",
      "sendAsOption": {
        "newSubject": "New subject line",
        "thread": "Reply in the step 1 thread"
      },
      "sendRate": "Send rate",
      "sendsFrom": "SENDS FROM",
      "smsCounter_one": "{{chars}} characters · {{count}} segment · {{encoding}}, no emoji",
      "smsCounter_other": "{{chars}} characters · {{count}} segments · {{encoding}}, no emoji",
      "start": "Start",
      "startOption": {
        "now": "Now",
        "schedule": "Schedule"
      },
      "stopNotice": "“Reply STOP to opt out” is added automatically on the first message to a new number. You cannot remove it.",
      "subject": "Subject",
      "subjectHint": "Keep the subject under about 60 characters or phones cut it off. Preview text is the grey line beside it — leave it empty and the inbox shows the first line of the email instead.",
      "task": {
        "assignee": "Assign to",
        "due": "Due",
        "dueHint": "days after the step runs. Leave blank for no date.",
        "duePlaceholder": "—",
        "kind": "Kind",
        "ownAgent": "The quote's own agent",
        "title": "Task",
        "titlePlaceholder": "Call about the Denver quote",
        "type": {
          "call": "Call",
          "email": "Email",
          "todo": "To-do"
        }
      },
      "templatePlaceholder": "Start from a template",
      "threadNote": "Keeping the thread means no new subject line. It reads as a person following up, not a new blast.",
      "threadSubject": "Re: {{subject}}",
      "threadSubjectPending": "Inherits the subject of step 1",
      "title": "New step {{position}}",
      "wait": "Wait",
      "waitDays_one": "+{{count}} day",
      "waitDays_other": "+{{count}} days",
      "waitHours_one": "+{{count}} hour",
      "waitHours_other": "+{{count}} hours",
      "waitMinutes_one": "+{{count}} minute",
      "waitMinutes_other": "+{{count}} minutes",
      "waitNote": "Counted from the previous step — from enrolment for step 1."
    },
    "contact": {
      "columns": {
        "contact": "Contact",
        "lastActivity": "Last activity",
        "outcome": "Outcome",
        "quote": "Quote / order",
        "step": "Step",
        "tariff": "Tariff"
      },
      "filters": {
        "all": "All",
        "booked": "Booked",
        "failed": "Failed",
        "heldByCap": "Held by cap",
        "inSequence": "In sequence",
        "noResponse": "No response",
        "optedOut": "Opted out",
        "replied": "Replied",
        "waiting": "Waiting on us"
      },
      "quoteNotFound": "Couldn't find quote {{code}}",
      "rowActions": "More actions for {{name}}",
      "rowMenu": {
        "addToAnotherSequence": "Add to another sequence",
        "assignToAgent": "Assign to an agent",
        "createTask": "Create task",
        "openInPhone": "Open in Phone",
        "removeFromSequence": "Remove from sequence"
      },
      "search": "Search people",
      "selection": {
        "actions": {
          "addToAnotherSequence": "Add to another sequence",
          "assignToAgent": "Assign to an agent",
          "createTasks": "Create tasks",
          "export": "Export",
          "openInPhone": "Open in Phone",
          "removeFromSequence": "Remove from sequence"
        },
        "clear": "Clear",
        "count_one": "{{count}} person selected",
        "count_other": "{{count}} people selected"
      },
      "toasts": {
        "assigned_one": "{{count}} person reassigned",
        "assigned_other": "{{count}} people reassigned",
        "removed_one": "{{count}} person removed from the sequence",
        "removed_other": "{{count}} people removed from the sequence",
        "tasksCreated_one": "{{count}} task created",
        "tasksCreated_other": "{{count}} tasks created",
        "tasksFailed_one": "{{count}} refused by the shipment service",
        "tasksFailed_other": "{{count}} refused by the shipment service",
        "tasksSkipped_one": "{{count}} skipped (no quote to attach it to)",
        "tasksSkipped_other": "{{count}} skipped (no quote to attach them to)"
      }
    },
    "delete": {
      "body": "“{{name}}” and everyone enrolled in it come off the list, along with its send history. Nothing further will be sent.",
      "cancel": "Cancel",
      "confirm": "Delete campaign",
      "title": "Delete this campaign?"
    },
    "detail": {
      "actionError": "That did not go through. Try again.",
      "actions": {
        "addStep": "Add step",
        "change": "change",
        "duplicate": "Duplicate",
        "edit": "Edit",
        "pause": "Pause",
        "resume": "Resume",
        "reviewReplies": "Review replies",
        "seeAllBounces": "See all bounces",
        "seeAllFailures": "See all failures",
        "start": "Start",
        "startPowerDialing": "Start Power Dialing"
      },
      "attribution": {
        "hint": "A booked order counts as this campaign's if it lands within:",
        "option_one": "{{count}} day of a send",
        "option_other": "{{count}} days of a send",
        "saved": "Attribution window updated — figures recalculated"
      },
      "backToList": "All campaigns",
      "deliverability": {
        "count_one": "{{count}} person",
        "count_other": "{{count}} people",
        "empty": "Nothing has bounced or failed.",
        "title": {
          "bounced": "Bounced addresses",
          "failed": "Failed sends"
        }
      },
      "engagement": {
        "clicked": "Clicked",
        "opened": "Opened",
        "quotePage": "Reached the quote page",
        "timeToClick": "Median time to click"
      },
      "loadError": "This campaign could not be loaded.",
      "pending": {
        "description": "This tab is still being designed.",
        "title": "Not built yet"
      },
      "performance": {
        "bookedOrders": "Booked orders",
        "costPerBooked": "Cost per booked order",
        "marginBooked": "Margin booked",
        "replies": "Replies",
        "unsubscribed": "Unsubscribed",
        "waitingOnUs": "Waiting on us"
      },
      "retry": "Try again",
      "sections": {
        "cost": "COST & COMPLIANCE",
        "emailDeliverability": "DELIVERABILITY — EMAIL STEPS",
        "emailEngagement": "EMAIL ENGAGEMENT",
        "performance": "PERFORMANCE — IS IT WORKING",
        "placement": "WHERE PEOPLE ARE NOW",
        "replyTiming": "WHEN REPLIES ARRIVED",
        "smsDelivery": "DELIVERY — SMS STEPS",
        "strategy": "STRATEGY — WHO AND WHY",
        "tactic": "TACTIC — WHAT EACH TOUCH EARNS"
      },
      "step": {
        "barLegend": "Bar width is how many people the step reached",
        "booked": "Booked",
        "costPerBooking": "Cost / booking",
        "margin": "Margin",
        "replied": "Replied",
        "title": "Step {{position}}"
      },
      "strategy": {
        "agents": "Agents: {{value}}",
        "sources": "Sources: {{value}}",
        "trigger": "Trigger: {{value}}"
      },
      "tabs": {
        "activity": "Activity",
        "contact": "Contact",
        "overview": "Overview",
        "sequence": "Sequence"
      },
      "toasts": {
        "deleted": "Campaign deleted",
        "duplicated": "Campaign duplicated",
        "paused": "Campaign paused",
        "started": "Campaign started",
        "stopped": "Campaign stopped"
      },
      "waiting": {
        "label": "WAITING ON US"
      }
    },
    "kind": {
      "automation": "Automation",
      "broadcast": "Broadcast",
      "sequence": "Sequence"
    },
    "modal": {
      "add": {
        "description_one": "{{count}} selected. Duplicates and anyone already in the destination sequence are dropped automatically.",
        "description_other": "{{count}} selected. Duplicates and anyone already in the destination sequence are dropped automatically.",
        "destinationLabel": "WHERE DO THEY GO",
        "existing": {
          "description": "They join at step 1 of a campaign that is already running.",
          "placeholder": "Pick a campaign",
          "title": "An existing campaign"
        },
        "keepAdding": {
          "description": "A trigger enrols people from now on. Step 1 timing sets the delay.",
          "title": "Keep adding automatically"
        },
        "new": {
          "description": "Name it, then build the sequence. Nothing sends until you start it.",
          "title": "A new campaign"
        },
        "notes": {
          "skipOnly": "Everyone joins. A step only skips the people it cannot legally reach — nobody is dropped from the sequence."
        },
        "onlyThese": {
          "description": "A one-time add. Nobody else joins unless you add them.",
          "title_one": "Only this {{count}}",
          "title_other": "Only these {{count}}"
        },
        "submit_one": "Add {{count}} person",
        "submit_other": "Add {{count}} people",
        "summaryLabel": "OF THE {{count}} SELECTED",
        "title_one": "Add {{count}} person to a campaign",
        "title_other": "Add {{count}} people to a campaign",
        "toasts": {
          "added": "{{count}} added to the sequence"
        }
      },
      "assign": {
        "agentLabel": "Agent",
        "agentPlaceholder": "Pick an agent",
        "description": "The remaining steps go out under this agent's name and lines. Nothing already sent changes.",
        "submit_one": "Assign {{count}} person",
        "submit_other": "Assign {{count}} people",
        "title_one": "Assign {{count}} person to an agent",
        "title_other": "Assign {{count}} people to an agent"
      },
      "audience": {
        "alreadyEnrolled": "{{count}} are already on this campaign.",
        "capped": "The channel counts are sampled from the first few thousand; the total is exact.",
        "headline": "{{people}} people · {{email}} with email · {{mobile}} with a mobile · {{callable}} callable",
        "inOtherCampaign": "{{count}} of the {{total}} are already in another campaign — the frequency cap holds them."
      },
      "cancel": "Cancel",
      "channelNote": "You pick channels when you add steps.",
      "edit": {
        "description": "Who this campaign runs for and who it enrols. People already in the sequence stay in it.",
        "filter": {
          "description": "The filter keeps enrolling people over time.",
          "title": "Everyone who matches a filter"
        },
        "joinLabel": "WHO JOINS",
        "manual": {
          "description": "People join only when someone adds them. This cannot be changed after the campaign is created.",
          "title": "Added by hand"
        },
        "submit": "Save audience",
        "title": "Edit audience",
        "toasts": {
          "saved": "Audience saved"
        },
        "trigger": {
          "description": "People join when the event happens on their quote.",
          "title": "A trigger fires"
        }
      },
      "join": {
        "allSources": "All sources",
        "filter": {
          "add": "+ Add filter",
          "apply": "Apply",
          "chipLabel": "Filter",
          "customDays": "Days",
          "days_one": "{{count}} day",
          "days_other": "{{count}} days",
          "description": "Rolling — anyone who newly matches joins at step 1, so it never needs recreating.",
          "noOptions": "Nothing to choose from yet.",
          "none": "Every available filter is already set.",
          "pickField": "ADD A FILTER",
          "title": "Everyone who matches a filter"
        },
        "label": "HOW PEOPLE JOIN",
        "manual": {
          "description": "Add people later from the Quote list or in bulk. Nobody joins on their own.",
          "title": "I pick them myself"
        },
        "pickSources": "Pick sources",
        "pickSourcesPlaceholder": "Choose sources",
        "sources": "Sources",
        "sourcesNote": "Lead vendor, quote page, dealer portal, phone-in — all of them unless you narrow it.",
        "trigger": {
          "description": "Something happens in the system and they join. Step 1 timing sets the delay.",
          "title": "A trigger fires"
        },
        "triggerLabel": "Trigger",
        "triggers": {
          "delivered": "Delivered",
          "dispatched": "Dispatched",
          "noOrder60d": "No order 60d",
          "whenQuoted": "When quoted"
        }
      },
      "new": {
        "description": "Name it, say who it belongs to, and how people join. Nothing sends until you add steps and start it.",
        "nameHint": "Agents see this name on the quote and order pages. Name it after who is in it, not what it sends.",
        "nameLabel": "NAME",
        "namePlaceholder": "Cold quote follow-up — August",
        "notes": {
          "skipOnly": "A step only skips the people it cannot legally reach — nobody is dropped. The frequency cap still holds anyone already in another campaign."
        },
        "previewLabel": "WHO THIS WOULD HAVE CAUGHT LAST MONTH",
        "submit": "Create and add steps",
        "title": "New campaign"
      },
      "scope": {
        "allUsers": "All users",
        "justMe": {
          "description": "Yours to edit and stop. It only touches people you add.",
          "title": "Just me"
        },
        "label": "WHO IT BELONGS TO",
        "organization": {
          "description": "Runs for the whole company. Only admins can edit or stop it — you are an admin.",
          "title": "Organization"
        },
        "pickUsers": "Pick users",
        "pickUsersPlaceholder": "Choose the agents it runs for",
        "runsFor": "Runs for"
      },
      "tasks": {
        "dateLabel": "Due",
        "datePlaceholder": "No due date",
        "description": "One task per person, attached to their quote. Anyone without a quote is skipped.",
        "submit_one": "Create {{count}} task",
        "submit_other": "Create {{count}} tasks",
        "titleLabel": "Task",
        "titlePlaceholder": "e.g. Follow up on the quote",
        "title_one": "Create a task for {{count}} person",
        "title_other": "Create tasks for {{count}} people",
        "typeLabel": "Type",
        "types": {
          "call": "Call",
          "email": "Email",
          "todo": "To-do"
        }
      }
    },
    "noAccess": {
      "description": "Your role doesn't include campaigns. Ask an admin to turn it on under Admin → Roles.",
      "title": "You don't have access to Campaigns"
    },
    "powerDial": {
      "chooseAria": "Choose who to call",
      "error": "Couldn't start the dialer",
      "menuLabel": "Who to call",
      "menuNote": "Only people with a mobile and a quote are called — up to 500 per run. Adds to a dialer that is already running.",
      "nobody": "Nobody here has both a mobile number and a quote to call about"
    },
    "rowActions": "More actions for {{name}}",
    "rowMenu": {
      "delete": "Delete",
      "deleteBlocked": "Stop the campaign first",
      "duplicate": "Duplicate",
      "edit": "Edit",
      "pause": "Pause",
      "resume": "Resume",
      "start": "Start",
      "stop": "Stop"
    },
    "sequence": {
      "actions": {
        "activate": "Activate",
        "deactivate": "Deactivate",
        "delete": "Delete step",
        "edit": "Edit",
        "editStep": "Edit step",
        "more": "More actions for step {{position}}",
        "moveDown": "Move down",
        "moveUp": "Move up",
        "openInbox": "Open inbox"
      },
      "addStep": {
        "alwaysSend": "always send",
        "cancel": "Cancel",
        "channelHint": {
          "email": "Room to explain. Use it when the answer needs detail.",
          "sms": "Short, read in minutes. Use it when you want an answer today.",
          "task": "Work for an agent, not a message. Use it when the next move is a person."
        },
        "condition": {
          "noBooking": "no booking",
          "noClick": "no click",
          "noReply": "no reply"
        },
        "customUnsupported": "Pick one of the preset delays — a custom delay is not available yet.",
        "delay": {
          "custom": "Custom",
          "immediately": "Immediately",
          "oneDay": "+1 day",
          "sevenDays": "+7 days",
          "threeDays": "+3 days",
          "twoDays": "+2 days"
        },
        "intro": "ADD A STEP — pick the channel, then say when it fires. Cost goes up as you go right.",
        "onlyIf": "Only if",
        "open": "+ Add a step",
        "openHint": "Email, SMS, or a task for an agent",
        "resolvedNote": "Counted from the previous step, not from enrolment. With business hours and skip weekends on, a step due Saturday 4:12 PM sends Monday around 8:00 AM.",
        "when": "When",
        "write": "Write the message"
      },
      "messageLabel": "Step {{position}} message",
      "sections": {
        "coverage": "CHANNEL COVERAGE & CONSENT",
        "exitRules": "EXIT RULES — WHO LEAVES AND WHY",
        "replyHandling": "REPLY HANDLING",
        "sendingWindow": "SENDING WINDOW"
      },
      "stats": {
        "booked": "booked",
        "clicked": "clicked",
        "delivered": "delivered",
        "margin": "margin",
        "queued": "queued",
        "replies": "replies",
        "sent": "sent"
      },
      "subject": "Subject",
      "taskTitle": "Task",
      "toasts": {
        "stepActivated": "Step activated",
        "stepAdded": "Step added to the sequence",
        "stepDeactivated": "Step deactivated — it keeps its history but sends no more",
        "stepDeleted": "Step deleted",
        "stepMoved": "Step moved",
        "stepSaved": "Step saved"
      }
    },
    "status": {
      "draft": "Draft",
      "finished": "Finished",
      "paused": "Paused",
      "running": "Running",
      "scheduled": "Scheduled",
      "stopped": "Stopped"
    },
    "summary": {
      "booked": "Booked",
      "margin": "Margin",
      "runningNow": "Running now",
      "sendLimits": "Send limits",
      "waitingOnUs": "Waiting on us"
    },
    "tabs": {
      "all": "All",
      "drafts": "Drafts",
      "finished": "Finished",
      "mine": "Mine",
      "organization": "Organization",
      "running": "Running",
      "scheduled": "Scheduled"
    },
    "toolbar": {
      "newCampaign": "New campaign",
      "search": "Search campaign"
    }
  },
  "timezone": {
    "placeholder": "Search timezones",
    "noMatches": "No timezone matches that"
  }
}
